var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _pes, _liveVitalStats, _offline;

var mobile = {
  "nav": {
    "today": "Status",
    "history": "Energie",
    "layout": "Modulfeld",
    "menu": "Menü"
  },
  "button": {
    "cancel": "Abbrechen",
    "done": "Fertig",
    "login": "Anmelden",
    "today": "Heute",
    "submit": "Absenden",
    "ok": "in Ordnung",
    "choose_file": "Bestand auswählen",
    "refresh": "Aktualisieren",
    "send": "Senden",
    "skip": "Überspringen",
    "clickHere": "klicken Sie hier",
    "confirm": "Bestätigen",
    "reset": "Zurücksetzen",
    "edit": "Bearbeiten",
    "update": "Aktualisieren",
    "next": "Nächster",
    "save": "Speichern",
    "no": "Nein",
    "yes": "Ja",
    "enable": "Aktivieren",
    "setNow": "Jetzt einstellen",
    "gotIt": "Verstanden",
    "okGotIt": "Okay, verstanden",
    "continue": "Fortfahren",
    "knowMore": "Erfahren Sie mehr",
    "noExportCredit": "Ich bekomme keinen Exportkredit",
    "tryLater": "Versuche es später",
    "otherNetworks": "Andere Netzwerke"
  },
  "form": {
    "topic": "Thema",
    "contactSupport": {
      "success": {
        "message": "Vielen Dank für Ihre Kontaktaufnahme.",
        "description": "Wir bemühen uns, Ihr Problem so schnell wie möglich zu lösen. Ein Enphase-Spezialist wird Sie so schnell wie möglich kontaktieren.",
        "email_notify": "Der Bericht wird in Kürze an %{email} geschickt."
      },
      "error": {
        "message": "Nachricht konnte nicht gesendet werden.",
        "description": "Bitte versuche es erneut.",
        "reset_password": "Das Passwort ist abgelaufen. Bitte setzen Sie das Passwort zurück."
      }
    },
    "default": {
      "success": "Erfolgreich gespeichert",
      "error": "Bitte versuchen Sie es erneut",
      "pleaseEnterAValue": "Bitte einen Wert eingeben",
      "permissionDenied": "Erlaubnis verweigert",
      "activeBatteryProfile": "Sie haben eine aktive Batterieprofilanfrage. Bitte warten Sie auf eine Bestätigung oder stornieren Sie die Anfrage, um fortzufahren."
    },
    "search": "Suchen"
  },
  "common": {
    "please": "Bitte",
    "contactSupport": "kontaktieren Sie den Support",
    "forHelp": "für Hilfe.",
    "videos": "Videos",
    "articles": "Artikeln",
    "new": "Neu",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "clearedDate": "Verrechnetes Datum",
    "startTime": "Startzeit",
    "endTime": "Endzeit",
    "duration": "Dauer"
  },
  "errors": {
    "error": "Fehler",
    "errors": "Fehler",
    "retry": "Erneut versuchen",
    "warning": "Warning",
    "email": "Geben Sie Ihre E-Mail-Adresse ein",
    "password": "Geben Sie Ihr Kennwort ein",
    "login": "Die eingegebene E-Mail-Adresse und das Kennwort stimmen nicht mit unseren Unterlagen überein",
    "accInactive": "Konto ist inaktiv. Bitte wenden Sie sich an Ihren Installateur und versuchen Sie es erneut, sobald Ihr System vollständig aktiv ist.",
    "expired": "Ihre Anmeldung ist leider abgelaufen.",
    "loggedout": "Sie wurden abgemeldet.",
    "report": "Entschuldigung! Ein Fehler ist aufgetreten.",
    "offline": "Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    "noInternet": "Kein Internet",
    "message": "Nachricht",
    "tryagain": "Versuchen Sie es erneut.",
    "resetNow": "Jetzt zurücksetzen",
    "resetPassword": "Ihr Passwort ist abgelaufen. Bitte setzen Sie es zurück, um den Bericht anzuzeigen.",
    "validEmail": "Bitte geben Sie eine gültige Email Adresse an",
    "validPhone": "Bitte geben Sie eine gültige Telefonnummer ein",
    "fileError": "Das Firmenlogo muss zwischen 0,05 KB und 4 MB groß sein.",
    "400": "Fehlerhafte Anfrage",
    "401": "Unbefugter Zugang",
    "403": "Zugang verboten",
    "404": "Ressource nicht gefunden",
    "422": "Nicht verarbeitbare Einheit",
    "500": "Interner Serverfehler.",
    "502": "Fehlerhaftes Gateway.",
    "503": "Dienst nicht verfügbar.",
    "504": "Gateway-Zeitüberschreitung.",
    "default": "Serverfehler.",
    "400_text": "Fehlerhafte Anfrage",
    "401_text": "Unbefugter Zugang",
    "403_text": "Zugang verboten",
    "404_text": "Ressource nicht gefunden",
    "422_text": "Nicht verarbeitbare Einheit",
    "500_text": "Interner Serverfehler. Bitte versuchen Sie es später erneut.",
    "502_text": "Fehlerhaftes Gateway. Bitte versuchen Sie es später erneut.",
    "503_text": "Dienst nicht verfügbar. Bitte versuchen Sie es später erneut.",
    "504_text": "Gateway-Zeitüberschreitung. Bitte versuchen Sie es später erneut.",
    "default_text": "Serverfehler. Bitte versuchen Sie es später erneut.",
    "noDeviceFound": "Kein Gerät gefunden",
    "noBackupHistoryFound": "Kein Sicherungsverlauf gefunden",
    "noWiFiNetworkFound": "Kein WLAN-Netzwerk gefunden",
    "noResultFound": "Keine Einträge gefunden",
    "allSites": "Alle Standorte",
    "favorites": "Favoriten",
    "changesNotSaved": "Änderungen werden nicht gespeichert",
    "wantToExit": "Möchten Sie den Vorgang ohne Speichern beenden?",
    "rateNotFound": "Prozentualer Wert wurde nicht gefunden"
  },
  "login": {
    "forgot": "Kennwort vergessen",
    "signup": "Neues Konto",
    "header": "Sich bei Enphase anmelden",
    "intro_content": "Füllen Sie Ihre E-Mail-Adresse ein. Sie erhalten umgehend eine E-Mail mit einem Link zum Zurücksetzen Ihres Passwortes.",
    "remember_me": "Daten speichern",
    "forgot_password": "Kennwort vergessen?",
    "forgot_password_success": "Wenn Sie sich bereits bei Enphase registriert haben, überprüfen Sie bitte Ihre E-Mail auf die gesendeten Anweisungen zum Zurücksetzen.",
    "caps_lock_warning": "Hochstelltaste gedrückt",
    "welcome_back": "Willkommen zurück, %{user_name}. ",
    "en_us_installer_html": "Willkommen %{user_name}. Besuchen Sie unsere <a href='http://go.enphase.com/gettingstarted' target='_blank'>Erste Schritte</a>-Website, um alle wichtigen Informationen zur Entwicklung, Installation und Bereitstellung von Enphase-Systemen zu erhalten. ",
    "en_aunz_installer_html": "Willkommen %{user_name}. Besuchen Sie unsere <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>Erste Schritte</a>-Website, um alle wichtigen Informationen zur Entwicklung, Installation und Bereitstellung von Enphase-Systemen zu erhalten. ",
    "provide_email_password": "Geben Sie einen Benutzernamen und ein Kennwort an.",
    "request_account": "Konto anfordern",
    "subheader": {
      "new_user": "Neu bei Enphase?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "Produkte von Enphase Energy können die Leistung von Solaranlagen erheblich verbessern. Durch den Einsatz von Enphase-Mikro-Wechselrichtern können Eigentümer und Betreiber die Produktivität und Zuverlässigkeit ihrer Solarinstallation erhöhen.<br/><br/>Wenn sie Enphase in Aktion erleben möchten, <a href='%{systems_list_link}'> sehen Sie sich die Installationen unserer Kunden an.</a>",
    "public_system_content_html": "Möchten Sie Enphase in Aktion erleben? <a href='%{systems_list_link}'>Öffentliche Systeme anzeigen</a>",
    "register_new_user_html": "Installieren Sie Ihr erstes Enphase-System? <a href='%{register_user_link}'>Sich bei Enphase registrieren</a>",
    "recommended_browsers": "Die Enphase App ist mit den folgenden Browsern kompatibel: Chrome 5 oder höher, Firefox 3.6 oder höher, Internet Explorer 10 oder höher, Microsoft Edge für Windows, Safari 4 oder höher. Für die Enphase App ist Adobe Flash Player 10 erforderlich.",
    "recommended_browsers_3x": "Die Enphase App ist mit den folgenden Browsern kompatibel: Chrome 44 oder höher, Firefox 41 oder höher, Internet Explorer 11, Microsoft Edge für Windows, Safari 8 oder höher.",
    "cookies_required": "Cookies müssen aktiviert sein.",
    "no_community": "Diese Community ist technischen Diskussionen unter Enphase-Installateuren gewidmet. Wir laden Sie herzlich dazu ein, an Diskussionen auf unserer <a href='https://www.facebook.com/EnphaseEnergy'>Facebook-Seite</a> teilzunehmen.",
    "required": "Sie müssen sich anmelden, um auf diese Seite zugreifen zu können",
    "findInstaller": "Einen Installateur finden",
    "sizeYourSystem": "Größe ihres systems",
    "getEnphase": "Enphase herunterladen",
    "experienceTheApp": "Erlebnis-App",
    "viewStorageSystem": "Schau Video",
    "meetEnphase": "Treffen Sie Enphase",
    "enphaseSolar": "Enphase-Solar",
    "enphaseStorage": "Enphase-Speicher"
  },
  "logout": {
    "confirm_logout": "Sie sind abgemeldet. Vielen Dank für Ihren Besuch."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Konto aktivieren",
      "link": "Aktivieren Sie nun Ihr Konto"
    },
    "header": "Zurücksetzen des Kennworts",
    "intro_content": "Vul in uw emailadres. U krijgt van Enphase een email met een link om uw wachtwoord te resetten.",
    "login": "Anmelden",
    "try_again": "Versuchen Sie es erneut.",
    "sent_message_html": "Wenn Sie bereits bei Enlighten registriert sind, sehen Sie in Ihrem Posteingang nach, ob Sie Anweisungen zum Zurücksetzen erhalten haben. <span style='color:red'>Wenn Sie die E-Mail nicht erhalten haben, sehen Sie bitte in Ihrem Junk-/Spam-Ordner nach.</span>",
    "invalid_request": "Ungültige Anforderung",
    "invalid_link": "Kennwort kann nicht zurückgesetzt werden. Link zum Zurücksetzen des Kennworts ist 7 Tage gültig. Versuchen Sie es erneut.",
    "success": "Kennwort erfolgreich zurückgesetzt.",
    "failed_password_reset": "Problem aufgetreten. Versuchen Sie es erneut.",
    "password_requirements": "Ihr Kennwort muss mindestens sechs Zeichen lang sein, mindestens eine Ziffer oder ein Sonderzeichen enthalten und darf nicht mit Ihrer E-Mail-Adresse identisch sein.",
    "note": "Kennwort ",
    "OK": "in Ordnung",
    "sent_email": "Wir haben eine E-Mail verschickt an",
    "rest_pwd": "Bitte klicken Sie auf den LInk in der E-Mail um Ihr Passwort zurückzusetzen."
  },
  "users": {
    "new": "Neue Benutzerregistrierung",
    "company_details": "Unternehmensdetails",
    "edit": "Benutzer bearbeiten",
    "site_accesses": "Systemzugang",
    "login": "Anmelden",
    "logged_in_as": "%{admin}, Sie sind angemeldet als %{user}",
    "logout_as": "Stopp",
    "reset_password": "Kennwort zurücksetzen",
    "preview_marketing_description": "Nur Vorschau. Die Änderungen wurden noch nicht gespeichert.",
    "preview_custom_welcome_message": "Nur Vorschau. Die Änderungen wurden noch nicht gespeichert.",
    "reset_password_confirm_html": "<b>Sind Sie sicher, dass das Kennwort für diesen Benutzer zurückgesetzt werden soll?</b><p>Dadurch wird der Benutzer auf \"Aktiv\" festgelegt, ein neues Kennwort generiert und eine Willkommens-E-Mail an den Benutzer gesendet.</p>",
    "reset_password_success": "Kennwort erfolgreich zurückgesetzt. Es wird eine Willkommen-E-Mail mit einer Erläuterung der Anmeldung an %{email} gesendet.",
    "reset_password_failed": "Kennwort konnte nicht zurückgesetzt werden.",
    "enlighten_manager_access": "Dieser Benutzer verfügt über Enlighten Manager mit Datenzugriff auf Modulebene.",
    "myenlighten_access_note": "(nur für Benutzer, die NICHT zu einem Unternehmen gehören)",
    "module_level_access_note": "(mit Datenzugriff auf Modulebene)",
    "complimentary_note": "HINWEIS: Die Umstellung eines Benutzers von MyEnlighten auf Enlighten Manager bedeutet, dass Sie eine Software-Aktivierung in Höhe von %{price} abgeben. Diese Transaktion wird protokolliert und der Finanzabteilung gemeldet.",
    "purchase_note": "Die Software-Aktivierung wurde am %{date} durch %{email} für einen Betrag von %{price} erworben.",
    "enlighten_version_title": "Enphase-App-Version",
    "unlock_account": "Konto entsperren",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "Ich installiere die Enphase-Produkte in meinem Wohn- oder Geschäftsgebäude selbst",
    "self_installer_false": "Ich bin ein professioneller Solarinstallateur und registriere mich im Namen meiner Firma",
    "self_register_independent": "Sonstige",
    "opt_in": "Ich erkläre mich einverstanden, Newsletter, Werbeaktionen und Umfragen zu Enphase-Produkten und Dienstleistungen zu erhalten.",
    "opt_in_info": "Sie können die Einwilligung jederzeit rückgängig machen. Weitere Informationen finden Sie in den <a href='%{privacy_url}' target='_blank'>Datenschutzrichtlinien</a> von Enphase. Sie können uns auch <a href='%{contact_url}' target='_blank'>kontaktieren</a>.",
    "personal_details": "Persönliche Informationen",
    "enable_camera": "Aktivieren Sie den Zugriff auf die Kamera für Ihre App über die Registerkarte Einstellungen",
    "dont_allow": "Nicht zulassen",
    "cameraText": "Auf diese Weise können Sie das Bild auswählen, das Sie als Firmenlogo hochladen möchten."
  },
  "company": {
    "id": "Unternehmens-ID",
    "active_users": "Aktive Benutzer",
    "address1": "Straße",
    "optional": "Wahlweise",
    "address2": "Straße 2",
    "address_id": "Standort",
    "branch_name": "Zweigstellenname",
    "branch_of": "Zweigstelle von",
    "city": "Stadt",
    "companies": "Zweigstellen",
    "country": "Land",
    "duplicate_of": "Ersetzen durch",
    "latitude": "Breitengrad",
    "logo_img": "Unternehmenslogo",
    "file_type_size": "Muss als JPEG, GIF oder PNG vorliegen und darf nicht größer als 4 MB sein.",
    "file_recommendation": "Wir empfehlen für optimale Ergebnisse ein quadratisches Bild mit transparentem Hintergrund und mindestens 400 x 400 Pixel.",
    "logo_img_file_size": "Unternehmenslogo",
    "logo_img_content_type": "Unternehmenslogo",
    "longitude": "Längengrad",
    "long_name": "Firmenname",
    "marketing_description": "Unternehmensbeschreibung",
    "custom_welcome_message": "Nachricht für Begrüßungs-E-Mail an Kunden",
    "show_logo_in_welcome_email": "Firmenlogo in Begrüßungs-E-Mail an Kunden anzeigen",
    "name": "Name",
    "parent": "Stammhaus",
    "phone": "Telefon",
    "role": "Rolle",
    "roles": {
      "admin": "Support/Callcenter",
      "installer": "Installateur",
      "distributor": "Distributeur",
      "third_party_owner": "Dritteigentümer"
    },
    "state": "Staat/Provinz",
    "support_email": "E-Mail-Adresse des Kundensupports",
    "support_phone": "Telefonnummer des Kundensupports",
    "timezone": "Zeitzone",
    "url": "Website-URL",
    "zip": "Postleitzahl",
    "is_installer": "Dieses Unternehmen installiert Enphase-Systeme",
    "errors": {
      "name_not_found": "Firmenname nicht gefunden"
    },
    "success": {
      "msg": "Ihr Konto wurde erstellt. In Ihrer E-Mail finden Sie Anweisungen zur Anmeldung."
    }
  },
  "forecast": {
    "nodata": "Prognostizierte Daten sind nicht verfügbar!",
    "nodata5": "Wir benötigen mindestens 5 Tage Produktionsdaten, um Produktionsdaten genau vorherzusagen.",
    "nodata10": "Wir benötigen Produktionsdaten von mindestens 5 Tagen in den letzten 15 Tagen, um Ihre Prognose anzuzeigen.",
    "apifail": "Prognosedaten können nicht angezeigt werden!",
    "apifailSub": "Aufgrund technischer Probleme zeigt Fehler bei der prognostizierten Daten.Bitte überprüfen Sie nach einiger Zeit.",
    "weatherErr": "Fehler bei der Anzeige von Vorhersagedaten wegen Nichtverfügbarkeit von Wetterdaten.",
    "weatherProdErr": "Fehler bei der Anzeige von Prognosedaten wegen Nichtverfügbarkeit von Produktions- oder Wetterdaten.",
    "genErr": "Fehler bei der Anzeige der prognostizierten Daten aufgrund technischer Probleme.",
    "envoyErr1": "Produktionsdaten sind nicht verfügbar, da Ihr Gateway nicht an die Cloud berichtet.",
    "envoyErr2": "Produktionsdaten werden nicht aktualisiert, da Ihr Gateway nicht an die Cloud berichtet.",
    "microErr1": "Fertigungsdaten sind nicht verfügbar, da keiner der Mikro-Wechselrichter meldet",
    "microErr2": "Fertigungsdaten aktualisieren nicht , da keiner der Mikro-Wechselrichter meldet",
    "accCTA": "Warum weicht Ihre tatsächliche Produktion von der Prognose ab?",
    "ctainfo": "Die Prognose ist nur eine Vorhersage, die Ihnen bei der Planung Ihres Energiebedarfs hilft. Bitte beachten Sie, dass Ihre Produktionswerte von der Prognose abweichen können.",
    "ctainfoRes": "Mögliche Gründe für Abweichungen zwischen tatsächlicher Produktion und Prognose",
    "ctainfoRes1": "Häufige Wetteränderungen in Ihrer Nähe",
    "ctainfoRes2": "Einige Ihrer Mikro-Wechselrichter melden sich nicht",
    "ctainfoRes3": "Ihr System hat sich seit mehr als einem Tag nicht gemeldet",
    "today": "Heute",
    "forecast": "Vorhersage",
    "actual": "Aktuell",
    "timeFrom": "Zeigt 0:00 Uhr",
    "actualProd": "Actual Production",
    "sunrise": "Sonnenaufgang",
    "sunset": "Sonnenuntergang",
    "clearDay": "Meistens sonnig",
    "clearNight": "Mostly clear",
    "rain": "Meistens regnerisch",
    "snow": "Meistens schneebedeckt",
    "sleet": "Meistens eisig",
    "wind": "Meistens windig",
    "fog": "Meistens neblig",
    "cloudy": "Bewölkt",
    "partlycloudy": "Teilweise bewölkt",
    "unknown": "Unknown",
    "at12": "Um 0:00 Uhr",
    "title": "Kennen Sie Ihre Produktionsprognose",
    "infoIconPopup": "Die Produktionsprognose ist die Vorhersage, wie viel Energie Ihre Module heute und in den nächsten 5 Tagen produzieren würden. Die Prognose wird basierend auf Ihrer bisherigen Energieerzeugung und der Wettervorhersage in Ihrer Region berechnet.",
    "fiveday": "5-Tages-Vorhersage",
    "tomo": "Morgen"
  },
  "user": {
    "id": "Benutzer-ID",
    "api_key": "API-Schlüssel",
    "company": "Unternehmen",
    "company_id": "Unternehmens-ID",
    "consumer": "MyEnlighten",
    "country": "Land",
    "email": "E-Mail Adresse",
    "email_confirm": "E-Mail bestätigen",
    "password": "Kennwort",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "sfdc_email": "E-Mail",
    "sfdc_subject": "Gegenstand",
    "sfdc_message": "Nachricht",
    "sfdc_siteId": "Enphase-Standort-ID",
    "created_at": "Erstellt um",
    "name": "Name",
    "updated_at": "Aktualisiert um",
    "status": "Status",
    "phone": "Telefon",
    "locale": "Bevorzugtes Gebietsschema",
    "preferred_metric": "Einheiten",
    "preferred_alert_level": "Standardwarnstufe",
    "preferred_array_builder": "Kann Modulfelder erstellen",
    "preferred_show_dashboard_help": "Einstellung für Dashboard-Hilfe",
    "preferred_new_look": "Enlighten 3.0 in der Vorschau anzeigen",
    "preferences": "Einstellungen",
    "role": "Rolle",
    "roles_mask": "Rollenmaske",
    "sales_demo": "Vertriebsdemo",
    "sees_modules": "Kann Moduldaten sehen",
    "notes": "Hinweise",
    "prefers_monthly_email": "Monatliche E-Mail abonnieren",
    "preferred_enphase_email": "Enphase-E-Mail abonnieren",
    "prefers_privacy_policy_assent": "Bedingungen der Datenschutzrichtlinie akzeptiert",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "add_user": "Benutzer hinzufügen",
    "self_installer": "Selbstinstallateur",
    "site_access_id": "Anlagen-ID",
    "user_access_id": "Benutzer-ID",
    "with_company": "Unternehmensdetails in meiner Registrierung einschließen",
    "last_login": "Letzte Anmeldung",
    "acknowledge": "Ik erken dat ik Enphase heb gelezen en ermee akkoord ga",
    "privacy_url": "Privacybeleid",
    "terms_url": "Gebruiksvoorwaarden",
    "acknowledgementHead": "Ich habe das folgende Dokument von Enphase gelesen",
    "acknowledgementBody": "Zudem habe ich das folgende Dokument gelesen und stimme ihm zu"
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Unsere Datenschutzrichtlinie wurde zum %{policy_date} geändert.",
      "link_body": "<a href='%{privacy_url}' target='_blank'>Datenschutzrichtlinie anzeigen</a>",
      "acknowledgement": "Ich bestätige, dass ich die <a href='%{privacy_url}' target='_blank'>Datenschutzrichtlinie</a> von Enphase gelesen habe und ihr zustimme.",
      "continue_button": "Fortfahren",
      "privacy_settings_button": "Zu den Datenschutzeinstellungen",
      "privacy_policy_agreement_required": "Ich bestätige, dass ich die <a target='_blank' href='%{privacy_url}'>Datenschutzrichtlinie</a>\nund die <a target='_blank' href='%{terms_url}'>Nutzungsbedingungen</a> von Enphase gelesen habe und ihnen zustimme.\n"
    }
  },
  "period": {
    "hours": "Tag",
    "days": "Monat",
    "week": "Woche",
    "months": "Jahr",
    "years": "Gesamt",
    "custom": "Benutzerdefiniert"
  },
  "jquery_validate": {
    "messages": {
      "required": "Dieses Feld ist ein Pflichtfeld."
    }
  },
  "validate": {
    "privacy_policy_accept": "Wenn Sie den Bestimmungen der Datenschutzrichtlinie und der Nutzungsbedingungen von Enphase nicht zustimmen, können Sie sich möglicherweise nicht für die Enphase-App registrieren."
  },
  "history": {
    "totals": "Gesamtmenge",
    "graph": "Startseite",
    "production": "Erzeugt",
    "consumption": "Verbraucht",
    "grid": "Netz",
    "export": "Eingespeist",
    "import": "Bezogen",
    "netExported": "Netto Eingespeist",
    "netImported": "Netto Bezogen",
    "battery": "Speicher",
    "charge": "Aufgeladen",
    "discharge": "Entladen",
    "soc": "Speicher",
    "hours": "",
    "months": "",
    "today": "Heute",
    "battery_status": "Ladezustand",
    "bulbs": "100-W-Glühbirne",
    "last_updated": "Aktualisiert",
    "power": "Leistung",
    "solar_produced": "Solar Erzeugt",
    "solar_consumed": "Sonnenenergie verbraucht",
    "saved": "Gerettet",
    "emission_saved": "CO2-Emission eingespart",
    "refrigerator": "Kühlschrank",
    "produced_today": "Heute erzeugt",
    "produced_yesterday": "Gestern erzeugt",
    "this_week": "Diese Woche",
    "last_week": "Letzte Woche",
    "this_month": "Diesen Monat",
    "last_month": "Im vergangenen Monat",
    "this_year": "Diesen Jahr",
    "last_year": "Vergangenes Jahr",
    "selected_day": "Ausgewählter Tag",
    "previous_day": "Vorheriger Tag",
    "selected_week": "Ausgewählte Woche",
    "previous_week": "Vorheriges Woche",
    "selected_month": "Ausgewählter Monat",
    "previous_month": "Vorheriger Monat",
    "selected_year": "Ausgewähltes Jahr",
    "previous_year": "Vorheriges Jahr",
    "produced_this_week": "Erzeugt diese woche",
    "produced_last_week": "Erzeugt letzte Woche",
    "produced_this_year": "Erzeugt in diesem Jahr",
    "produced_last_year": "Letztes Jahr erzeugt",
    "produced_this_month": "Erzeugt diesen Monat",
    "produced_last_month": "Erzeugt im letzten Monat",
    "produced_lifetime": "Erzeugte Lebensdauer",
    "imported-exported": "Bezogen/Eingespeist",
    "yesterday": {
      "hours": "Gestern",
      "days": "Letzter Monat",
      "months": "Letztes Jahr",
      "years": "Erzeugt"
    },
    "lastyear": {
      "hours": "Letztes Jahr",
      "days": "Letztes Jahr",
      "months": "Letztes Jahr",
      "years": "Erzeugt"
    },
    "generator": "Generator"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Wählen Sie die Datenfrequenz",
      "daily": "Täglich",
      "weekly": "Wöchentlich",
      "monthly": "Monatlich",
      "yearly": "Jährlich",
      "generateReport": "Wir benötigen die Daten von mindestens einer Woche, um den Bericht zu erstellen"
    }
  },
  "calendar": {
    "select": "Datum auswählen",
    "scale": {
      "production": "Erzeugung",
      "consumption": "Verbrauch"
    },
    "weekDays": {
      "monday": "Montag",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Freitag",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "months": {
      "january": "Januar",
      "february": "Februar",
      "march": "März",
      "april": "April",
      "may": "Mai",
      "june": "Juni",
      "july": "Juli",
      "august": "August",
      "september": "September",
      "october": "Oktober",
      "november": "November",
      "december": "Dezember",
      "jan": "Jan",
      "feb": "Feb.",
      "mar": "März",
      "apr": "Apr.",
      "jun": "Juni",
      "jul": "Juli",
      "aug": "Aug.",
      "sep": "Sept.",
      "oct": "Okt.",
      "nov": "Nov.",
      "dec": "Dez."
    },
    "time": {
      "hour": "Stunde",
      "hours": "Stunden",
      "minute": "minute",
      "minutes": "Minuten",
      "second": "Sekunde",
      "seconds": "Sekunden",
      "millisecond": "Millisekunde",
      "milliseconds": "Millisekunden",
      "day": "Tag",
      "h": "Std.",
      "min": "Min."
    }
  },
  "status": {
    "nameChangeNormal": "Normal",
    "nameChangeError": 'Fehler',
    "nameChangeWarning": 'Warnung',
    "dayTitle": "Heutiger Status",
    "dayAltTitle": "Letzter Status",
    "monthTitle": "Status dieses Monats",
    "monthAltTitle": "Neuester monatlicher Status",
    "yearTitle": "Status dieses Jahres",
    "yearAltTitle": "Neuester jährlicher Status",
    "lifetimeTitle": "Status der Gesamt",
    "lifetime": "Gesamt",
    "system_normal": "Normalbetrieb",
    "system_error": "Systemfehler",
    "energyConsumed": "Energie Verbraucht",
    "energyProduced": "Energie Erzeugt",
    "powerProduced": "Erzeugung",
    "powerConsumed": "Stromverbrauch",
    "moreDetails": "Mehr Details",
    "latest_power": "Neueste Leistung",
    "latest_power_text": "Die aktuellste Solarstromleistung ist die zuletzt gemeldete Leistungsabgabe Ihrer PV-Anlage.",
    "peak_power": "Spitzenleistung",
    "peak_power_text": "Spitzenleistung ist die maximale Leistung Ihrer PV-Anlage für den gewählten Zeitraum.",
    "addEnphaseStorage": "Enphase Batterie hinzufügen",
    "getAQuote": "Ein Angebot bekommen",
    "production": {
      "title": "Erzeugt",
      "label": "Erzeugt",
      "section": "Energieziele"
    },
    "consumption": {
      "title": "Verbrauch",
      "label": "Verbraucht",
      "section": "Energiequellen"
    },
    "grid": {
      "title": "Nettoenergie",
      "export": "Eingespeist",
      "import": "Bezogen",
      "label": "Nettoenergie mit importierten/exportierten",
      "section": "Energiequellen",
      "progressbarTitle": "Nettoenergie aus dem Netz"
    },
    "breakdown": {
      "consumption": "Startseite",
      "battery": "Speicher",
      "production": "Erzeugt",
      "grid": "Netz",
      "export": "Eingespeist",
      "import": "Bezogen",
      "soc": "Gespeichert",
      "total": "Gesamtzahl",
      "peak": "Spitzenleistung",
      "latest": "Neueste Leistung",
      "next": "Nächster Bericht"
    },
    "battery": {
      "title": "Speicher",
      "label": {
        "none": "Standby",
        "positive": "Laden",
        "negative": "Entladen"
      },
      "section": "Verfügbare Energie"
    },
    "charge": "Ladezustand",
    "stormAlertOn": "Sturmalarm: An",
    "batteryProfile": "Nutzungsstrategie",
    "batteryInfo1": "Basierend auf den letzten 24 Stunden Verbrauch (%{consumption}) Ihr Enphase-System läuft ungefähr ",
    "batteryInfo2": " ohne Netz oder Solarenergie.",
    "batteryInfoWOSolar": " ohne Netz.",
    "batteryErrorInfo": "Wir verfügen nicht über genügend Daten, um die Batterie-Backup-Zeit zu schätzen",
    "to": "bis",
    "batteryZeroErrorInfo": "Sie haben null Stunden Backup, da Ihre Batterien nicht mehr geladen sind.",
    "hours": "Stunde(n)",
    "minutes": "Minute(n)",
    "gridControls": {
      "verifyOtp": "Code verifizieren",
      "verificationCode": "Verifizierungscode",
      "offGridContent": "Sie werden die Verbindung zum Netz verlieren. Der für den Verbrauch verfügbare Strom wird eingeschränkt.",
      "tryAgainContent": "Es konnte keine Verbindung zum Gateway hergestellt werden.",
      "verifyOtpEmail": "Geben Sie den 4-stelligen Code ein, der an Ihre registrierte E-Mail-Adresse gesendet wurde.",
      "verifyOtpEmailMobile": "Geben Sie den 4-stelligen Code ein, der an Ihre registrierte E-Mail-Adresse und die Handynummer gesendet wurde.",
      "verifyOtpUpdateMobile": "Es wird ein 4-stelliger Code an Ihre registrierte E-Mail-Adresse gesendet.",
      "onGridContent": "Wollen Sie Ihr System jetzt wieder mit dem Netz verbinden?",
      "pleaseTryAgain": "Bitte versuchen Sie es noch einmal",
      "enterValidOtp": "Geben Sie einen gültigen Code ein.",
      "didntReceiveOtp": "Sie haben den Code nicht erhalten?",
      "goOffGrid": "Off Netz gehen",
      "goOnGrid": "On Netz gehen",
      "tryAgain": "Erneut versuchen",
      "resend": "Erneut senden",
      "alert": "Der Zugriff auf die Netzsteuerung ist deaktiviert, da ein Update für Ihr System ausgeführt wird. Dieses Update kann bis zu 24 Stunden dauern. Bitte warten Sie, bis das Update abgeschlossen ist.",
      "sendCode": "Code senden",
      "mobileStatus": "um den Code per SMS zu erhalten.",
      "myInfoButton": "Aktualisieren Sie Ihre Handynummer,",
      "wpc1l1": "Ihr aktueller Verbrauch ist höher als die verfügbare Solarstromproduktion. Bitte reduzieren Sie Ihren Verbrauch, um eine Systemabschaltung beim Übergang zu vermeiden.",
      "wpc1l2": "Sie können Ihre aktuelle Solarenergieproduktion und den Verbrauch der wesentlichen Lasten in %{liveStatus} anzeigen.",
      "wpc2l1": "Ihr durchschnittlicher Verbrauch in den letzten 15 Minuten ist größer als Ihre durchschnittliche Solarstromproduktion. Bitte stellen Sie sicher, dass Ihre aktuelle Solarenergieproduktion ausreicht, um Ihren Verbrauchsbedarf zu decken, um einen Systemausfall zu vermeiden, wenn Sie Netzfern sind.",
      "wpcOnGrid": "Ihr System wird derzeit über einen Generator mit Strom versorgt. Der Wechsel zu Netverbunden kann bei sehr hohem Verbrauch zu einer vorübergehenden Stromunterbrechung führen. Bitte reduzieren Sie Ihren Konsum, um diese Störung zu vermeiden.",
      "wpcOnGrid2": "Ihren aktuellen Verbrauch können Sie in %{liveStatus} einsehen."
    },
    "viewDetails": "Details anzeigen",
    "socMessageError1": "Der Gesamtspeicher ",
    "socMessageError2": " schließt die Speicherprozentsätze von ",
    "socMessageError3": " Batterie(n)",
    "socMessageThreshold": "Batterieladung ist nicht bekannt, weil keine der Batterien beim letzten Meldezyklus Daten gesendet hat"
  },
  "menu": {
    "supportHistory": "Support-Geschichte",
    "supportHistorySearch": "",
    "connectedAppliances": "Vernetzte Geräte",
    "connectedAppliancesSubtitle": "Überwachen und steuern Sie Ihre intelligenten Geräte",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Überwachen und steuern Sie Ihre Home Connect-fähigen Geräte",
    "appTutorial1": "Sie können sich jederzeit auf alle Systemtutorials zugreifen, indem Sie zu ",
    "appTutorial2": "Kennen Sie Ihr System",
    "appTutorial": "Kennen Sie Ihr System",
    "appTutorial3": "navigieren, unter",
    "appTutorial4": "System",
    "viewallsystutorial": "Alle systemtutorials anzeigen",
    "voiceAssistant": "Sprachassistent",
    "voiceAssistantSubtitle": "Aktivieren Sie die Sprachsteuerung für Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Produktionsprognose",
    "dryContactLoads": "Verbraucher",
    "generator": "Generator",
    "generatorDevice": "Generator",
    "loadControl": "Laststeuerung",
    "loadControlSubtitle": "Steuern Sie die Stromversorgung Ihrer Lasten",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Hinweise",
    "newNotices": "Hinweise",
    "reports": "Berichte",
    "exploreEnphase": "Enphase Erkunden",
    "exploreEnphaseNewMenu": "Erkunden",
    "advanceSettings": "Erweiterte Einstellungen",
    "advanceBatterySettings": "Erweiterte Einstellungen",
    "advancedBatterySettings2": "Erweiterte Einstellungen",
    "details": "Details",
    "detailSite": "ANGABEN ZUM STANDORT",
    "detailsInstaller": "ANGABEN ZUM INSTALLATEUR",
    "systemDescription": "System Beschreibung",
    "systemStatistics": "Systemstatistik",
    "settings": "Einstellungen",
    "account": "Konto",
    "support": "Support",
    "supportFaq": "FAQs",
    "emergencySupport": "Ruf uns jetzt an",
    "contactUs": "Kontaktieren Sie uns",
    "contactSupport": "Schreiben sie uns",
    "devices": "Geräte",
    "addStorage": "Speicher hinzufügen",
    "devicesOld": "Geräte",
    "configure": "Konfigurieren",
    "batteryStorage": "Batteriespeicher",
    "batteryStorageNewMenu": "Speicher",
    "connectivity": "Konnektivität",
    "connectGateway": "Konnektivität",
    "batteryReserve": "Batteriereserve",
    "expertModeEdit": "Expertenmodus",
    "eventsHistory": "Ereignisse Geschichte",
    "backupHistory": "Backup-Verlauf",
    "outageHistory": "Stromausfallhistorie",
    "event": "Ereignis",
    "events": "Ereignisse",
    "totalEvents": "Ereignisse insgesamt",
    "totalBackup": "Speicherbackup",
    "backupDuration": "Backup-Dauer",
    "hours": "Std",
    "minutes": "Protokoll",
    "siteDetails": "Angaben zum Standort",
    "envoy": "Gateway",
    "liveVitals": "Live Stats",
    "envoyNotReport": "Keine Daten vom Gateway",
    "microInverterNotReporting": "Keine Berichte von den Mikro-Wechselrichtern",
    "enpowerNotReporting": "Keine Daten vom Systemcontroller",
    "enchargeNotReporting": "Keine Daten von der Batterie",
    "enchargeError": "Batteriefehler",
    "enpowerError": "Systemcontroller-Fehler",
    "microinverters": "Mikrowechselrichter",
    "stringInverters": "String Inverter",
    "storage": "Batterie",
    "reconnectToEnvoy": "Konnektivität",
    "configureWiFi": "Wifi konfigurieren",
    "envoyInternetConnection": "So ändern Sie die Internetverbindung des Gateways",
    "enpower": "Systemcontroller",
    "theme": "Thema",
    "darkmode": "Dunkelmodus",
    "devmode": "Developer Mode",
    "appUpdate": "App-Aktualisierung",
    "wifi": "Verbindungstyp",
    "feedback": "Feedback",
    "logout": "Abmelden",
    "help": "Hilfe",
    "siteid": "Anlagen-ID",
    "visitTommorrowForReport": "Bitte schauen Sie morgen wieder vorbei. Die Enphase Cloud hat die erforderlichen Daten zum Erstellen von Berichten nicht erfasst.",
    "email_report": "E-Mail-Bericht",
    "will_send": "Wird gesendet an",
    "batterySubtitle": "Optimieren Sie Ihren Speicher nach Verbrauch und Tarif",
    "batteryEmeaSubtitle": "Optimieren Sie Ihren Speicher nach Verbrauch",
    "connectivitySubtitle": "Ändern Sie die Internetverbindung Ihres Gateways",
    "eventsHistorySubtitle": "Protokoll der wesentlichen Systemereignisse anzeigen",
    "backupHistorySubtitle": "Anzeigen des Stromausfallverlaufs",
    "accountSubtitle": "Persönliche Informationen, Sprache, Datenschutzeinstellungen",
    "wifiSubtitle": "Standardbandbreite, Meldet alle 15 Minuten Daten",
    "liveVitalsSubtitle": "Live-Vitalwerte des Systems anzeigen",
    "themeSubtitleOn": "Der Dunkelmodus ist eingeschaltet",
    "themeSubtitle": "Der Dunkelmodus ist ausgeschaltet",
    "devmodeSubtitle": "Optionen für den Entwicklermodus",
    "appUpdateSubtitle": "Versionshinweise für aktuelle Updates und Changelog",
    "appUpdateSuccessSubtitle": "Die App ist aktuell",
    "requestReplacement": "Umtausch beantragen",
    "changeShippingAddress": "Lieferadresse ändern",
    "tariffEditor": "Strompreis",
    "tariffEditorNewMenu": "Strompreis",
    "currencyConversion": "Wirtschaftlichkeit",
    "currencyConversionNewMenu": "Währung",
    "currencySubtitle": "Konvertiert Energiedaten in äquivalente Wechselkurse",
    "showCurrency": "Wirtschaftlichkeit anzeigen",
    "showCurrencySubtitle": "Aktivieren Sie diese Option, um das Conversion-Widget anzuzeigen",
    "passwordReset": "Passwort zurücksetzen",
    "tariffAdded": "Anzeigen/Bearbeiten der Strompreis Ihres Versorgungsunternehmens",
    "showCurrencySubtitleOff": "Deaktivieren, um das Währungs-Widget auszublenden",
    "tariffNotAdded": "Die Struktur der Strompreis wird nicht hinzugefügt",
    "enlightenManager": "In Enlighten Manager anzeigen",
    "sgipIncentive": "Speicheranreiz (SGIP)",
    "gridServices": "Grid Services",
    "enphaseHome": "Gerade erst in ein Haus gezogen, das Enphase besitzt",
    "systemAccess": "Alles eingerichtet, aber Systemzugang erforderlich",
    "woSiteSystemAccess": "Systemzugang",
    "enphaseProducts": "Erfahren Sie mehr über Enphase Produkte",
    "enphaseTeam": "Erhalten Sie Hilfe vom Enphase-Team",
    "gridSwitch": "Netzsteuerung",
    "onGrid": "On Netz",
    "chatWithUs": "chatte mit uns",
    "referFriends": "Freunde empfehlen",
    "referralTnC": "Geschäftsbedingungen",
    "hello": "Hallo",
    "homeControls": "Home Controls",
    "systemDetails": "System",
    "pesDetails": "System",
    "community": "Gemeinschaft",
    "settingsMenu": "Einstellungen",
    "enphaseStore": "Enphase Store",
    "upgrades": "Upgrades",
    "services": "Dienste",
    "generatorSubtitle2": "Konfigurieren Sie Ihren Generator basierend auf intelligenten Profilen",
    "devicesSubtitle": "Alle Geräte und ihren Status anzeigen",
    "siteDetailsSubtitle": "Details zur Site und zum Installationsprogramm anzeigen",
    "reportsSubtitle": "Berichte erstellen und senden",
    "appSettings": "App Einstellungen",
    "accountSettings": "Account Einstellungen",
    "addStorageSubtitle": "Fügen Sie einen Speicher hinzu, um Stromausfälle zu vermeiden",
    "addSolarPanels": "Sonnenkollektoren hinzufügen",
    "addSolarPanelsSubtitle": "Erhöhen Sie Ihren Eigenverbrauch",
    "sgipIncentiveSubtitle": "Bewerben Sie sich für SGIP-Incentive",
    "gridServicesSubtitle": "Verdienen Sie Vorteile, indem Sie das Stromnetz mit IQ Battery unterstützen",
    "incentives": "Anreize",
    "accountMenu": "Konto",
    "myInformation": "Meine Information",
    "myNotificationPreferences": "Meine Benachrichtigungen",
    "myPrivacy": "Meine Privatsphäre",
    "myAccessControl": "Meine Zugangskontrolle",
    "myInformationSubtitle": "Aktualisieren Sie persönliche und Systemdetails",
    "myNotificationPreferencesSubtitle": "Verwalten sie meine benachrichtigungen",
    "myPrivacySubtitle": "Steuern Sie, wie Enphase Systeminformationen verwendet",
    "myAccessControlSubtitle": "Verwalten Sie den Zugriff auf Systemdaten",
    "systemSettings": "Systemeinstellungen",
    "deviceSettings": "Geräteeinstellungen",
    "wirelessRangeExtender": "Extender für Funkreichweite",
    "cacheAction": "Löschen Sie den lokalen Cache",
    "cacheResult": "Browser-Energiedaten gelöscht",
    "noActiveNotices": "Es gibt keine aktiven Bewertungen für Sie",
    "appInfo": "App-Informationen",
    "whatsNew": "Neuheiten",
    "privacyPolicy": "Datenschutzrichtlinie",
    "tos": "Nutzungsbedingungen",
    "rateUs": "Bewerten Sie uns",
    "gridToggle": {
      "infoPopupTitle": "Sonnenlicht-Backup-System",
      "infoPopupContentP1": "Ihr System ist ein Sonnenlicht-Backup-System und das Umschalten auf Netzfern wird außerhalb der Sonneneinstrahlungszeit nicht empfohlen.",
      "pIt1": "Wenn das System auf Netzfern geht, werden nicht unbedingt erforderliche Verbraucher vom Strom getrennt.",
      "pIt2": "Das Gehen auf Netzfern ist nur während der Stunden möglich, in denen wichtige Lasten planmäßig im %{scheduledMode} eingeschaltet werden sollen.",
      "pIt3": "Ihr System kann in Netzfern heruntergefahren werden, wenn nicht genügend Sonnenlicht vorhanden ist.",
      "scheduledMode​": "Geplanter Modus​",
      "infoPopupContentP2": "Wenn das System auf Netzfern geht, werden Verbraucher mit Ausnahme der wesentlichen Verbraucher von der Stromquelle getrennt. Das Umschalten auf Netzfern ist außerhalb der festgelegten Zeiten nicht gestattet. Ihr System kann in Netzfern heruntergefahren werden, wenn nicht genügend Sonnenlicht vorhanden ist."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Get to know your device",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Nimm deine Kraft mit. Energiesicherheit und Power für unterwegs.",
      "enphasePESConnectDevice": "Ein Gerät verbinden",
      "enphasePESLearnMore": "Mehr erfahren",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Register your device",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Make sure your phone’s Bluetooth is turned on.",
      "registerStep1": "Anmelden / Registrieren Sie sich für ein Enphase-Konto",
      "registerStep2": "Pair your device and phone via Bluetooth​",
      "registerStep3": "Give your device a name​",
      "registerStep4": "Connect it to the Wi-Fi network​",
      "register": "Register",
      "start": "Start",
      "later": "Later",
      "fserialNumber": "Enter Serial No.",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Name Your Device",
      "enterBoxName": "Device Name",
      "connectToWiFi": "Connect your device to Wi%{nbh}Fi",
      "connectToWiFiNotice": "Select your preferred Wi-Fi network and enter password.",
      "takeFewMinutes": "This may take a few minutes",
      "connectingToWifi": "Connecting to Wi-Fi",
      "pleaseContactSupport": "Please contact support for help",
      "unableToCompleteConnect": "Unable to complete the connect",
      "incomplete": "Incomplete",
      "congratulations": "Congratulations!",
      "incorrectPasswordTryAgain": "Incorrect password. Please try again",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "is registered",
      "startMonitoring": "Start Monitoring",
      "turnOnBluetoothOnNotice": "Your mobile bluetooth seems to be switched off. Please turn it on to connect to Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy Systems Around",
      "noOjasDevicesFound": "No Portable Energy System found",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Incorrect Code",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Capturing Device Details",
      "capturedDeviceDetails": "Device details captured",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Registration Error",
      "registrationErrorNotice": "Please retry registration. If problem persist, ",
      "deviceAlreadyRegistered": "Device already registered",
      "deviceAlreadyRegisteredNotice": "Dieses tragbare Energiesystem ist bereits bei einem anderen Enphase-Konto registriert.",
      "proceed": "Proceed",
      "rename": "Rename",
      "nameAlreadyExist": "Name already exist",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Bluetooth connection eshtablished!",
      "enter4DigitCode": "Enter 4 digit code",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Resend code",
      "connWithOJASBLE": "Connect with Portable Energy System via Bluetooth",
      "noBLEDevicesFound": "No bluetooth devices found",
      "backupTime": "Backup Time",
      "timeToCharge": "Time to Charge",
      "powerSaving": "Power Saving",
      "poweredOn": "Powered On",
      "powerOn": "Power On",
      "powerOff": "Power Off",
      "close": "Schließen",
      "powerSavingHeader": "Device is Power Saving",
      "powerOnHeader": "Device is Powered On",
      "powerSavingSubHeader": "(AC output disabled)",
      "powerSavingContent": "You can remotely power on and enable AC output or shut down the device and disable all the input and output power supply.",
      "powerOnContent": "You can remotely shut down the device and disable all the input and output power supply.",
      "shuttingDown": "Shutting down in",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "Das Gerät ist nicht mit der Enphase-App verbunden!",
        "1_description": "Please ensure your device is turned on and connected to Wi-Fi. If you are nearby your device, you can pair your phone with the device using Bluetooth.",
        "1_action": "Connect using Bluetooth",
        "3_title": "Bluetooth not supported!",
        "3_description": "Bluetooth not supported in your device, please make sure device has Bluetooth and Location options.",
        "4_title": "Turn On Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Scanning for Bluetooth devices...",
        "7_title": "Bluetooth devices",
        "8_title_success": "No bluetooth devices found.",
        "8_title_error": "Problem persisted while scanning.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Eshtablish Bluetooth connection...",
        "10_title": "Enter proof of possession PIN for",
        "10_subTitle": "Proof of Possession PIN",
        "11_title": "Bluetooth connection established!",
        "11_description_1": "Bluetooth connection with your Portable Energy System:",
        "11_description_2": " is successfully eshtablished.",
        "12_title": "Bluetooth Not-Connected.",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " is failed, Please try again.",
        "13_title": "Searching for Wi-Fi networks...",
        "14_title": "Connect PES to Wi-Fi",
        "14_description": "Select your preferred Wi-Fi network and enter password.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "No Wi-Fi network found.",
        "15_title_error": "Problem persisted while scanning.",
        "15_description": "No Wi-Fi network found. Reboot your Wi-Fi router and try again.",
        "18_title_1": "Sending Wi-Fi credentials",
        "18_title_2": "Applying Wi-Fi connection",
        "18_description": "provisioned successfully,",
        "19_title": "Incomplete!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Device ID",
      "ojasSettings": {
        "profile": "Profile",
        "acPorts": "Wechselstromanschlüsse",
        "dcPorts": "Gleichstromanschlüsse",
        "on": "Eingeschaltet",
        "off": "Ausgeschaltet",
        "brightnesSettings": {
          "brightness": "Helligkeit",
          "customBrightness": "Benutzerdefinierte Helligkeit",
          "auto": "Helligkeit automatisch anpassen"
        },
        "lightSettings": {
          "light": "Licht",
          "on": "Immer an",
          "off": "Immer aus",
          "auto": "Automatisch",
          "onMsg": "Bleibt an",
          "autoMsg": "Schaltet sich ein, wenn jemand in der Nähe ist",
          "offMsg": "Bleibt aus"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Ein",
          "powerOff": "Aus",
          "powerSave": "Stromsparmodus"
        },
        "ojasModes": {
          "on": "Alle Ausgangs-Wechselstrom- und -Gleichstrom-Anschlüsse sind eingeschaltet. Lassen Sie das Gerät in diesem Modus, wenn Sie Ihre Werkzeuge oder Geräte an den Wechselstromanschluss angeschlossen haben.",
          "save": "Nur Gleichstromanschlüsse sind eingeschaltet und bereit, elektronische Geräte mit Strom zu versorgen. Dieser Modus spart Strom, da die Gleichstromanschlüsse ausgeschaltet sind.",
          "off": "Alle Eingangs- und Ausgangsstromquellen werden ausgeschaltet."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Einsparungen",
    "appTutorialPage": {
      'all-topics-empty': 'Keine Themen verfügbar',
      'videos-empty': 'Keine Videos verfügbar',
      'articles-empty': 'Keine Artikel vorhanden',
      'noResults': "Keine ergebnisse f\xFCr \"%{searchValue}\""
    }
  },
  "environmentCard": {
    "title": "Umgebung",
    "label": "Umweltbelastung",
    "rightText": "Quelle: epa.gov",
    "equivalent": "Äquivalent",
    "planted": "GEPFLANZT",
    "carbon_offset": "CO2-KOMPENSATION",
    "charged": "GELADEN",
    "trees": {
      "zero": "Bäume",
      "one": "Baum",
      "other": "Bäume"
    },
    "phone": {
      "one": "telefon",
      "other": "Telefone"
    },
    "tonne": {
      "one": "Tonne",
      "other": "Tonnen"
    },
    "lb": {
      "one": "Pfund",
      "other": "Pfund"
    },
    "ton": {
      "one": "Tonne",
      "other": "Tonnen"
    }
  },
  "connectionType": {
    "wifi": "Wlan",
    "cellular": "Zell-Modem",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Meldet Daten alle 15 Minuten",
    "reportsAt6Hrs": "Meldet Daten alle 6 Std.",
    "idle": "Leerlauf",
    "notAvailable": "Nicht verfügbar.",
    "configureWiFiSettings": "WiFi-Einstellungen konfigurieren",
    "configureWiFiSettings2": "Konfigurieren",
    "switchToWiFi": "Wechseln Sie zu Wi-Fi",
    "connectToWiFi": "Verbindung mit Wi-Fi"
  },
  "details": {
    "connection_type": "Verbindungstyp",
    "description": "Systembeschreibung",
    "installer": "Installiert von",
    "maintainer": "Systeminstandhalter",
    "micros": {
      "one": "Mikro-Wechselrichter",
      "other": "Mikro-Wechselrichter"
    },
    "acbs": {
      "one": "Speicher",
      "other": "Batterien"
    },
    "arrays": {
      "one": "Modulfeld",
      "other": "Modulfelder"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% mehr als gestern zu diesem Zeitpunkt",
    "less_yesterday": "% weniger als gestern zu diesem Zeitpunkt",
    "same_yesterday": "Etwa gleich viel wie zu diesem Zeitpunkt im letzten Monat",
    "more_last_year": "% mehr als zu diesem Zeitpunkt im letzten Jahr",
    "less_last_year": "% weniger als zu diesem Zeitpunkt im letzten Jahr",
    "same_last_year": "Etwa gleich viel wie zu diesem Zeitpunkt im letzten Jahr",
    "more_yesterday_prev": "% mehr als um diese Zeit am Vortag",
    "less_yesterday_prev": "% weniger als um diese Zeit am Vortag",
    "same_yesterday_prev": "Ungefähr dieselbe Zeit wie am Vortag um diese Zeit",
    "more_last_year_prev": "% mehr als um diese Zeit im Vorjahr",
    "less_last_year_prev": "% weniger als um diese Zeit im Vorjahr",
    "same_last_year_prev": "Ungefähr so ​​viel wie im letzten Jahr",
    "system": "System",
    "emptyArray": "Kein Anlagenlayout verfügbar",
    "storageArray": "Speicher",
    "solarArray": "Modulfeld",
    "contactInstForpersonalizedLayout": "Bitte wenden Sie sich an Ihren Installateur, wenn Sie die Darstellung der Speicheranlage personalisieren möchten.",
    "cntcInstPopP1": "Die Darstellung der Speicheranlage zeigt die in Ihrem Zuhause installierten Speichergeräte, unter anderem auch ihren Ladezustand.",
    "cntcInstPopP2": "Wenden Sie sich an Ihren Installateur, wenn Sie die Darstellung der Speicheranlage in der Anwendung Installer Tool Kit oder Enlighten Manager individuell gestalten möchten."
  },
  "support": {
    "enphase": "Enphase-Support",
    "enphaseLink": "Enphase-Support",
    "maintainer": "Systemsupport und -wartung",
    "maintainerLink": "Ansprechpartner für Wartung kontaktieren",
    "contactEnphase": "Kontaktieren Enphase",
    "enphaseSupport": "Enphase Support",
    "ensembleSupport": "Anruf Ensemble Support",
    "writeToUs": "Schreiben sie uns",
    "visitSupport": "Bezoek Ondersteuning",
    "talkToUs": "Rede mit uns",
    "talkToUsAnytime": "Sprechen Sie jederzeit mit uns",
    "customerSupport24by7": "24/7 Kundenbetreuung",
    "needHelpTitle": "Benötigen Sie Hilfe bei",
    "needMoreHelpTitle": "Brauche mehr Hilfe",
    "contactUs": "Kontaktieren Sie uns",
    "productionDifference": "Unterschied in der Produktion pro Panel",
    "productionIssue": "Produktionsfehler",
    "envoyNotReporting": "Keine Daten vom System oder Gateway",
    "askEnphaseCommunity": "Fragen Sie Enphase Community",
    "browseTopics": "Alle Hilfethemen durchsuchen",
    "chatWithUs": "chatte mit uns",
    "microinvertersNotReporting": "Mikro-Wechseltrichter berichten nicht",
    "helpTopics": "Hilfe-Themen",
    "brwsAllFaqs": "Alle FAQs durchsuchen",
    "askEnphaseCommunitySubtitle": "Wenden Sie sich an andere Enphase-Kunden in Ihrer Nähe",
    "systemOwnerGuide": "Siehe Bedienungsanleitung des Systems",
    "faq": {
      "usingManualOverride": "Verwenden der manuellen Überbrückung",
      "understandingEnpower": "Entendiendo a IQ System Controller",
      "understandingEncharge": "IQ Battery verstehen",
      "understandIQCombiner": "IQ Combiner, Gateway, Kommunikations-Kit und Mobilfunkmodem verstehen",
      "stormGaurdFeatureDetails": "Details zur Sturmschutzfunktion",
      "settingElectricityRateStructure": "Festlegen der Stromtarifstruktur",
      "recoverShutdownLL": "Wiederherstellung nach dem Herunterfahren aufgrund großer Lasten",
      "recoverShutdownCF": "Wiederherstellung nach dem Herunterfahren aufgrund eines Kommunikationsfehlers",
      "recoverShutdownBD": "Wiederherstellung nach Herunterfahren aufgrund von Akku-Entleerung",
      "PowerHomeInBCK": "Stromversorgung von Hauslasten im Backup",
      "partialHomeBCK": "Teilkonfiguration der Haussicherung",
      "monitorUrSys": "Überwachung Ihres Systems",
      "mngLgApplianceBck": "Verwalten großer Appliances in der Sicherung",
      "incentivesAvlbTou": "Ihnen zur Verfügung stehende Anreize",
      "grdTrnxToOffGrd": "Netzübergang zu netzfern",
      "allHomeBck": "Volle Konfiguration der Haussicherung",
      "envLEDstatus": "LED-Status des Gateways",
      "dsgnUrSys": "Entwerfen Ihres Systems",
      "cntctCustSupp": "Kontaktaufnahme mit dem Kunden-Support",
      "batSmrtPrfSel": "Wählen Sie das Smart-Speicher-Profil",
      "accsEnchrgDcswtch": "Zugriff auf DC-Schalter der Batterie",
      "mcrInvNtReprt": "Mikroinverter meldet nichts",
      "sysEnvNtReprt": "Keine Daten vom Gateway",
      "hwUrSysWrk": "Wie Ihr System funktioniert",
      "enchrLedStatus": "LED-Status der Batterie",
      "noPwNebDo": "Mein Zuhause hat keinen Strom aber meine Nachbarn",
      "consBatDurGridOut": "Schonen Sie die Speicher bei einem Netzausfall",
      "emgSupCallSteps": "Wählen Sie 2 für den Kundenservice und 1 für den Systembesitzer. Wählen Sie 2 im Untermenü für Speichersysteme.",
      "preLoginCallSteps": "Bitte wählen Sie 2 für den Kundensupport oder 4 für den Verkauf.",
      "sysProdIssue": "Systemproduktionsproblem",
      "diffInPerPanProd": "Produktionsunterschied pro Platte",
      "installCellModem": "Installationsanleitung für Mobilfunkmodem",
      "whatIsEI": "Energieunabhängigkeitswert",
      "howEnHomeEngSysWork": "Wie funktioniert das Enphase-Hausenergiesystem?",
      "understandEnv": "Gateway verstehen",
      "findEnv": "Meinen Gateway finden",
      "envReplaced": "Gateway wurde ersetzt",
      "rebootEnv": "Gateway wird neu gestartet oder neugestartet",
      "hwChangeEmail": "Wie ändere ich meine E-Mail?",
      "hwResetPasswd": "Wie kann ich mein Passwort zurücksetzen?",
      "accessEnvLocalIntf": "Zugriff auf die lokale Oberfläche des Gateways",
      "envLocIntfLogCred": "Anmeldedaten für die lokale Oberfläche des Gateways",
      "hwDisbaleNotification": "Wie schalte ich monatliche Berichte und andere E-Mail-Benachrichtigungen ein und aus?",
      "MontEngProd": "Verfolge meine Energieproduktion",
      "whyNotSeeConsumption": "Warum kann ich meinen Verbrauch nicht sehen?",
      "hwMonConsumpt": "Wie kann ich den Verbrauch meines Hauses überprüfen?",
      "calEngUsageWoConsumptionMonitoring": "Berechnen Sie meinen Energieverbrauch, ohne den Verbrauch zu überwachen",
      "undersNetEng": "Verstehe die Nettoenergie",
      "understTrueUpStmt": "Verstehe eine True-up Aussage",
      "diffPaidENLMvsPerpanelDataaoffering": "Unterschied zwischen dem bezahlten Enlighten Manager und dem Angebot von kostenlosen Energiedaten pro Panel",
      "blkInPerpanMon": "Schwarzes Feld in der Feldansicht",
      "gryorBlnkInPerpanMon": "Graues (leeres) Feld in der Bedienfeldansicht",
      "hwToMovePnl": "Wie bewege ich ein Panel?",
      "hwfindInst": "Wie finde ich ein neues Installationsprogramm?",
      "whtdoIfonePanelNotreproduc": "Was soll ich tun, wenn eines der Panels wenig oder gar keine Produktion hat?",
      "haveaSelfPoweredHome": "Was bedeutet es, ein autarkes Zuhause zu haben?",
      "yourSystemPaysForItself": "Wie lange dauert es, bis sich Ihr System bezahlt macht?",
      "enphaseSystemsAreSafe": "Warum Enphase-Systeme sicher sind?"
    },
    "webBackButton": "Zurück",
    "supportHistory": "Support-Geschichte"
  },
  "evse": {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data",
    "errprodcons": "Unable to suggest charging schedule because of insufficient consumption and production data",
    "addev": "Fügen Sie ein Elektrofahrzeug hinzu",
    "addevSub": "Teilen Sie uns mit, ob Sie Ihr Enphase-System zum Laden Ihres Elektrofahrzeugs verwenden, damit wir Einblicke geben und optimale Zeitpläne für das effiziente Laden Ihres Fahrzeugs empfehlen können.",
    "haveEv": "Ich habe ein Elektrofahrzeug",
    "qbrand": "Welche Marke hat Ihr Elektrofahrzeug?",
    "qbrandErr": "*The above field is mandatory",
    "qmodel": "Wie lautet der modellname Ihres Elektrofahrzeugs?",
    "diffcharger": "Ich lade mein Elektrofahrzeug zu Hause mit einem Ladegerät eines anderen Unternehmens auf",
    "qcharger": "Welche Marke hat Ihr Ladegerät?",
    "qcapacity": "Wie groß ist die Akkukapazität Ihres Elektrofahrzeugs (in kWh)?",
    "notcompulsory": "*diese Frage ist nicht obligatorisch. Wenn Sie es nicht wissen, können Sie es überspringen.",
    "qtime": "Wann laden Sie Ihr Fahrzeug auf?",
    "morning": "Morgens",
    "afternoon": "Mittags",
    "evening": "Abends",
    "night": "Über Nacht",
    "other": "Sonstiges (bitte angeben)",
    "qmiles": "Wie viele Kilometer fahren Sie normalerweise an einem Tag?",
    "brand": "Markendetails",
    "tech": "Technische Details",
    "operational": "Betriebsdetails",
    "ev": "Elektrofahrzeug:",
    "suggsch": "Empfohlener Zeitplan",
    "suggschInfo": "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate.",
    "charge": "To charge your electric vehicle",
    "weekday": "For Mon, Tue, Wed, Thur & Fri",
    "weekend": "For Sun & Sat",
    "everyday": "Everyday",
    "removeEV": "Elektrofahrzeug entfernen",
    "userfail": "Unable to display Electric Vehicle details!",
    "userfailDesc": "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."
  },
  "storage": {
    "stormGuardEnablePopUpHeader": "Storm Guard aktivieren",
    "stormGuardEnablePopUpFooter": "Möchten Sie Storm Guard aktivieren?",
    "stormGuardDisablePopUpHeader": "Storm Guard deaktivieren",
    "stormGuardDisablePopUpFooter": "Möchten Sie Storm Guard dennoch deaktivieren?",
    "backupTime": "Backup-Zeit",
    "encharge_battery": "Wählen Sie ein Smart-Profil aus, um Ihre Batterie zu steuern",
    "encharge_battery_emea": "Intelligentes Profil zur Steuerung Ihres Akkus",
    "savings": "Einsparungsmodus",
    "expert": "Expertenmodus",
    "self-consumption": "Eigenverbrauchsoptimierung",
    "battery_bkup": "Vollständiges Backup",
    "savings_text": "Verwenden Sie es, wenn Ihre Energiekosten im Laufe des Tages variieren. Der Speicher wird in den Nebenzeiten aufgeladen und in den Spitzenzeiten und nach Sonnenuntergang verwendet.",
    "savings_mode_notSet": "Maximiert die Einsparungen auf Grundlage des Stromtarifs",
    "savings_mode_dc_tou": "Die Solarmodule und die Batterie dienen zu Spitzenzeiten zur Minimierung des Stromimports aus dem Netz.",
    "savings_mode_dc_all_day": "Während der Spitzenzeiten wird Solarenergie ins Netz exportiert. Zu Hause erfolgt die Stromversorgung über die Batterie, bis die Reservekapazität erreicht ist.",
    "viewElectricityRate": "Stromtarif anzeigen",
    "optForDC": "Auf möglichst geringe Leistungspreiskosten ausgerichtet",
    "optForIncExport": "Auf Steigerung des Exports ausgerichtet",
    "consumption_text": "Verwenden Sie gespeicherte Sonnenenergie, um Ihr Haus nach Sonnenuntergang mit Strom zu versorgen. Der Speicher wird verwendet, wenn die Solaranlage keinen Strom erzeugt.",
    "consumption_text_pv_yield": "Laden Sie die Batterie während der Spitzenproduktionszeiten auf, um die PV-Produktion zu optimieren. Batterie wird verwendet, wenn Solar nicht verfügbar ist.",
    "bkup_text": "100 % der Speicher ist für das Backup reserviert.",
    "reserve": "Reserve",
    "optimization": "Optimierung basierend auf",
    "utility_rates": "Nutzungstarifen",
    "increase_consumtion": "Steigern Sie den Eigenverbrauch, um",
    "max_consumption": "den Autarkiegrad zu erhöhen",
    "optimize_pv_production": "Optimieren Sie die PV-Produktion",
    "activate": "Aktivieren",
    "active": "Aktiv",
    "save": "Speichern",
    "edit": "BEARB",
    "error": "Die Speichereinstellungen können nicht gespeichert werden.",
    "requestTakingLonger": "Die Anfrage dauert länger als erwartet. Bitte versuchen Sie es später noch einmal.",
    "batterySettingsTakingLonger": "Die Aktualisierung der Batterieeinstellung dauert länger als erwartet. Bitte versuchen Sie es später noch einmal.",
    "completed": "Akkueinstellungen erfolgreich aktualisiert.",
    "completedAdvance": "Erweiterte Akku-Einstellungen erfolgreich aktualisiert.",
    "requestPending": "Anfrage steht aus. Warten auf Bestätigung des gateways. Bitte versuchen Sie es später noch einmal.",
    "editRequest": "Sie haben eine aktive Anfrage. Bitte warten Sie auf die Bestätigung oder stornieren Sie diese Anforderung, um mit der Auswahl fortzufahren.",
    "editRequestVls": "Sie haben eine aktive Anfrage in den erweiterten Akku-Einstellungen. Bitte warten Sie auf die Bestätigung oder brechen Sie die Anfrage ab, um mit der Auswahl fortzufahren.",
    "cancelRequest": "Ihre Anfrage wurde storniert.",
    "updatedSuccesfully": "Erfolgreich geupdated",
    "pendingRequestText": "Ausstehende Anfrage",
    "cancelRequestText": "Anfrage stornieren",
    "pendingText": "Ausstehend",
    "processingText": "Wird bearbeitet",
    "battery_reserve": "der gespeicherten Energie wird für die Sicherung reserviert.",
    "cancelFailed": "Aufgabe konnte nicht abgebrochen werden.",
    "noPendingTask": "Das System hat keine ausstehende Aufgabe zum Abbrechen.",
    "noEncharges": "Das System umfasst keine Batterien",
    "severeWeatherText": "Sturmschutzfunktion",
    "disabled": "Deaktiviert",
    "enabled": "Aktiviert",
    "weatherWatchDescription": "Überschreibt Ihr Speicherprofil in den Vollsicherungsmodus, wenn für Ihren Standort eine Unwetterwarnung für Ihren Standort ausgegeben wird.",
    "disabledModeInfo": "Wenn aktiviert, kommuniziert Enphase mit dem {%s}, um Warnungen vor Unwetterereignissen zu erkennen, und stellt Ihr Akkuprofil auf den vollständigen Backup ein, um während des Ereignisses einen Backup bereitzustellen. Nach Ablauf des Ereignisses kehrt das Batterieprofil zu seiner vorherigen Einstellung zurück.",
    "enabledModeInfo": "Enphase kommuniziert mit {%s}, um Warnungen vor Unwetterereignissen zu erkennen, und stellt Ihr Akkuprofil auf den vollständigen Backup-Modus ein. Nach dem Ereignis kehrt das Batterieprofil zu seiner vorherigen Einstellung zurück.",
    "activeModeInfo": "Enphase hat eine Unwetterwarnung von {%s} erkannt und Ihr Akkuprofil ist auf den Modus Vollständiger Backup eingestellt. Nach Ablauf der Ereignisendzeit kehrt das Akkuprofil zu seiner vorherigen Einstellung zurück.",
    "stormGuardModeInfo": "Bei %{status} überwacht die Sturmschutzfunktion die von %{nws} ausgegebenen Unwetterbedingungen. Es überbrückt Ihr Speicherprofil in den Modus „Vollständiges Backup“, wenn eine Warnung für Ihren Standort ausgegeben wird. Auf diese Weise kann Ihre gesamte Speicher-Kapazität für die Verwendung während eines möglichen Netzausfalls reserviert werden.%{nl} Wenn für Ihren Standort eine Warnung ausgegeben wird, dann wird „Storm Alert: On“ auf der Statusseite unter „Batterie-Profil“ und Live-Statusseite angezeigt.%{nl} Nach Beendigung der Warnung kehrt das Speicherprofil zu seinen vorherigen Einstellungen zurück.",
    "editActiveWeatherAlert": "Storm Guard ist aktiv. Bitte warten Sie, bis das Ereignis vorbei ist (empfohlen) oder deaktivieren Sie die Unwetterüberwachung, um mit der Auswahl fortzufahren.",
    "enabledToActiveAlert": "Enphase hat eine Unwetterwarnung des nationalen Wetterdienstes erkannt und Ihr Akkuprofil wird in den Modus Vollständiger Backup versetzt. Nach Ablauf der Ereignisendzeit kehrt das Akkuprofil zu seiner vorherigen Einstellung zurück.",
    "activeToEnabledAlert": "Das Unwetterereignis ist vorbei und Ihr Batterieprofil wird auf die vorherigen Einstellungen gesetzt.",
    "okayText": "Gut, habe ich verstanden!",
    "disclaimerText": "Die Sturmschutzfunktion verwendet Informationen, die von der Nationalen Ozeanischen und Atmosphärischen Verwaltung der USA / dem nationalen Wetterdienst stammen, wie z. B. (ohne Einschränkung) Unwetterwarnungen, deren Informationen gemeinfrei sind und keinem Urheberrechtsschutz unterliegen. Enphase erhebt keinen Anspruch darauf, solche Informationen zu besitzen oder zu kontrollieren. Sie stimmen ausdrücklich zu, dass die Nutzung dieser Funktion auf Ihr eigenes Risiko erfolgt. Und Sie übernehmen das gesamte Risiko, das mit der Aktivierung dieser Funktion und der späteren Nutzung verbunden ist. Enphase stellt diese Informationen über die Sturmschutzfunktion „wie sie sind“ zur Verfügung und lehnt jegliche ausdrückliche oder stillschweigende Gewährleistung ab, einschließlich (ohne Einschränkung) stillschweigender Gewährleistungen der Marktgängigkeit oder Eignung für einen bestimmten Zweck. Enphase haftet Ihnen oder Dritten gegenüber in keinem Fall für direkte indirekte, zufällige, Folge-, Sonder- oder erweiterte Schäden oder Profitverluste, die sich aus der Verwendung oder dem Missbrauch dieser Daten ergeben.",
    "disclaimer": "Haftungsausschluss",
    "agreeText": "Einverstanden & weiter",
    "disagreeText": "Nicht einverstanden",
    "nationalWeather": "Nationaler Wetterdienst (NWS)",
    "dataNotAvailable": "NA",
    "errorTitle": "Fehler",
    "errorCode": "Fehlercode",
    "thresholdError": "Reporting Error",
    "PopupError": "SN Ihrer Batterie",
    "thresholdPopupError": "Beim letzten Meldezyklus keine Daten gesendet? Der Gesamtspeicher-Prozentsatz beinhaltet daher nicht den Speicher-Prozentsatz dieser Batterie. Die Batterie sollte ab dem nächsten Meldezyklus wieder Daten senden. Bitte wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "errorPopup1": "hat ein Problem (Fehler Des:",
    "errorPopup2": ", Fehlercode:",
    "errorPopup3": "). Aufgrund dieses Fehlerereignisses ist der für diese Batterie gemeldete Speicher-Prozentsatz nicht zuverlässig. Der oben erwähnte Gesamtspeicher-Prozentsatz beinhaltet daher nicht den Speicher-Prozentsatz dieser Batterie. Bitte wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "contactSupport": "Support kontaktieren",
    "errorSubmitButton": "Okay, verstanden",
    "microinvertorError": "Mikro-Wechselrichter der Batterie ist nicht aktiv.",
    "microinvertorsError": "Mikro-Wechselrichter der Batterie sind nicht aktiv.",
    "touAlert": "Der Sparmodus funktioniert nur, wenn Ihre Stromimportrate je nach Nutzungszeit variiert. Bitte aktualisieren Sie Ihre Stromimportrate, um diesen Modus zu aktivieren.",
    "touAlert2": "Bitte stellen Sie Ihren Stromimporttarif auf ToU und Ihren Exporttarif auf NEM ein, um den Sparmodus zu aktivieren.%{nl}Der Sparmodus funktioniert nur, wenn Sie eine Netto-Messung (NEM) haben und Ihr Stromtarif je nach Nutzungsdauer (ToU) variiert.",
    "touAlert3": "Bitte stellen Sie Ihren Strombezugstarif als ToU ein, um den Sparmodus zu aktivieren",
    "touAlert4": "Bitte stellen Sie Ihren Stromexportplan so ein, dass der Sparmodus aktiviert ist",
    "updateElectricityRate": "Strompreis aktualisieren",
    "batteryChangeAlert": "Ihr Speicherprofil wurde in den Selbstverbrauchsmodus geändert, da der Sparmodus nur dann funktioniert, wenn Ihre Stromimportrate je nach Gebrauchszeit variiert.",
    "batteryChangeAlert2": "Ihr Akkuprofil wurde in den Eigenverbrauchsmodus geändert, da der Sparmodus nur funktioniert, wenn Sie über eine Netto-Messung (NEM) verfügen und Ihr Stromtarif je nach Nutzungsdauer (ToU) variiert.",
    "viewDetails": "Details anzeigen",
    "ok": "Ok",
    "systemRequest": "Vom System generierte Anfragen können nicht storniert werden.",
    "featureDetailsButton": "Storm Guard Feature Details",
    "stormGuardEnablePopUp": "Durch die Aktivierung von Storm Guard wird Ihre gesamte Batteriekapazität für einen potentiellen Stromausfall reserviert, indem das Batterieprofil im Falle einer Unwetterwarnung außer Kraft gesetzt und auf „Vollständiges Backup“ eingestellt wird.",
    "stormGuardDisablePopUp": "Es wird nicht empfohlen, Storm Guard zu deaktivieren. Im Falle von Unwetterwarnungen schützt Storm Guard vor wetterbedingten Stromausfällen.",
    "batterySmartProfile": {
      "title": "Wählen Sie das Smart-Speicher-Profil",
      "description": "Erfahren Sie, wie Sie das richtige Profil für Ihr Batteriesystem auswählen",
      "viewDetails": "Details anzeigen"
    },
    "reserveDisclaimer": "Die Speicher-Reserve kann nicht unter  %{minSoc}% eingestellt werden. Im Speicher sind mindestens  %{minSoc}% Energie gespeichert, um Ihre kritischen Hauslasten während eines Netzausfalls mit Strom zu versorgen.",
    "eIpopDesc": "%{enabled}: Ihre Speicher wird entladen, um in Spitzenzeiten bei hohen Strompreisen Geld zu sparen. Sobald dies geschehen ist, wird der Energieunabhängigkeit Vorrang eingeräumt. Dies erhöht Ihre Energieautarkie, bis Sie die Batterieladungsladung erreicht haben. Ihr Speicher wird am Morgen mit Sonnenenergie aufgeladen, um sich auf die nächste Spitzenzeit vorzubereiten.%{nl}%{disabled}: Ihre Speicher wird nur während der Stoßzeiten entladen, wenn die Stromtarife hoch sind. Zu anderen Zeiten ist die Speicher morgens im Leerlauf oder wird mit Solarenergie aufgeladen, um sich auf die nächste Spitzenzeit vorzubereiten.",
    "errActiveCostSave": "Aktivieren Sie zur Nutzung dieser Funktion den Energiesparmodus",
    "eiDescreption": "Energieunabhängigkeit nach Spitzenzeiten",
    "advSetting": {
      "cfg": {
        "title": "Laden Sie den Akku über das Netz",
        "descrDisable": "Ihre Batterie wird durch Solar aufgeladen.",
        "descrEnabled": "Der Akku wird mit Solarenergie geladen. Es kann auch über das Stromnetz geladen werden, wenn sich die Batterie im Vollpufferbetrieb befindet oder wenn die Batterieladung im Spar- oder Eigenverbrauchsbetrieb unter die Reservekapazität fällt.",
        "descrEnabledFR": "Ihr Akku wird im geplanten Zeitplan vom Netz geladen. Es wird während dieser Zeit nicht entladen.",
        "popUpDescrFR": "%{enabled}: Ihr Akku wird im geplanten Zeitplan vom Netz geladen. Es wird während dieser Zeit nicht entladen. %{nl}%{disabled}: Ihre Batterie wird über die Solarmodule aufgeladen.",
        "popUpDescr": "%{enabled}: Der Akku wird mit Solarenergie geladen. Es kann auch über das Stromnetz geladen werden, wenn sich die Batterie im Vollpufferbetrieb befindet oder wenn die Batterieladung im Spar- oder Eigenverbrauchsbetrieb unter die Reservekapazität fällt.%{nl}%{disabled}: Ihre Batterie wird durch Solar aufgeladen.",
        "disclaimer": "Die Verwendung einer nicht erneuerbaren Energiequelle zum Aufladen Ihres Enphase-Speichersystems kann Ihre Berechtigung zur Inanspruchnahme des ITC beeinträchtigen. Bitte wenden Sie sich für weitere Informationen an Ihren Steuerberater.​",
        "dlgTitle": "Vom Netz aufladen?",
        "dlgInfo": "Nach der Aktivierung wird Ihr Akku im geplanten Zeitplan vom Netz aufgeladen. Es wird während dieser Zeit nicht entladen. Bitte prüfen Sie die Vorschriften des Versorgungsunternehmens, bevor Sie diese Option aktivieren.",
        "selfDeclrFR": "Ich verstehe, dass das Aufladen über das Stromnetz möglicherweise gegen die Vorschriften des Versorgungsunternehmens verstößt.",
        "selectSchedule": "Wählen Sie den Zeitplan, um Ihren Akku aus dem Netz aufzuladen.",
        "titleFR": "Planen Sie das Aufladen aus dem Netz",
        "saveSch": "Zeitplan speichern",
        "chargeSch": "Ladeplan",
        "selfDeclr": "Mir ist bewusst, dass meine Berechtigung zur Inanspruchnahme der Investitionssteuergutschrift beeinträchtigt sein kann.",
        "disclaimer_itk": "Die Verwendung einer nicht erneuerbaren Energiequelle zur Modifikation des Enphase-Speichersystems kann die Berechtigung eines ITC-Anspruchs beeinträchtigen. Wenden Sie sich zur Genehmigung an den Eigentümer.",
        "selfDeclr_itk": "Der Eigentümer nimmt zur Kenntnis, dass die Berechtigung zur Inanspruchnahme der Investitionssteuergutschrift beeinträchtigt sein kann.",
        "activeStormAlert": "Die Sturmwarnung für Ihr System ist aktiviert. Bitte warten Sie auf das Ende der Warnung, um diese Einstellung zu aktualisieren."
      }
    },
    "exM": {
      "title": "Expertenmodus",
      "subTitle1": "Batterieprofile planen",
      "subTitle2": "Geplante Batterieprofile",
      "schedule": "Planen",
      "tariffNotSetDlgtitle": "Stromtarif Nicht Angegeben",
      "tariffNotSetDlgContent": "Bitte stellen Sie Ihren Stromtarif ein, um den Sparmodus zu aktivieren.%{nl}Enphase benötigt Ihre Tarifdetails, um den besten Zeitplan für Ihren Akku zu ermitteln.",
      "setRate": "Tarif angeben",
      "tariffUpdateDlgtitle": "Stromtarif aktualisieren",
      "tariffUpdateDlgContent": "Der Energiesparmodus kann nur genutzt werden, wenn Sie über Nettoenergiezählung (Net Energy Metering, NEM) verfügen und Ihr Stromtarif je nach Gebrauchszeit (Time-of-Use, ToU) unterschiedlich ist.",
      "updateRate": "Tarif aktualisieren",
      "setNemDlgTitle": "Kein Tarif für Stromexporte angegeben",
      "setNemDlgContent": "Um diesen Modus zu aktivieren, müssen Sie Ihren Tarif für Stromimporte als NEM festlegen.",
      "setNemCta": "Als NEM festlegen",
      "preview": "Vorschau",
      "addBatProfile": "Batterieprofile hinzufügen",
      "pViewPop": {
        "l1": "Das Diagramm zeigt die geplanten Batterieprofile für einen Zeitraum von 24 h.",
        "l2": "Die Batteriereserve gilt nur für den Eigenverbrauchs- und den Energiesparmodus. Bei vollständigem Backup ist die Batteriereserve 100%.",
        "l3": "Maximiert die Energieunabhängigkeit​",
        "l4": "Maximiert die Einsparungen auf Grundlage des Stromtarifs",
        "l5": "Hält den Ladestand der Batterie auf 100 % als Backup",
        "batteryProfiles": "Batterieprofile"
      },
      "batReserveDisclaimer": "Die Batteriereserve gilt nur für den Eigenverbrauchs- und den Energiesparmodus. Bei vollständigem Backup ist die Batteriereserve 100%."
    },
    "prfAssist": {
      "t0": "Bereits in empfohlenem Profil",
      "t1": "Wir empfehlen",
      "t2": "Energiesparmodus mit geringer Batteriereserve und aktivierter Energieunabhängigkeit.",
      "t3": "Energiesparmodus mit geringer Batteriereserve und deaktivierter Energieunabhängigkeit.",
      "t4": "Eigenverbrauchsmodus mit geringer Batteriereserve.",
      "t5": "Eigenverbrauchsmodus mit mittelgroßer Batteriereserve.",
      "t6": "Modus „Vollständiges Backup“.",
      "t7": "Energiesparmodus mit großer Batteriereserve und deaktivierter Energieunabhängigkeit.",
      "t8": "Eigenverbrauchsmodus mit großer Batteriereserve.",
      "batResText": "Batteriereserve zwischen",
      "learnHowEmea": "Erfahren Sie mehr über das Batterieprofil",
      "learnHow": "Erfahren Sie, wie Batterieprofile funktionieren",
      "editPref": "Einstellungen bearbeiten",
      "c1": "Geld sparen",
      "c1Sub": "Maximale Ersparnis bei den laufenden Kosten",
      "c2": "Energieunabhängigkeit",
      "c2Sub": "Stromversorgung für das eigene Zuhause und Umweltfreundlichkeit",
      "c3": "Reserve",
      "c3Sub": "Reserve bei Stromausfällen",
      "p1": "Erste Priorität",
      "p2": "Zweite Priorität ",
      "optional": "Optional",
      "ques": "Was sind Ihre Erwartungen an das Enphase system?",
      "priority": "Ordnen Sie die Ziele mittels Ziehen und Ablegen vom wichtigsten zum am wenigsten wichtigsten an.",
      "ftrpTutorialText": "Wählen Sie die Karten aus, und ziehen Sie sie entsprechend Ihren Prioritäten nach oben oder unten. Die erste Karte von oben steht für die höchste Priorität.",
      "updateBatteryProfile": "Batterieprofil aktualisieren",
      "activatedSavingsMode": "Ihre Batterie ist derzeit im Energiesparmodus und hat eine Reserve von %{soc}%. Die Energieunabhängigkeit außerhalb der Spitzenzeiten ist %{eiStatus}.",
      "activatedSelfConsumptionMode": "Ihre Batterie ist derzeit im Eigenverbrauchsmodus und hat eine Reserve von %{soc}%.",
      "activatedFullBackupMode": "Ihr derzeitiges Batterieprofil ist Vollständiges Backup.",
      "activatedSavingsModeWithoutSoc": "Ihr Akku befindet sich derzeit im Sparmodus und die Energieunabhängigkeit nach Spitzenzeiten beträgt %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "Ihr Akku befindet sich derzeit im Eigenverbrauch.",
      "activateProfile": "Möchten Sie das empfohlene Profil aktivieren?"
    }
  },
  "envoy": {
    "all": "Alle Gateways",
    "pvAll": "Alles",
    "dropDwnHelper": "Daten anzeigen von",
    "envSN": "Gateway SN:",
    "reconnect": "Bitte verbinden Sie Ihr Gateway neu.",
    "extraContent": "Wenn Sie sich in der Nähe Ihres Systems befinden, können Sie sich in der Zwischenzeit lokal mit Gateway verbinden, um den aktuellen Status anzuzeigen.",
    "btnText": "Erfahren Sie, wie Sie eine Verbindung zum WLAN des Gateways herstellen",
    "getHelp": "Verbinden Sie Ihren Gateway wieder mit dem Heim-WLAN",
    "envoyConfirmation": "Verbinden Sie sich über den AP-Modus mit dem Gateway, um fortzufahren.",
    "title": "Wir haben festgestellt, dass Sie Envoy-S oder IQ Gateway nutzen und WLAN verwenden.",
    "steps": "Führen Sie die Schritte durch, um den Gateway mit dem WLAN-Netzwerk zu verbinden.",
    "steps_ap": "Befolgen Sie die Schritte, um eine Verbindung zum Gateway-Netzwerk herzustellen",
    "ap_button": "Drücken Sie die AP-Modustaste",
    "ap_modeDescription": "Drücken Sie kurz die Gateway-Menütaste unter dem Telefonsymbol und lassen Sie sie wieder los (nicht gedrückt halten). Dies führt zur Aktivierung des AP-Modus auf Ihrem Gateway, und es wird ein WLAN-Netzwerk erstellt, das Sie über Ihr Telefon aufrufen können.",
    "disable_data": "Deaktivieren mobiler Daten",
    "disable_dataDescription": "Schalten Sie die mobilen Daten (Mobilfunkdaten) in den Einstellungen Ihres mobilen Geräts aus. Gehen Sie zu Einstellungen > Mobile Daten und schalten Sie sie aus.",
    "envoy_network": "Dem Gateway-Netzwerk beitreten",
    "envoy_description": "Treten Sie dem Gateway-Netzwerk über die WLAN-Einstellungen Ihres Telefons bei. Envoy_029655 ist der Name des Mini-Netzwerks, dem Sie beitreten, wobei „029655“ die letzten sechs Ziffern der Seriennummer Ihres Gateways sind.",
    "home_wifi": "Gateway mit dem Heim-WLAN verbinden",
    "wifi_description": "Tippen Sie auf die Schaltfläche Heim WLAN konfigurieren, wählen Sie Ihr Heimnetzwerk aus und geben Sie das WLAN-Kennwort ein.",
    "configure_wifi": "Konfigurieren Sie WLAN zu Hause",
    "cancel": "Stornieren",
    "stickyNotification": "Bitte tippen Sie nicht auf die Zurück-Schaltfläche und wischen Sie nicht, um die App zu beenden (Sie können sie minimieren), während Sie versuchen, Ihren Gateway erneut zu verbinden.",
    "enter_password": "Passwort eingeben für",
    "password": "Passwort",
    "incorrect_password": "Falsches Passwort",
    "wifi_failureMsg": "Gateway konnte sich nicht mit Ihrem WLAN-Netzwerk verbinden",
    "wifi_successMsg": "Gateway ist erfolgreich mit dem WLAN verbunden",
    "envoyConnectToCellular": "Sie können Ihr Mobilgerät jetzt von Ihrem Gateway-Netzwerk trennen und es mit Ihrem WLAN-Netzwerk verbinden/Ihre mobilen Daten aktivieren.",
    "envoyToastMessage": "Ihr Gateway ist erfolgreich verbunden. Aber es kann bis zu 30 Minuten dauern, bis der Status Ihres Gateways aktualisiert wird.",
    "wifi_congratsMsg": "Gratulation! Sie sind wieder online. Jetzt können Sie Ihr Mobiltelefon wieder mit dem WLAN-Heimnetzwerk verbinden.",
    "tryagain": "Versuchen Sie es nochmal",
    "okay": "OK, habe es",
    "failedToFetchWiFiNetworks": "Probleme beim Abrufen von Wi-Fi-Netzwerken. Bitte versuchen Sie es nach einiger Zeit erneut.",
    "noWifiNetworkFound": "Kein Wi-Fi-Netzwerk gefunden. Starten Sie Ihren WLAN-Router neu und versuchen Sie es erneut.",
    "option2": "Wenn die oben genannten Schritte nicht funktionieren, erfahren Sie, wie Sie es manuell durchführen können",
    "learnhow": "Lerne wie",
    "ensureOn": "Stellen Sie sicher, dass das Gateway eingeschaltet ist",
    "connectToPower": "Stellen Sie sicher, dass Ihr Gateway mit einer Stromquelle verbunden ist."
  },
  "whatsnews": {
    "monitorTitle": "Monitor",
    "monitorContent": "Verschaffen Sie sich mit Schlüsselmetriken auf einem einzigen Bildschirm einen Überblick über den Zustand Ihres Systems",
    "trackTitle": "Nachverfolgen",
    "trackContent": "Sie können die Energiegewinnung und den Verbrauch über Tage, Monate, Jahre oder die gesamte Lebensdauer hinweg nachverfolgen und darin navigieren.",
    "reportTitle": "Bericht",
    "reportContent": "Mithilfe der App können Sie täglich, wöchentlich, monatlich oder in beliebigen Abständen Berichte zur Energiegewinnung und zum Verbrauch erstellen."
  },
  "theme": {
    "instructions": "Aktuelles Farbschema",
    "night": "Nacht",
    "day": "Tag"
  },
  "devices": {
    "model": "Model",
    "dryContactLoads": "Verbraucher",
    "generator": "Generator",
    "noDeviceFound": "Kein Gerät gefunden",
    "searchMicroinverters": "Suchen Sie nach Mikroinvertern SN",
    "serialNumber": "SN",
    "configure": "Konfigurieren",
    "connect": "Verbinden",
    "envoy": "Gateway",
    "microinverters": "Mikrowechselrichter",
    "microinverter": "Mikrowechselrichter",
    "stringInverters": "String Inverter",
    "storage": "Batterie",
    "enpower": "Systemcontroller",
    "skuNumber": "SKU",
    "firmwareVersion": "Firmware",
    "cycleCount": "Zyklusanzahl",
    "cycleCountInfo": "Die Zyklusanzahl einer Batterie ist die Gesamtzahl der Zyklen mit vollständiger Auf- und Entladung. Sie errechnet sich durch Division der insgesamt akkumulierten Energie durch die Nutzkapazität der Batterie. Die hier angezeigte Zahl steht für den kompletten Zyklus.",
    "status": "Status",
    "array": "Array",
    "help": "Hilfe",
    "not_reporting": "Keine Berichterstattung",
    "not_reporting_lowercase": "keine berichterstattung",
    "normal": "Normal",
    "home": "Zuhause",
    "no_microinverters": "Kein mikrowechselrichter gefunden",
    "no_storage": "Kein speicher gefunden",
    "no_envoy": "Kein Gateway gefunden",
    "no_enpower": "Kein Systemcontroller gefunden",
    "wirelessRangeExtender": "Extender für Funkreichweite",
    "no_wirelessRangeExtender": "Kein Extender für Funkreichweite gefunden",
    "lastReported": "Zuletzt gemeldet",
    "manufacturer": "Herstellername",
    "startType": "Starttype",
    "fuelType": "Treibstoffart",
    "modelNumber": "Modell-Nr",
    "onOffCycles": "Gesamtanzahl der Ein/Aus-Zyklen",
    "maintainenceInfo": "Wartungsinformationen",
    "maintainenceSub": "Aktualisieren Sie diese Details, um über Ihre Generatorwartung und Ihren Kraftstoffbedarf benachrichtigt zu werden.",
    "lastMaintainenceDate": "Datum der letzten Wartung",
    "lastRefuellingDate": "Letztes Tankdatum",
    "lastRefuellingTime": "Letzte Tankzeit",
    "lastMaintainenceTime": "Letzte Wartungszeit",
    "litresOfFuel": "Liters of fuel filled",
    "additionalInfo": "Für weitere Informationen",
    "statistics": "Ihre Statistik seit der letzten Wartung:",
    "timeElapsed": "Verstrichene Zeit:",
    "cycles": "Ein/Aus-Zyklen:",
    "runningHours": "Laufzeit:",
    "Days": "Tage",
    "update": "Aktualisieren",
    "clickHere": "Klick hier",
    "savedSuccessfully": "Ihre Einstellungen wurden erfolgreich gespeichert.",
    "loads": {
      "status": "Status",
      "smartControl": "Smart Control",
      "auxillaryContact": "Hilfskontakt"
    },
    "devicegenerator": {
      "on": "An",
      "off": "Aus"
    },
    "connected": {
      "true": "Verbunden mit der Enphase Cloud",
      "false": "Von Enphase Cloud getrennt"
    },
    "envoyConnected": {
      "wait": "Gateway wird gesucht ...",
      "true": "Gateway erfolgreich gefunden.",
      "false": "Gateway nicht gefunden."
    },
    "stepOne": "Bitte verbinden Sie sich direkt mit dem Gateway. Drücken Sie dazu zunächst die Verbindungstaste am Gateway.",
    "stepTwo": "Rufen Sie dann Ihre WLAN-Einstellungen auf und verbinden Sie sich mit dem Netzwerk des Gateways:",
    "stepThree": "Kehren Sie zu diesem Bildschirm zurück, nachdem die Verbindung hergestellt wurde. Ihre Internetverbindung wird vorübergehend getrennt.",
    "connectLocally": "Lokal verbinden",
    "connectEnvoy": "Verbindung zum Gateway über",
    "connectEnvoyUser": "Benutzername",
    "connectEnvoyPassword": "Kennwort",
    "notAllowAPMode": "Das Gateway unterstützt keine lokalen Verbindungen.",
    "localEnvoyConnected": {
      "true": "Gateway erfolgreich gefunden",
      "false": "Kein Gateway im lokalen Netzwerk gefunden",
      "wait": "Bitte warten…"
    },
    "envoyPwd": {
      "urenvPwd": "Ihr Gateway-Passwort",
      "retrivePwd": "So rufen Sie Ihr Gateway-Passwort ab:",
      "infoTitle": "Gateway-Passwort",
      "infoDescription": "Sie benötigen dieses Passwort, um Ihr Gateway erneut mit Ihrem WLAN zu verbinden. Dies passiert in der Regel, wenn das WLAN-Passwort oder der Dienstanbieter geändert wurde.",
      "infoLearnMore": "Klick hier um mehr zu erfahren"
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Schalten Sie das Bluetooth Ihres Telefons ein, um sich mit Ihrem IQ Gateway zu verbinden",
      "tryApMode": "Probieren Sie den AP-Modus aus",
      "gatewayNotFound": "IQ Gateway ist nicht erkennbar. Stellen Sie sicher, dass sich Ihr IQ Gateway in der Nähe befindet und eingeschaltet ist.",
      "bleNotSupported": "Bluetooth wird nicht unterstützt",
      "bleNotSupportedDesc": "Bluetooth wird von Ihrem Gerät nicht unterstützt. Bitte stellen Sie sicher, dass das Gerät über Bluetooth- und Standortoptionen verfügt.",
      "bleConnected": "Bluetooth verbunden",
      "scanningGateway": "Scannen nach IQ Gateway",
      "fewMints": "Dies kann einige Minuten dauern",
      "noWifi": "Keine WLAN-Geräte gefunden",
      "password": "Kennwort",
      "gatewayConnected": "IQ Gateway ist erfolgreich mit WLAN verbunden.",
      "okGotIt": "Okay, verstanden",
      "noGateway": "IQ Gateway nicht gefunden",
      "gatewayNearByWarning": "Stellen Sie sicher, dass sich Ihr Gateway in der Nähe befindet und eingeschaltet ist.",
      "noNetwork": "Kein Netzwerk",
      "wifiRouterWarning": "Lassen Sie den WLAN-Router eingeschaltet und das IQ Gateway in Reichweite des WLAN.",
      "connectionError": "Verbindungsfehler",
      "turnOn": "Einschalten",
      "failedWifiConnect_1": "Verbindung mit dem WLAN-Netzwerk fehlgeschlagen. Bitte ",
      "failedWifiConnect_2": "Kontaktieren Sie den Support,",
      "failedWifiConnect_3": " um Hilfe zu erhalten",
      "failedIQConnect_1": "Verbindung zum IQ Gateway fehlgeschlagen. Bitte ",
      "failedIQConnect_2": "Kontaktieren Sie den Support,",
      "failedIQConnect_3": " um Hilfe zu erhalten",
      "bleDevices": "Bluetooth Devices",
      "wifiNetworks": "WLAN-Netzwerke",
      "connectBle": "Bluetooth-Verbindung herstellen",
      "gatewayToWifi": "IQ Gateway wird mit dem WLAN verbunden...",
      "bleStatus": "Bluetooth-Status wird überprüft...",
      "searchingWifi": "Suche nach WLAN-Netzwerken...",
      "connectingBle": "Verbindung mit Bluetooth wird hergestellt",
      "turnOnBle": "Bluetooth einschalten",
      "tryAgain": "Erneut versuchen",
      "wifiSsIdConfigFailedDesc": "Beim Verbinden mit dem Wi-Fi-Netzwerk ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder stellen Sie eine Verbindung zu einem anderen Netzwerk her.",
      "wifiCommunicationError": "Wi-Fi-Kommunikationsfehler",
      "wifiCommunicationErrorDesc": "Es kann keine Verbindung mit dem BLE-Modul von IQ Gateway hergestellt werden. Bitte versuch es später.",
      "networkNotFound": "Netzwerk nicht gefunden",
      "networkNotFoundDesc": "Das Netzwerk, zu dem Sie eine Verbindung herstellen möchten, wurde nicht gefunden. Stellen Sie sicher, dass der WLAN-Router eingeschaltet ist, oder versuchen Sie es mit einem anderen Netzwerk."
    }
  },
  "notification": {
    "offline": "Offline",
    "apmode": "AP-Modus"
  },
  "siteempty": {
    "nosystemassociated": "Ihr Konto ist zurzeit mit keinem System verknüpft.",
    "systemowner": "Sind Sie der Enphase-Systemeigentümer?",
    "contactyourinstaller": "Wenden Sie sich an Ihren Installateur, um das Konto zu bestätigen, das Ihrem System zugeordnet ist.",
    "interestedonsystem": "Sind Sie an einem Enphase-System interessiert?",
    "initiatetransferofwarranty": "Initiieren Sie die Übernahme einer Garantie, falls Sie ein Objekt mit einem Enphase-System gekauft haben. ",
    "applytransferownership": "Beantragen Sie hier eine Eigentümerübertragung.",
    "ownershiptransfer": "Eigentümerübertragung",
    "visita": "Rufen Sie eine",
    "publicsystempage": "öffentliche Systemseite auf,",
    "monitoringexperience": "um die Enphase-Überwachungslösung anzusehen. "
  },
  "recaptcha": {
    "verification_failed": "Verifizierung mit reCAPTCHA fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "recaptcha_unreachable": "Hoppla, wir konnten Ihre reCAPTCHA-Antwort nicht validieren. Versuchen Sie es erneut."
  },
  "mobile_app_rating": {
    "enjoying_app": "Gefällt Ihnen die Enphase App?",
    "rate_on_play_store": "Bewerten Sie Ihre Erfahrung",
    "rate_on_play_store2": "Im Play Store",
    "rate_us": "Bewerten Sie uns jetzt",
    "may_be_next": "Vielleicht nächstes Mal"
  },
  "consumptionMtr": {
    "btnText": "Verbrauchszähler hinzufügen",
    "infoText": "Mit dem Verbrauchszähler behalten Sie den Überblick über Ihren Gesamtenergieverbrauch"
  },
  "replacement": {
    "microinverter_not_reporting": "Keine Berichte von den Mikro-Wechselrichtern.",
    "batteryWarning": 'Dies kann auftreten, wenn die drahtlose Kommunikation zwischen Ihrem Gateway und dem Akku nicht robust ist. Dies kann ein vorübergehender Fehler sein und sollte sich bald beheben. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Betreuer, um Hilfe zu erhalten.',
    "controllerWarning": 'Dies kann auftreten, wenn die drahtlose Kommunikation zwischen Ihrem Gateway und dem Systemcontroller nicht robust ist. Dies kann ein vorübergehender Fehler sein und sollte sich bald beheben. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Betreuer, um Hilfe zu erhalten.',
    "batteryError": 'Batterie sendet keine Daten.',
    "controllerError": 'System Controller meldet sich nicht.',
    "contactMaintainer": 'Wenden Sie sich an den Kundenservice, um Hilfe zu erhalten.',
    "systemWarning": 'Systemwarnung',
    "array_details": "Array-Details",
    "replacement_warranty1": "",
    "replacement_warranty": "Mikrowechselrichter unterliegen der Garantie und können umgetauscht werden.",
    "shipping_address": "Versandadresse",
    "site_address": "Baustellenadresse",
    "change": "AUSTAUSCH",
    "select_microinverters": "MIKRO-WECHSELTRICHTER AUSWÄHLEN",
    "serial_number": "Seriennummer suchen",
    "status": "Status",
    "normal": "Normal",
    "not_reporting": "Keine Meldung",
    "submit_request": "Antrag absenden",
    "dear": "Sehr geehrte/r",
    "replacement_message1": "Sie müssen sich möglicherweise an Ihren Installateur wenden",
    "replacement_message2": "um den Austausch durchzuführen, sobald das Ersatzgerät angeliefert wurde. Möglicherweise fallen Austauschkosten von Ihrem Installateur an.",
    "request_submitted": "Ihre Retourenanforderung wurde erfolgreich übermittelt.",
    "response_message": "Wenn Sie sich an den Support wenden, können Sie anhand der Antragsnummer den Status des Austauschs verfolgen.",
    "request_id": "Antragsnummer",
    "ok": "Gut, habe ich verstanden",
    "replacement_delivery": "Das/die Austauschgerät(e) werden auf Ihre Baustelle geliefert.",
    "replacement_delivery_installer": "Das/die Austauschgerät(e) werden an den von Ihnen beauftragten Installateur geliefert.",
    "installer_address": "ANSCHRIFT DES INSTALLATEURS",
    "understand": "Ich bin einverstanden",
    "continue_button": "Fortfahren",
    "error_message": "Anforderungs-ID konnte nicht generiert werden",
    "failed_to_fetch": "Das Abrufen von Mikro-Wechseltrichtern ist fehlgeschlagen. Bitte versuchen Sie es noch einmal",
    "change_address": "Lieferadresse ändern"
  },
  "tariff": {
    "tariff": "Tarif",
    "tariffNotAdded": "Tarif wird nicht hinzugefügt",
    "tariffNotSet": "Tarif nicht festgelegt",
    "tariffType": "Tarif-Art",
    "buying": "Einkauf",
    "selling": "Verkauf",
    "flat": "Pauschalpreis",
    "tou": "Nutzungszeit",
    "tiered": "Gestaffelt",
    "copyFromBuyingTariff": "Kopie vom Kauftarif",
    "copyFromSellingTariff": "Kopie vom Verkaufstarif",
    "dayBasedTariff": "Variiert Ihr Tarif im Laufe des Tages?",
    "unitsBasedTariff": "Variiert Ihr Tarif je nach verbrauchten Einheiten?",
    "seasonalTariff": "Variiert Ihr Tarif saisonal?",
    "weekendTariff": "Variiert Ihr Tarif am Wochenende?",
    "baseRateTariff": "Was ist der Grundtarif?",
    "flatLabel": "Die Energiekosten werden den ganzen Tag über festgelegt.",
    "touLabel": "Die Energiekosten variieren während der Spitzenzeiten.",
    "tieredLabel": "Die Energiekosten variieren mit steigendem Stromverbrauch.",
    "rate": "Tarif",
    "addSeason": "Saison hinzufügen",
    "season": "Saison",
    "next": "Weiter",
    "noSeasonWeekend": "Der Tarif variiert weder saisonal noch am Wochenende.",
    "weekendOnly": "Der Tarif variiert nur an Wochenenden.",
    "seasonAndWeekend": "Der Tarif variiert saisonal und am Wochenende.",
    "seasonOnly": "Der Tarif variiert nur saisonal.",
    "infoText": "Die Info",
    "baseRate": "Grundtarif",
    "remove": "Entfernen",
    "from": "Von",
    "to": "Bis",
    "addPeak": "Spitze hinzufügen",
    "tariffDetails": "Tarifdaten",
    "off-peak": "Off-Peak",
    "above": "Darüber",
    "below": "Unten",
    "between": "Zwischen",
    "and": "und",
    "weekdays": "Wochentage ",
    "weekend": "Wochenende",
    "winter": "Winter",
    "summer": "Sommer",
    "fall": "Herbst",
    "spring": "Frühjahr",
    "confirmAndSave": "Bestätigen & Speichern",
    "buyingTariff": "Kauftarif",
    "sellingTariff": "Verkaufstarif",
    "edit": "Bearb",
    "offPeak": "Schwachlast",
    "peak": "Spitzenwert",
    "period": "Spitzenwert",
    "addTier": "Lage hinzufügen",
    "tier": "Lage",
    "yesLabel": "ja",
    "noLabel": "Nr",
    "manualConfiguration": "Manuelle Konfigurationen",
    "added": "hinzugefügt",
    "modified": "geändert",
    "successfully": "erfolgreich",
    "alreadySelected": "ist schon ausgewählt",
    "alreadyAdded": "ist schon hinzugefügt",
    "buyingTariffAdded": "Bezugstarif hinzugefügt",
    "sellingTariffAdded": "Abgabetarif hinzugefügt",
    "buyingTariffModified": "Bezugstarif geändert",
    "sellingTariffModified": "Abgabetarif geändert",
    "buyingTariffReset": "Bezugstarif zurückgesetzt",
    "sellingTariffReset": "Abgabetarif zurückgesetzt",
    "reset": "Zurücksetzen",
    "resetConfirmationText": "Sind Sie sicher, dass Sie die ausgewählten Tarif zurücksetzen möchten?",
    "resetErrorText": "Die Tarifdaten können nicht zurückgesetzt werden.",
    "updateErrorText": "Die Tarifdaten können nicht aktualisiert werden.",
    "tariffErrorText": "Falsche Eingabe Dieser Wert ist bereits in Ebene vorhanden ",
    "tierInvalidEntry": "Falsche Eingabe Der Wert muss größer als \"Tier 1\" sein.",
    "timeInvalidEntry": "Invalid Eintrag. Der Wert muss größer als \"Von\" sein.",
    "invalidValue": "Der Wert muss größer als 0 sein."
  },
  "currency": {
    "currencyEquivalent": "Siehe Wirtschaftlichkeit der Energiewerte",
    "currencyConversion": "Währungsumrechnungsfaktor einstellen",
    "currencyInfo": "Der ausgewiesene Geldwert ist eine durchschnittliche Schätzung, da er die Preise für Steuern, Gebühren, Staffelung, Nachfrage oder Nutzungszeit nicht berücksichtigt.",
    "currencyFactor": "Währungsumrechnungsfaktor",
    "currencyFactorSubtitle": "Energiedaten werden in ihren Währungsäquivalentwert umgerechnet, indem sie mit dem Währungsumrechnungsfaktor multipliziert werden.",
    "currencyNote": "Hinweis: Der ausgewiesene Geldwert ist eine durchschnittliche Schätzung, da er die Preise für Steuern, Gebühren, Staffelung, Nachfrage oder Nutzungszeit nicht berücksichtigt.",
    "conversionFactor": "Umrechnungsfaktor",
    "currencyEquivalentHeader": "Wirtschaftlichkeit",
    "energyImported": "Energie importiert",
    "energyExported": "Energie exportiert",
    "netEnergyImported": "Importierte Nettoenergie",
    "netEnergyExported": "Exportierte Nettoenergie",
    "currencyConversionHeader": "Währungsumrechnung",
    "confirmationMessage": "Möchten Sie fortfahren, ohne die Änderungen zu speichern?",
    "confirmationYes": "Ja",
    "confirmationNo": "Nein",
    "invalidInput": "Ungültige Eingabe"
  },
  "demo": {
    "appDemo": "App-Demo",
    "message": "Dies ist eine Demo-Anwendung",
    "enphaseInstaller": "Enphase-Installer",
    "mainHeader": "Alles in einem intelligenten Energiesystem",
    "subHeader": "Holen Sie sich Solarenergie und Speicher",
    "getStarted": "Einstieg",
    "appDemoDesc": "Tippen Sie hier, um zu sehen, wie ein System funktioniert",
    "loginDesc": "Für registrierte Nutzer",
    "selectLanguage": "Sprache auswählen"
  },
  "connectionBandwidth": {
    "low": "Niedrige Bandbreite. Meldet Daten alle 6 Stunden",
    "high": "Standard-Bandbreite. Meldet alle 15 Minuten Daten"
  },
  "release_notes": {
    "appUpdateHeading": "Neues Update für Ihre Enphase App",
    "appUpdateSuccessHeading": "Ihre Enphase App wurde aktualisiert.",
    "later": "Später",
    "updateNow": "Jetzt aktualisieren",
    "update": "Aktualisieren",
    "whatsNew": "Hier ist, was es Neues gibt",
    "askWhatsNew": "Was gibt es Neues?",
    "new": "Neu",
    "version": "Version",
    "readMore": "Mehr erfahren"
  },
  "storageCapacity": {
    "availableEnergy": "Vorhandene Energie",
    "totalStorage": "Gesamtladung",
    "encharge": "IQ Battery",
    "acBattery": "AC Batterie",
    "of": "von",
    "availablePower": "Verfügbare Leistung",
    "activeMicroinverters": "Aktive(r) Mikrowechseltrichter",
    "activeEncharge": "Aktive Batterie(n)",
    "microinverters": "Mikrowechseltrichter"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Laden Sie ein Site-Image Ihrer Wahl hoch",
    "selectImage": "Bild Auswählen",
    "imageSizeError": "*Die Bildgröße sollte weniger als 5 MB betragen",
    "hide": "Ausblenden",
    "apply": "Anwenden",
    "hideSiteImage": "Site-Bild ausblenden",
    "hideSiteImageDesc1": "Site-Bild wird nicht auf der Statusseite angezeigt. Sie können die Einstellung ändern, indem Sie zu Menü -> System -> Standortdetails gehen.",
    "hideSiteImageDesc2": "Willst du fortfahren?",
    "uploadSuccessToast": "Ihr Site-Image wurde erfolgreich aktualisiert",
    "maxImageLimit": "Sie können bis zu vier Bilder für Ihre Website hochladen. Bitte löschen Sie ein Bild, um ein neues hinzuzufügen.",
    "okGotIt": "Okay, verstanden!",
    "imageSIzeErrorSiteDetails": "Die Bildgröße sollte weniger als 5 MB betragen. Bitte laden Sie ein anderes Bild hoch.",
    "apiError": "Anfrage kann nicht abgeschlossen werden. Bitte versuchen Sie es später erneut",
    "displayOnStatusPage": "Anzeige auf statusseite",
    "displayOnStatusPageWarning": "Möchten Sie das Bild auf der Statusseite wirklich aktualisieren?",
    "displayOnStatusPageNote": "Hinweis: Das Bild wird automatisch zur Anzeige angepasst. Sie können es jederzeit auf der Statusseite neu anpassen",
    "deleteSiteImage": "Lösche Bild",
    "deleteSiteImageWarning": "Möchten Sie das Bild wirklich löschen?",
    "imageDeleteSuccess": "Bild wurde erfolgreich gelöscht",
    "imageUploadSuccess": "Bild wurde erfolgreich hochgeladen",
    "imageUploadSuccessStatusPage": "Bild erfolgreich auf der Statusseite aktualisiert",
    "displayedOnStatusPage": "Angezeigt auf der statusseite",
    "uploadImage": "Bild hochladen",
    "imagePreferenceSaved": "Ihre Site-Image-Einstellung wird gespeichert",
    "siteImage": "Website-Bild",
    "statusPageMaxImagePopUpDesc1": "Sie können bis zu vier Bilder für Ihre Website hochladen. Bitte löschen Sie ein Bild aus ",
    "statusPageMaxImagePopUpDesc2": ", um hier ein neues hinzuzufügen",
    "addSiteImage": "WEBSITE-BILD HINZUFÜGEN",
    "wrongFileType": "Bitte laden Sie nur ein JPEG- oder PNG-Bild hoch"
  },
  "nps": {
    "question": "Wie sind Sie mit uns zufrieden?",
    "description": "Wie wahrscheinlich ist es, dass Sie Enphase aufgrund Ihrer jüngsten Erfahrungen mit Enphase einem Freund oder Kollegen empfehlen?",
    "dontAskAgain": "Frag mich nicht noch einmal",
    "notNow": "Nicht jetzt",
    "notLikely": "Unwahrscheinlich",
    "mostLikely": "Am wahrscheinlichsten",
    "confirmationHeader": "Vielen Dank für Ihre Antwort! Helfen Sie uns, Ihre Antwort besser zu verstehen.",
    "surveyButton": "Nehmen Sie bitte an der 2-minütigen Umfrage teil",
    "notInterested": "Nicht interessiert",
    "survey": "Umfrage",
    "internetError": "Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    "rateEnphaseTitle": "Bewerten Sie Enphase",
    "rateEnphaseDescription": "Wie wahrscheinlich ist es, dass Sie Enphase einem Freund oder Kollegen empfehlen?",
    "rateInstallerTitle": "Bewerten Sie Ihren Installateur",
    "rateInstallerDescription1": "Wie wahrscheinlich ist es, dass Sie",
    "rateInstallerDescription2": "Ihrem Freund oder Kollegen empfehlen?",
    "feedbackSuccess": "Vielen Dank für Ihre wertvolle Meinung.",
    "ratingSuccess": "Vielen Dank für dein Feedback.",
    "feedbackEnphaseTitle": "Ihre Enphase-Bewertung",
    "feedbackInstallerTitle": "Ihre Installer-Bewertung",
    "detractors": "Was könnten wir besser machen?",
    "passive": "Was können wir tun, um Ihre Erfahrung zu verbessern?",
    "promoters": "Helfen Sie uns, indem Sie Ihre Punktzahl erklären?",
    "legalDisclaimer": "Ihr Name und Ihr Feedback/Kommentare werden den Installateuren mitgeteilt."
  },
  "liveStatus": {
    "title": "Live-Status",
    "subTitle": "Echtzeitleistung des Stroms anzeigen",
    "offlineMsg": "Use LIVE STATUS when Offline",
    "streamingLocally": "Lokales Streaming vom Gateway",
    "closingMinutes": "Abschließen in",
    "cfgMsg": "Die Batterien werden möglicherweise über das Stromnetz aufgeladen, da Sie die %{cfglink}-Einstellung aktiviert haben.",
    "cfgFiller": "Laden Sie den Akku über das Netz",
    "cfgVls": "Die Akkus werden möglicherweise über das Stromnetz aufgeladen, wenn der Ladezustand der Akkus unter dem Abschaltgrenzwert liegt.",
    "learn": "Lernen",
    "pvOnlyCta": "%{learn} wie Sie Ihren Energieverbrauch mithilfe von Verbrauchsmessungen optimieren und nachverfolgen können",
    "solar": {
      "title": "Erzeugt",
      "producing": "Wird produziert",
      "energyProducing": "Energiegewinnung"
    },
    "home": {
      "title": "Startseite",
      "consuming": "Verbrauch",
      "energyConsuming": "Energieverbrauch"
    },
    "grid": {
      "title": "Netz",
      "gridConnectivity": "Netzverbindung",
      "waiting": "Wachten op informatie",
      "unknown": "Netzstatus unbekannt",
      "notAvailable": "Netz nicht verfügbar",
      "systemConnected": "System ist On Netz",
      "notSystemConnected": "System ist Off Netz",
      "outage": "Grid Outage",
      "updating": "Netzstatus aktualisieren",
      "exporting": "Exportiere",
      "importing": "Netzbezug",
      "notConnected": "Nicht verbunden",
      "offGrid": "Off Netz",
      "onGrid": "On Netz",
      "goOnGrid": "On Netz gehen",
      "goOffGridDisabled": "Außerhalb des Netzes nicht erlaubt",
      "goOffGrid": "Off Netz gehen",
      "gridUpdatingMessage": "Die Bestätigung des Netzstatus dauert länger als erwartet. Bitte schauen Sie später wieder vorbei.",
      "gridConnectedMessage": "Ihr System ist jetzt an das Netz angeschlossen",
      "gridDisconnectedMessage": "Ihr System ist nun vom Netz getrennt.",
      "disconnectingGrid": "Verbindung zum Netz trennen...",
      "connectingGrid": "Mit Netz verbinden...",
      "unableToConnect": "Keine Verbindung zum Gateway möglich",
      "initialisingOnGrid": "Netzsteuerung wird gestartet...",
      "gridOutage": "Das System ist aufgrund eines Netzausfalls vom Netz getrennt",
      "gridOutageToastAuto": "Sie können aufgrund eines Stromausfalls nicht auf Netzverbunden wechseln. Wenn die Stromversorgung wiederhergestellt ist, verbindet sich das System wieder mit dem Netz",
      "gridOutageToastUser": "Sie können aufgrund eines Stromausfalls nicht auf Netzverbunden wechseln. Sie können die Netzverbindung steuern, sobald das öffentliche Stromversorgungsnetz verfügbar ist"
    },
    "generator": {
      "title": "Generator",
      "onGenerator": "Generator An",
      "offGenerator": "Generator Aus",
      "unknown": "Generatorstatus unbekannt",
      "notConnected": "Nicht verbunden",
      "genDisconnecting": "Disconnecting...",
      "waiting": "Wartet",
      "updating": "Aktualisiere"
    },
    "fuelCell": {
      "title": "Brennstoffzelle",
      "on": "Brennstoffzelle an",
      "off": "Brennstoffzelle aus",
      "warmingUp": "Aufwärmen der Brennstoffzelle",
      "coolDown": "Abkühlung der Brennstoffzelle",
      "unknown": "Brennstoffzellenstatus unbekannt",
      "notConnected": "Nicht verbunden",
      "genDisconnecting": "Trennen...",
      "waiting": "Wartet",
      "updating": "Aktualisierung"
    },
    "systemNotReporting": {
      "title": "System Controller meldet sich nicht",
      "subTitle": "Wir können die Live-Daten nicht anzeigen, da Ihr System Controller nicht an das Gateway berichtet. Dies kann ein vorübergehender Fehler sein und sollte sich bald beheben."
    },
    "envoy": {
      "connecting": "Verbindung zum Gateway wird hergestellt ...",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "Kann nicht verbinden",
      "notAbleToConnectMultiEnv": "Keine Verbindung zu gateway SN.:",
      "negativeConsumptionTitle": "Kommunikationsfehler",
      "negativeConsumptionDesc": "Wir können den vollständigen Live-Status aufgrund eines Kommunikationsverlusts zwischen Ihren Geräten nicht anzeigen. Dies ist eine vorübergehende Störung und sollte sich bald erholen"
    },
    "onDifferentNetwork": "Ihr Gateway und dieses Gerät befinden sich in unterschiedlichen Netzwerken",
    "connectOnSameNetworkorAPMode": "Verbinden Sie Ihr Gateway und Ihr Gerät mit demselben Netzwerk oder aktivieren Sie den AP-Modus auf Ihrem Gateway, um dieses Gerät mit dem %{ssid} WLAN-Netzwerk zu verbinden​",
    "connectOnSameNetwork": "Verbinden Sie dieses Gerät mit dem %{ssid} WLAN-Netzwerk und versuchen Sie dann erneut, den Live-Status im Offline-Modus anzuzeigen.",
    "apModeTutorial": "AP-Modus-Tutorial",
    "apMT1": "Drücken und loslassen (nicht gedrückt halten). ",
    "apMT2": "AP-Modus-Taste",
    "apMT3": "bis die AP-Modus-LED (",
    "apMT4": ") grün leuchten. Das Gateway bleibt acht Stunden lang im AP-Modus."
  },
  "desktop": {
    "status": {
      "power": "Leistung",
      "energy": "Energie",
      "solarEquivalent": "Solaräquivalent",
      "dataUnavailable": "Es sind keine Daten verfügbar"
    },
    "array": {
      "title": "Array",
      "totalProduced": "Insgesamt Erzeugt",
      "totalConsumed": "Gesamter Verbrauch",
      "lifetimeProduced": "Lebenslang Erzeugt",
      "lifetimeConsumed": "Lebenszeit verbraucht",
      "status": "Status",
      "azimuth": "Azimut",
      "tilt": "Gekippt",
      "microinverter": "Mikroinverter"
    },
    "energy": {
      "totalEnergy": "Energie insgesamt",
      "graphControls": "Grafik-Steuerelemente"
    },
    "header": {
      "switchToClassic": "Zur klassischen Ansicht wechseln"
    },
    "footer": {
      "change": "Ändern",
      "changeSite": "Standort wechseln",
      "copyRightsText": "©2008-%{currYear} Amber Road, Inc. Alle Rechte vorbehalten.",
      "privacyText": "Datenschutz",
      "termsText": "AGB",
      "weatherCompany": "Die Wetterkompanie",
      "weatherDataText": "Wetterdaten, bereitgestellt von"
    }
  },
  "customPeriod": {
    "dialogLabel": "Ansicht basierend auf",
    "billingCycle": "Abrechnungszyklus",
    "billingLabel": "Passen Sie die Energiekurve an Ihren Abrechnungszyklus an",
    "billingLabelStatusPage": "Zeitraum ab einem ausgewählten Startdatum für die ausgewählte Dauer",
    "startDate": "Beginndatum der Abrechnung",
    "frequency": "Abrechnungshäufigkeit",
    "months": "Monate",
    "days": "Tage",
    "every": "Jede",
    "customDate": "Benutzerdefinierter Datumsbereich",
    "customDateLabel": "Wählen Sie eine benutzerdefinierte Datumsspanne aus, um sie im Energiediagramm anzuzeigen",
    "customRange": "Bitte wählen Sie einen Datumsbereich zwischen 1 und 100 Tagen"
  },
  "systemEstimator": {
    "heading": "System Estimator",
    "exitConfirmation": "Möchten Sie den Flow \"Speicher hinzufügen\" wirklich schließen?",
    "resumeButton": "Fortsetzen",
    "systemAccess": "Holen Sie sich den Systemzugriff",
    "statusAddStorage": "to avoid blackouts",
    "addStorageLeadInfo": "Status anzeigen",
    "postLoginWoSiteTitle": "Lernen Sie das einzige All-in-One-Solar- und Speichersystem kennen",
    "videoCTABtn": "Schau Video",
    "addStorageTitle": "Holen Sie sich ein neues Enphase-System",
    "orderNowBtn": "Jetzt bestellen"
  },
  "sgipIncentive": {
    "gotItButton": "Verstanden",
    "exitButton": "Beenden",
    "dontExitButton": "Nicht beenden",
    "sgipPaymentNotDone": "Ihr SGIP-Antrag ist unvollständig. Möchten Sie beenden, ohne Ihren Antrag ausgefüllt zu haben?",
    "sgipPaymentDone": "Sie können jederzeit wiederkommen, um den Status Ihres SGIP-Antrags zu überprüfen.",
    "sgipApplyAlert": "SGIP-Zulagen können nur für in Kalifornien installierte Systeme in Anspruch genommen werden. Wenn Sie bereits eine Systemaktivierung in Kalifornien begonnen haben, bitten Sie Ihren Installateur, den Prozess der Standorterstellung in seiner Enphase Anwendung zu initiieren.",
    "sgipGetStorage": "Holen Sie sich ein neues Enphase-Speichersystem"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "Der Rasterstatus wurde in geändert",
    "gridOn": "Auf dem Gitter",
    "gridOff": "Off-Grid",
    "batteryChangeDesc": "Batterieprofil geändert in",
    "costSavings": "Kosteneinsparungen",
    "selfConsumption": "Eigenverbrauch",
    "savingsMode": "Sparmodus",
    "backupOnly": "Nur Backup",
    "stormGuardDesc": "Sturmschutzfunktion ist",
    "alertIssued": " Alarm ausgegeben",
    "alertHasEnded": " Warnung ist beendet"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normal",
    "unknown": "Unbekannt",
    "undefined": "Nicht definiert",
    "loads": "Lastkontrolle",
    "loadsInfoPart1": "Ihr Installationsunternehmen ordnet die Verbraucher den ",
    "loadsInfoPart2": "Systemcontroller-Hilfskontakte",
    "loadsInfoPart3": " zu. Sie können diese Verbraucher in den ",
    "loadsInfoPart4": "System Settings (Systemeinstellungen)",
    "powered": "Gespeist",
    "invalidState": "Ungültiger Status",
    "viewMore": "Mehr anzeigen",
    "viewLess": "Weniger anzeigen",
    "ECA_BAT_IDLE": "Leerlauf",
    "ECA_BAT_CHARGING": "Laden",
    "ECA_BAT_DISCHARGING": "Entladen",
    "MAX_ECA_BAT_STATE": "Unbekannt",
    "systemIsOnGrid": "System ist netzverbunden",
    "systemIsOffGrid": "System ist netzfern",
    "infoIsOnGrid": "Das System arbeitet im netzgekoppelten Modus.",
    "infoIsOffGrid": "Das System arbeitet im Mikronetz-Modus.",
    "wiredCANConn": "Kabelgebundene CAN-Verbindung",
    "infoWiredCAN": "Der IQ System Controller kommuniziert mit dem IQ Gateway über eine Kabelverbindung. Das Symbol zeigt an, ob es mit dem Gateway verbunden ist und mit ihm kommuniziert.",
    "infoIsOffGridAvailable": "Das System arbeitet im Mikronetz-Modus. Das Netz ist jedoch verfügbar und Sie können jederzeit netzverbunden wählen.",
    "voltageL1": {
      "val": "Stromspannung L1",
      "info": "Die Spannung zwischen Leitung 1 (L1) und Neutral."
    },
    "voltageL2": {
      "val": "Stromspannung L2",
      "info": "Die Spannung zwischen Leitung 2 (L2) und Neutral."
    },
    "voltageL3": {
      "val": "Stromspannung L3",
      "info": "Die Spannung zwischen Leitung 3 (L3) und Neutral."
    },
    "voltage": {
      "val": "Stromspannung",
      "info": "Die Spannung zwischen Leitung 1 (L1) und Neutral."
    },
    "frequency": {
      "val": "Frequenz",
      "info": "Die nominale Wechselstromfrequenz (AC)"
    },
    "gridParameters": "Netzparameter Utility",
    "auxiliaryContactsParameters": "Lastkontrolle",
    "infoauxiliaryContactsParam": "Systemcontroller verfügt über vier Hilfskontakte zur Laststeuerung. Wenn ein Lastname angegeben ist, wurde der betreffende Kontakt dieser Last zugeordnet. Wenn ein Kontakt keiner Last zugeordnet wurde, wird „Außer Gebrauch“ angezeigt.",
    "infoGridParam": "Netzspannung und -frequenz werden auf der Utility-Seite des Mikronetz-Verbindungsgeräts (MID) gemessen. Wenn das Netz nicht verfügbar ist, beträgt die Netzspannung und -frequenz 0.",
    "microgridParameters": "Mikronetzparameter",
    "infoMicrogridParam": "Mikronetz Spannung und Frequenz werden auf der Lastseite des Mikronetz-Verbindungsgeräts (MID) gemessen. Wenn Ihr MID geöffnet ist, befindet sich Ihr System im netzfernen / Mikronetz-Modus.",
    "generatorParameters": "Generatorparameter",
    "infoGeneratorParam": "Generator Spannung und Frequenz werden auf der Lastseite des Generator-Verbindungsgeräts (GID) gemessen. Wenn Ihr GID geschlossen ist, befindet sich Ihr System im netzfernen / Mikronetz-Modus.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Kommunikationssignal",
    "infoZigbeeSignal": "Gibt die Stärke der 2,4-GHz-Verbindung für die drahtlose Kommunikation mit dem Gateway an. Mehr Balken bzw. ein höherer dBM-Wert stehen für eine bessere Signalstärke.",
    "commStatus": "Kommunikationsstatus",
    "infoCommSignal": "KOMMUNIKATIONSSIGNAL",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "IQ System Controller kommuniziert mit IQ Gateway über eine USB-Verbindung. Das Symbol zeigt an, ob der USB angeschlossen ist und mit dem IQ Gateway kommuniziert.",
    "commStatusDesc": "IQ Battery kommuniziert mit IQ Sytem Controller über eine Kabelverbindung. Das Symbol zeigt an, ob IQ Battery verbunden ist und mit IQ System Controller kommuniziert.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Unbekannt"
    },
    "ENCMN_STATE_MISSING": {
      "val": "2,4 GHz Kommunikationsfehler"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "2.4 GHz pairing"
    },
    "ENCMN_STATE_CONNECTED": {
      "val": "2,4-GHz-Kopplung abgeschlossen"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Abrufen der Geräteinformationen abgeschlossen"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "Es wird darauf gewartet, dass die Batterien den Netzstatus bestätigen"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Systemcontroller wird aufgefordert, das EC1-Relais zu schließen"
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Unbekannt"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "Startet die Netzprofilaktualisierung"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Aktualisierung des Netzprofils läuft"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Aktualisierung des Netzprofils abgeschlossen"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Systemcontroller-Relais-Status wird nach der Initialisierung abgerufen"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Systemcontroller-Relais-Status wird ausgewertet"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "Systemcontroller ist nicht am Netz („Off Grid“)"
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "Systemcontroller ist nicht am Netz („Off Grid“). Netz ist verfügbar"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "Mikronetz ist mit dem Netz synchronisiert. Bereit um auf Netzverbunden zu gehen"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "Systemcontroller ist am Netz („On Grid“)"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Systemcontroller wird aufgefordert, ans Netz zu gehen"
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "Vorbereiten der Ausführung des Befehls des Benutzers, um auf netzfern zu gehen"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Systemcontroller wird aufgefordert, vom Netz zu gehen"
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "Der System Controller ist Netzverbunden. Akkus werden entdeckt."
    },
    "ENCMN_STATE_MAX": {
      "val": "Unbekannt"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "No micros detected"
    },
    "ENCHG_STATE_READY": {
      "val": "Batterie ist betriebsbereit"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Netzmodus wird an Akku gesendet"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Reservegrenze für den Ladezustand (SOC) der Batterie wird aktualisiert"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "Startet die Netzprofilaktualisierung"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Aktualisierung des Netzprofils läuft"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Aktualisierung des Netzprofils abgeschlossen"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Hardware- und Softwaredaten werden von der Batterie abgerufen"
    },
    "ST_NOP": {
      "val": "Unbekannt"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "Systemcontroller ist nicht am Netz („Off Grid“). Verbindung zum Generator wird hergestellt."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "Systemcontroller ist nicht am Netz („Off Grid“). Generator verbunden."
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "Systemcontroller ist nicht am Netz („Off Grid“). Verbindung zum Generator wird getrennt."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "EC1 geschlossen. Relaistest abgeschlossen."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "EC1 offen. Relaistest läuft."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "GEN-Relais geschlossen. Relaistest abgeschlossen."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "GEN-Relais offen. Relaistest läuft."
    },
    "default": {
      "val": "Unbekannt"
    },
    "controlState": "Kontrollstatus",
    "CHECK_BUSES": {
      "val": "Busse und Relais prüfen",
      "info": "Der Systemcontroller wurde zurückgesetzt. Validierung der Systemparameter vor der Umstellung auf einen anderen Netzstatus."
    },
    "CYCLE_RELAYS": {
      "val": "Durchlaufen des Relais",
      "info": "Ihr System schaltet durch die Systemcontroller-Relais, um zu prüfen, ob alle Relais-Fehlerbedingungen behoben wurden."
    },
    "GRID_CONNECT": {
      "val": "Verbindet mit dem Netz",
      "info": "Ihr System ist dabei, sich nach dem Reset des Systemcontrollers mit dem Netz zu verbinden."
    },
    "EC1_EC2_CONNECT": {
      "val": "Batterien verbunden. NFT wird verbunden",
      "info": "Ihr System schaltet auf das Mikronetz um. Batterien sind verbunden. Der NFT (Neutral Forming Transformer) wird verbunden."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "Am Netz. Batterien werden verbunden",
      "info": "Ihr System ist am Netz („On Grid“). Die Batterien werden derzeit verbunden."
    },
    "GRID_OP_FULL": {
      "val": "Netzverbunden",
      "info": "Ihr System arbeitet im netzgekoppelten Modus."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Netzfern",
      "info": "Ihr System arbeitet im Mikronetz-Modus."
    },
    "SYNC_TO_GRID": {
      "val": "Synchronisation auf Netz",
      "info": "Ihr System wechselt von Mikronetz zu netzverbunden."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Ausfall des Mikronetzes",
      "info": "Mikronetz ist aufgrund einer Überlastung oder eines Systemfehlers zusammengebrochen. Das System wird bald wiederhergestellt."
    },
    "MANUFACTURING_MODE": {
      "val": "Herstellungs-Modus",
      "info": "Bitte wenden Sie sich an den Kunden-Support."
    },
    "RESET": {
      "val": "Systemcontroller-Rest",
      "info": "Ihr Systemcontroller wurde zurückgesetzt. Das System ist bald wieder funktionsfähig."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "Netzverbunden. NFT Öffnen",
      "info": "Ihr System ist netzverbunden. Der Neutralformtransformator (NFT) wird getrennt."
    },
    "MANUAL_OVERRIDE": {
      "val": "Manuelle Überbrückung aktiviert",
      "info": "Sie haben das Mikronetz-Verbindungsgerät (MID) manuell geschlossen, um in das Netz einzusteigen. Bitte rufen Sie den Kunden-Support an, wenn Sie dies nicht absichtlich getan haben."
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Unbekannt",
      "info": "Bitte wenden Sie sich an den Kunden-Support."
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Synchronisiert und verbindet mit dem Netz"
    },
    "infoControlState": "Kontrollstatus",
    "faults": "Systemcontroller-Fehler",
    "MID_FUSED": "Ihr System kann nicht in den Mikronetz-Modus wechseln, da MID geschlossen geblieben ist.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "Neutralformtransformator (NFT) Relais sind fest geschlossen.",
    "NFT_OPEN": "Ihr System kann nicht in den Mikronetz-Modus wechseln, da die Neutralformtransformator Relais (NFT) fest offen sind.",
    "MID_OPEN": "Ihr System kann nicht in den netzgekoppelten Modus wechseln, da MID nicht funktioniert.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Ihr System ist nicht betriebsbereit. Fehler bei der ATS-Platine (Automatischer Transferschalter) des Systemcontrollers.",
    "ADC_INIT": "Ihr System ist nicht betriebsbereit. Fehler bei der ATS-Platine (Automatischer Transferschalter) des Systemcontrollers.",
    "I2C_COMM": "Ihr System ist nicht betriebsbereit. Fehler bei der ATS-Platine (Automatischer Transferschalter) des Systemcontrollers.",
    "NFT_TEMP": "Ihr System ist nicht betriebsbereit. Der NFT (Neutral Forming Transformer) des Systemcontrollers hat die Temperaturgrenzen überschritten.",
    "ATS_TEMP": "Ihr System ist nicht betriebsbereit. Die ATS-Platine (Automatischer Transferschalter) des Systemcontrollers hat die Temperaturgrenzen überschritten.",
    "E3_TEMP": "Ihr System ist nicht betriebsbereit. Die Systemcontroller-Platine hat die Temperaturgrenzen überschritten.",
    "CRC_MISMATCH": "Ihr System ist nicht betriebsbereit. Fehler beim Initialisieren der Systemcontroller-Platine.",
    "V_IMBALANCE": "Ihr System kann nicht in den Mikronetz-Modus wechseln. Ein Spannungsungleichgewicht zwischen L1 und L2 hat eine Auslösung verursacht.",
    "MANUAL_OVR": "Aufgrund der manuellen Außerkraftsetzung des Systemcontrollers befindet sich Ihr System im Modus „Mit dem Netz verbunden“).",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "Mikronetz-Verbindungsgerät (MID) verbindet (wenn geschlossen) oder trennt (wenn geöffnet) Ihr Haus vom Stromnetz."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Dezentrale Energieressource (DER)-Relais DER L1 verbindet im geschlossenen Zustand Ihre Encharges und PV auf Leitung 1 bzw. 2 mit Ihrem Zuhause"
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "SRT_L1_L2": {
      "val": "SRT L1_L2"
    },
    "SRT_L1_L3": {
      "val": "SRT L1_L2"
    },
    "EC1_L1": {
      "val": "EC1 L1",
      "info": "Wenn die EC1-L1- und L2-Relais geschlossen sind, werden Ihre Batterien oder IQ8 PV mit Ihren Lasten zu Hause verbunden. Sie funktionieren von Phase zu Phase und haben keinen Neutralleiter."
    },
    "EC1_L2": {
      "val": "EC1 L2"
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "IQ Battery L1 und L2 Relais verbinden im geschlossenen Zustand Ihre Akkus mit Ihren Hauslasten. Sie arbeiten von Leitung zu Leitung und haben keinen Neutralleiter."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "Die Relais PV L1 und L2 verbinden im geschlossenen Zustand Ihre IQ8 PV-Anlage mit den Verbrauchern in Ihrem Heimnetz. Sie arbeiten im Leiter-Leiter-Betrieb und haben keinen Nullleiter."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "Die Relais PV L1 und L2 verbinden im geschlossenen Zustand Ihre IQ PV-Anlage mit den Verbrauchern in Ihrem Heimnetz. Sie arbeiten im Leiter-Leiter-Betrieb und haben keinen Nullleiter."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "NFT L1",
      "info": "NFT ist der Neutralformtransformator. Es stellt sicher, dass Ihr System im Netzfernen-Modus betrieben werden kann. Das NFT L1-Relais schaltet Ihr NFT im geschlossenen Zustand ein. Das geschlossene NFT N-Relais verbindet den Neutralleiter von NFT mit Ihren Heimlasten."
    },
    "NFT_N": {
      "val": "NFT N"
    },
    "GID_L1": {
      "val": "GID L1",
      "info": "Wenn die Relais GID L1 und L2 geschlossen sind verbinden sie Ihr Generator mit Ihren Heimlasten."
    },
    "GID_L2": {
      "val": "GID L2"
    },
    "NFT_L2": {
      "val": "NFT L2",
      "info": "NFT ist der Neutralformtransformator. Es stellt sicher, dass Ihr System im Netzfernen-Modus betrieben werden kann. Das NFT L2-Relais schaltet Ihr NFT im geschlossenen Zustand ein. Das geschlossene NFT N-Relais verbindet den Neutralleiter von NFT mit Ihren Heimlasten."
    },
    "DER1_L1": {
      "val": "DER1 L1",
      "info": "Wenn die DER1-L1- und L2-Relais geschlossen sind, werden Ihre Batterien oder IQ8 PV mit Ihren Lasten zu Hause verbunden. Sie funktionieren von Phase zu Phase und haben keinen Neutralleiter."
    },
    "DER1_L2": {
      "val": "DER1 L2"
    },
    "DER2_L1": {
      "val": "DER2 L1",
      "info": "Wenn die Relais DER2 L1 und L2 geschlossen sind verbinden sie Ihr IQ8 PV-Gerät mit Ihren Heimlasten. Sie arbeiten von Leitung zu Leitung und haben keinen Neutralleiter."
    },
    "DER2_L2": {
      "val": "DER2 L2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "Wenn diese Relais geschlossen werden, verbinden sie Ihre Lasten mit der Stromquelle."
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "Die Relais der verteilten Energieressourcen (DER) DER L1, DER L2, DER L3 und DER N verbinden im geschlossenen Zustand Ihre IQ Battery und Ihren IQ Mikrowechselrichter auf Leitung 1, 2, 3 bzw. dem Neutralleiter mit Ihrem Zuhause"
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "Die Relais der verteilten Energieressourcen (DER) DER L1, DER L2 und DER N verbinden im geschlossenen Zustand Ihre IQ Battery und Ihren IQ-Mikrowechselrichter auf Leitung 1, 2 bzw. dem Neutralleiter mit Ihrem Zuhause"
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "Die Relais der verteilten Energieressourcen (DER) DER L1 und DER N verbinden, wenn sie geschlossen sind, Ihre IQ Battery und Ihren IQ-Mikrowechselrichter auf der Leitung bzw. dem Neutralleiter mit Ihrem Zuhause"
    },
    "open": "Offen",
    "closed": "Geschlossen"
  }, _defineProperty(_liveVitalStats, "powered", "Gespeist"), _defineProperty(_liveVitalStats, "notPowered", "Nicht gespeist"), _defineProperty(_liveVitalStats, "niu", "Außer Gebrauch"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "EC1 L1, L2"), _defineProperty(_liveVitalStats, "infoNftL1N", "NFT L1, N"), _defineProperty(_liveVitalStats, "infoGidL1L2", "GID L1, L2"), _defineProperty(_liveVitalStats, "infoNftL2N", "NFT L2, N"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "DER1 L1, L2"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "DER2 L1, L2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "Der Unterschied zwischen dem Versorgungsnetz und der Mikronetz-Spannung und -Frequenz wird aufgrund des Spannungsabfalls am Mikronetz-Verbindungsgeräts (MID) beobachtet."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "Das Blockschaltbild des Systemcontrollers dient nur zur Veranschaulichung."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "Systemcontroller-Relais"), _defineProperty(_liveVitalStats, "bmuWarning", "BMU-Warnung"), _defineProperty(_liveVitalStats, "bmuL1Error", "BMU Level 1 Fehler"), _defineProperty(_liveVitalStats, "bmuL2Error", "BMU Level 2 Fehler"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Akkuzellenspannung auf Maximum Warnung"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Akkuzellenspannung auf Minimum Warnung"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Akkuzellenspannung Spannungsungleichgewicht"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Speicher-FET-Schalter Überspannungswarnung"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Akkuzellenspannung auf Maximum Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Akkuzellenspannung auf Minimum Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Akkuzellentemperatur auf Maximum Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Akkuzellentemperatur auf Minimum Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Entladung auf die Stromstärke Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "Keine BMU Verbindungen."), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Feldeffekttransistor Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Offene Sicherung Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Feldeffekttransistor Treiber Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Voltage Sense offene Leitung Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Feldeffekttransistor Übertemperatur Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Wärmeleitung offen Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Vorladung des 24V Schaltkreises Fehler Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Vorladung der Speicher-Zellenspannung Fehler Level"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Akkuzellenspannung auf Maximum Fehler Level 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Akkuzellenspannung auf Minimum Fehler Level 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Akkuzellentemperatur auf Maximum Fehler Level 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Akkuzellentemperatur auf Minimum Fehler Level 2"), _defineProperty(_liveVitalStats, "gridMode", "Netz-Modus"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Netz gebundene",
    "info": "Batterie befindet sich im Modus „Mit dem Netz verbunden“. In diesem vorübergehenden Zustand bildet die Batterie kein Mikronetz, wenn das Netz nicht verfügbar ist.",
    "pcuInfo": "Der Mikro-Wechselrichter befindet sich im netzgekoppelten Modus. Es wird kein Mikronetz bilden, wenn das Netz nicht verfügbar ist."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "Netzverbunden",
    "info": "Batterie befindet sich im Modus „Mit dem Netz verbunden“ und kann bei Bedarf ein Mikronetz bilden.",
    "pcuInfo": "Der Mikro-Wechselrichter befindet sich im netzgekoppelten Modus und kann bei Bedarf ein Mikronetz bilden."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Netzfern",
    "info": "Die Batterie hat ein Mikronetz gebildet.",
    "pcuInfo": "Der Mikro-Wechselrichter hat ein Mikronetz gebildet."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Insel erkannt",
    "info": "Die Batterie hat erkannt, dass das Netzt nicht stabil/nicht verfügbar ist. Sie ist dabei, das Mikronetz zu bilden.",
    "pcuInfo": "Der Mikro-Wechselrichter hat festgestellt, dass das Netz instabil / nicht verfügbar ist. Es ist im Verfahren das Mikronetz zu bilden."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "Mikronetz bilden",
    "info": "Batterie wurde soeben neu gestartet. Sie hat erkannt, dass das Versorgungsnetz nicht verfügbar ist, und ist dabei, das Mikronetz zu bilden. Die Reduzierung der Lasten zu Hause hilft bei der Mikronetz-Bildung.",
    "pcuInfo": "Der Mikro-Wechselrichter wurde gerade neu gestartet. Es wurde festgestellt, dass das Versorgungsnetz nicht verfügbar ist und gerade das Mikronetz bildet. Die Reduzierung der Hauslast hilft bei der Bildung von Mikronetzen."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Falsch",
    "info": "Ungültigen Netzmodus für die Batterie erhalten.",
    "pcuInfo": "Ungültiger Netzmodus für Mikro-Wechselrichter empfangen."
  }), _defineProperty(_liveVitalStats, "infoGridModes", "Netz-Modus"), _defineProperty(_liveVitalStats, "ledStatus", "LED-Status"), _defineProperty(_liveVitalStats, "phase", "Phase"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "In jeder Batterie sind %{pcuLength} IQ8X-BAT Mikro-Wechselrichter enthalten."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "Ein positiver Wert für die Leistung des Mikro-Wechselrichters (kW) zeigt an, dass sich der Speicher entlädt, während ein negativer Wert für die Leistung (kW) anzeigt, dass der Speicher geladen wird."), _defineProperty(_liveVitalStats, "infoPcuMicro", "IQ8X-BAT Mikro-Wechselrichter"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "IQ8D-BAT Microinverters"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "In jedem Akku befinden sich %{pcuLength} IQ8D-BAT Microinverters."), _defineProperty(_liveVitalStats, "pcu", "Mikro"), _defineProperty(_liveVitalStats, "enph_oper_state", "Staat"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Leerlauf"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "Startet"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Entdeckung über Stromleitungskommunikation (SPS) in Bearbeitung"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normal (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normal (Durchbrechend)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Betrieb im konstanten Gleichspannungsmodus."
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normal (Bereithalten)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Herunterfahren (Schutzfehler)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Herunterfahren (Netzfehler)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normal (DCR Check)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Unbekannt"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Firmware-Fehler"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Deaktiviert (Host-Abschaltung)"
  }), _defineProperty(_liveVitalStats, "ac_power", "Wechselstrom"), _defineProperty(_liveVitalStats, "signalStrength", "Signalstärke"), _defineProperty(_liveVitalStats, "commOk", "Befehl Ok"), _defineProperty(_liveVitalStats, "noComm", "Kein Befehl"), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Unbekannt"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "LED-Status",
    "code": {
      "-1": "Unbekannt",
      "0": "Fehler braucht Service",
      "1": "BMU L1-Fehler",
      "2": "Hohe Temperatur",
      "3": "DC-Schalter AUS",
      "4": "Keine Kommunikation mit dem Gateway",
      "5": "Kommunikationen verbunden, aber nicht herausgefordert",
      "6": "Kommunikationen verbunden und herausgefordert",
      "7": "Upgrade fehlgeschlagen",
      "8": "BC-Update in Arbeit",
      "9": "BMU-Update in Arbeit",
      "10": "PCU-Update in Arbeit",
      "11": "Ruhemodus",
      "12": "Laden",
      "13": "Entladen",
      "14": "Die Batteriekapazität liegt dazwischen: 75-100%",
      "15": "Die Batteriekapazität liegt dazwischen: 50-75%",
      "16": "Die Batteriekapazität liegt dazwischen: 25-50%",
      "17": "Die Batteriekapazität liegt dazwischen: 0-25%",
      "18": "System AN"
    },
    "enpowerRow": {
      "code": {
        "-1": "Unbekannt",
        "0": "Fehler des System Controllers (Netzverbunden)",
        "1": "Fehler des System Controllers (Netzfern)",
        "2": "Der System Controller befindet sich im Schnellabschaltungs-/manuellen Übersteuerungsmodus",
        "3": "System Controller ist Netzfern; DERs getrennt",
        "4": "System Controller betriebsbereit, kann keine IQ Batteries über CAN erkennen (Netzverbunden)",
        "5": "System Controller betriebsbereit, kann nicht mindestens eine IQ Battery über CAN erkennen (Netzverbunden)",
        "6": "System Controller betriebsbereit, kann nicht mindestens eine IQ Battery über CAN erkennen (Netzfern)",
        "7": "System Controller Netzfern; SoC-Wiederherstellung durchführen",
        "8": "Der System Controller synchronisiert sich mit dem Netz",
        "9": "FW-Upgrade des System Controllers (Netzverbunden)",
        "10": "FW-Upgrade des Systemcontrollers (Netzfern)",
        "11": "Systemcontroller EIN, Wird gebootet",
        "12": "System Controller AN und Netzverbunden",
        "13": "System Controller AN und Netzfern",
        "14": "System Controller AUS"
      }
    },
    "info": {
      "safetyIssue": "Keiner der LED-Status stellt ein Sicherheitsproblem dar",
      "title": {
        "flashingRed": "Rot blinkend",
        "flashingYellow": "Gelb blinkend",
        "softPulseYellow": "Leicht Gelb pulsierend",
        "softPulseBlue": "Leicht Blau pulsierend",
        "softPulseGreen": "Leicht Grün pulsierend",
        "solidRed": "Durchgehend rot.",
        "solidYellow": "Fest Gelb",
        "solidBlueOrGreen": "Einfarbig blau oder grün",
        "ledOff": "Aus"
      },
      "desc": {
        "flashingRed": "Update fehlgeschlagen oder die Batterie befindet sich im Fehlerzustand. Wenden Sie sich an Ihren Installateur oder den Support von Enphase.",
        "flashingYellow": "Aktualisierung im Gange.",
        "softPulseYellow": "Schlafmodus aktiviert.",
        "softPulseBlue": "Entladen.",
        "softPulseGreen": "Laden.",
        "solidRed": "Inbetriebnahme.",
        "solidYellow": "Wegen hoher Temperatur nicht in Betrieb. Weitere Einzelheiten finden Sie unter \"IQ Battery-Fehlerbehebung\" A.",
        "solidBlueOrGreen": "Leerlauf. Farbübergänge zwischen Blau und Grün, wenn sich der Ladezustand ändert. Der Ladestatus wird in der Enphase-App aktualisiert. Siehe „IQ Battery Troubleshooting“ C für weitere Einzelheiten.",
        "ledOff": "Nicht in Betrieb. Weitere Einzelheiten finden Sie unter \"IQ Battery-Fehlerbehebung\" B."
      }
    }
  },
  "updatePending": {
    "title": "Daten-Upload läuft",
    "content": "Ihr gateway lädt Ihre Systemdaten in die Enphase Cloud hoch. Dies geschieht, wenn das gateway einige Zeit offline war. Normalerweise dauert es 1 Stunde für jeden Tag, an dem das gateway offline ist. Keine Sorge, die Nachricht verschwindet, sobald alle Daten hochgeladen sind.",
    "envoyDataTitle": "Daten hochladen",
    "envoyDataContent": "Ihr System hat sich vor kurzem mit dem Internet verbunden und benötigt einige Zeit, um Ihre Daten hochzuladen. Es kann bis zu einer Stunde für jeden Tag dauern, an dem Sie offline waren."
  },
  "bkpConfig": {
    "title": "Backup-Konfiguration",
    "0": "Nicht ausgewählt",
    "1": "Teilweise Home-Backup",
    "2": "Vollständige Home-Backup"
  },
  "set": "Konfiguration",
  "change": "Veränderung",
  "allTopics": "Alle Themen",
  "referFriends": {
    "title": "Freunde empfehlen",
    "subTitle_1": "die ",
    "subTitle_2": " erhalten sollen und bekommen Sie selbst ",
    "description_1": "Sowohl Sie als auch Ihr Freund können nach dem Kauf und der Aktivierung eines neuen Enphase-Solar- oder Speichersystems über den unten stehenden Link jeweils eine Geschenkkarte im Wert von ",
    "description_2": " erhalten.",
    "description_3": "Sowohl Sie als auch Ihr Freund können nach dem Kauf und der Aktivierung eines neuen Enphase-Solar über den unten stehenden Link jeweils eine Geschenkkarte im Wert von ",
    "urlHeading": "Deine Empfehlungs-URL",
    "shareButton": "Teilen Sie Ihren Empfehlungslink",
    "copyButton": "Kopieren Sie Ihren Empfehlungslink",
    "termsConditions": "Geschäftsbedingungen",
    "applyTerms": "anwenden.",
    "toastMessage": "Empfehlungslink wurde in Ihre Zwischenablage kopiert.",
    "shareMessage_1": "Hey! Haben Sie gewusst, dass mein Haus mit Solarstrom versorgt wird? Wenn Sie daran gedacht haben auf Solarstrom umzusteigen, jetzt ist die Zeit dafür. Ich habe einen exklusiven Empfehlungslink, den Sie benutzen können, um ",
    "shareMessage_2": " zu erhalten, wenn Sie einen neuen Enphase Solar-System aktivieren.",
    "shareMessageAU_1": "Hey! Getting Enphase solar for my home is one the best investments I've made so I'm sharing the sunshine. If you’re considering ways to lower your electricity bills and protect your pocket, I have a referral link that you can use to receive ",
    "shareMessageAU_2": " when you go solar with Enphase. Check it out:",
    "tncTitle": "Geschäftsbedingungen des Enphase Empfehlungsprogramms:",
    "important_title": "Wichtig",
    "important_subtitle": "Sie und Ihr Freund haben nur dann Anspruch auf den Gutschein, wenn:",
    "important_1": "Zwischen der vollständigen Registrierung und der Installation liegt eine Pause von mindestens 15 Tagen.",
    "important_2": "Die E-Mail-Adresse, mit der die Empfehlung empfangen oder registriert wird, wird nach der Installation zur Aktivierung des Systems verwendet",
    "tnc": {
      "1": "Begrenzt auf 30 Empfehlungen pro Kunde. ",
      "2": "Empfohlene müssen den von Ihnen freigegebenen Link verwenden und ihre Kontaktinformationen Enphase über die angegebene Enphase-Website am oder vor dem 31. Dezember 2022 zur Verfügung stellen.",
      "3": "Wenn Enphase oder seine Installateure bereits über die vom Empfohlenen bereitgestellte E-Mail-ID verfügen, ist Ihr Empfohlener nicht dazu berechtigt, an diesem Empfehlungsprogramm teilzunehmen.",
      "4": "Sie und die Person, die Sie empfohlen haben können, die Geschenkkarten nur erhalten, wenn der Empfohlene innerhalb von 2 Jahren nach Erhalt der Informationen der Empfehlung auf der Enphase-Website die Enphase-Produktaktivierung kauft, installiert und abschließt.",
      "5": "Nachdem Sie von Enphase die Mitteilung erhalten haben, dass Sie und die Person, die Sie empfohlen haben, berechtigt sind, die Geschenkkarte zu erhalten, müssen Sie die Geschenkkarte innerhalb von 90 Tagen nach Erhalt dieser Mitteilung anfordern.",
      "6_One": "Wenn keine Geschenkkarten im Wert von ",
      "6_Two": " verfügbar sind, so kann Enphase diese durch einen anderen Preis mit gleichem oder höherem Wert ersetzen.",
      "7": "Der ausgewählte Geschenkkartenbetrag spiegelt eine Schätzung des Werts der Empfehlung angesichts Marketingausgaben wider, die bei der Rekrutierung neuer Kunden eingespart wurden.",
      "8": "Wenn Sie oder die Person, die Sie empfohlen haben vom Empfehlungsprogramm zurücktreten oder die Geschenkkartenprämie nicht erhalten möchten, wenden Sie sich bitte an Enphase",
      "9": "Enphase ist weder verantwortlich für verwirrende, falsche, unvollständige oder verspätete Einsendungen noch für typografische Fehler, Probleme beim Hoch- oder Herunterladen der Empfehlungsinformationen oder für andere technische Störungen von Netzwerken, Internet, elektronischen Geräten oder Webseiten.",
      "10": "Enphase behält sich das Recht vor, dieses Empfehlungsprogramm ohne vorherige Ankündigung zu ändern, auszusetzen oder zu beenden.",
      "11": "Dieses Empfehlungsprogramm ist ungültig, wenn es verboten ist.",
      "12": "Damit Enphase eine Empfehlung zuweisen kann, muss der einzigartige Link sowohl von Ihnen als auch von der Person, die Sie empfohlen haben, verwendet werden.",
      "13": "Zwischen der vollständigen Registrierung und der Installation muss eine Pause von mindestens 15 Tagen liegen.",
      "14": "Die E-Mail-Adresse, mit der die Überweisung empfangen oder registriert wird, muss nach der Installation zur Aktivierung des Systems verwendet werden."
    }
  },
  "contactPVMaintainer": "Wenden Sie sich an den Solar-Instandhalter",
  "contactStorageMaintainer": "Wenden Sie sich an den Speicher-Instandhalter",
  "pvInstallerDetails": "Details des Solar-Installateurs",
  "storageInstallerDetails": "Details des Speicher-Installateurs",
  "customerSupport": "Kundensupport",
  "soFarToday": "So weit heute,",
  "forSelectedPeriod": "Für den ausgewählten Zeitraum,",
  "energyIndependence": {
    "title": "Energieunabhängigkeit",
    "subTitle": "Misst, wie unabhängig Sie vom Netzbetreiber sind",
    "formulaText": "Berechnung der Energieunabhängigkeit:",
    "formula": "[1-(Bezogen/Verbraucht)] * 100%",
    "formulaForGenerator": "[1 - {(Netzimport + Generatorimport) / Verbrauch}] * 100%",
    "desc1": "Die Energieunabhängigkeit ist ein Maß für die Autarkie Ihrer Stromversorgung. Dies bedeutet, dass Sie selbst Ihren gesamten Energiebedarf decken können.",
    "unknown": "Dieser Wert ist nicht bekannt, da Ihr System keine Verbrauchsdaten gemeldet hat.",
    "0": "Ihr gesamter Energieverbrauch wird durch eine externe Quelle gedeckt (z. B. vom Netzbetreiber). Das bedeutet, der Stand Ihrer Energieunabhängigkeit liegt bei: %{periodValue} %{eiValue}%.",
    "100": "Für Ihren Energieverbrauch werden keine externe Quellen, wie z. B. der Netzbetreiber, herangezogen. Das bedeutet, der Stand Ihrer Energieunabhängigkeit liegt bei: %{periodValue} %{eiValue}%.",
    "value": "%{geValue}% Ihres Energieverbrauchs werden durch externe Quellen, wie z. B. den Netzbetreiber, gedeckt. Das bedeutet, der Stand Ihrer Energieunabhängigkeit liegt bei: %{periodValue} %{eiValue}%.",
    "forTodayPeriod": "Heute ist",
    "forSelectedPeriod": "Der ausgewählte Zeitraum ist",
    "addStorageTitle": "Speicher hinzufügen",
    "addStorage": "um Ihre Energieunabhängigkeit zu erhöhen.",
    "addStorageTitleWB": "Solar oder Speicher hinzufügen",
    "addStorageWB": "erhöht Ihre Energieunabhängigkeit.",
    "clarify": "Energieunabhängigkeit beinhaltet keine exportierte Energie und sollte nicht mit Net Metering (oder Nettoenergie) verwechselt werden, was der Unterschied zwischen importierter und exportierter Energie ist"
  },
  "backupHistory": {
    "backupEvents": "Gesamt-Back-Up-Ereignisse"
  },
  "eventHistory": {
    "totalEvents": "Ereignisse insgesamt",
    "events": "Gegenstand/Ereignis",
    "deviceImpacted": "Betroffenes Gerät",
    "recommendedAction": "Empfohlene Aktion",
    "noBackupHistoryFound": "Keine Sicherungshistorie gefunden",
    "eventStatus": "Ereignisstatus"
  },
  "siteActivationStage": {
    "title": " hat die Aktivierung Ihres Enphase-Systems eingeleitet, ",
    "learnToUse": "Erfahren Sie, wie Sie mit der Enphase-App Ihr neues Enphase-System überwachen können."
  },
  "sfdcChatBot": {
    "exitConfirmation": "Möchten Sie den \"chatte mit uns\" wirklich schließen?",
    "sfdcChatSubject": "Chat über die Enphase App",
    "offlineSupport": "Leider sind unsere Agenten offline. Bitte hinterlassen Sie uns eine Nachricht."
  },
  "pushN": {
    "ok": "Ok, geh dorthin",
    "stay": "Bleib hier",
    "permMsg": "Sie haben eine Benachrichtigung für die Site %{siteName} erhalten. Wechseln Sie zu dieser Site, um die Benachrichtigung anzuzeigen."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "Welchen Modus muss ich auswählen?",
    "autofillRatePlanExistFAQ": "Warum wird mein Tarif nicht aufgeführt?",
    "autofillRatePlanMatchFAQ": "Warum stimmen die Angaben nicht mit denen auf meiner Rechnung überein?",
    "autofillTariffNote": "Wenn Sie Schwierigkeiten haben, Ihre Tarifbezeichnung bzw. Ihren Tarifcode zu finden, wenden Sie sich bitte an Ihr Stromversorgungsunternehmen.",
    "whtBaslineElecRate": "Wie hoch ist Ihr Grundauszahlungstarif für Strom? ",
    "doElecPayRateVaryWeekends": "Variiert Ihr Stromauszahlungstarif am Wochenende? ",
    "doElecPayRateVarySeasonaly": "Variiert Ihr Stromauszahlungtarif saisonal? ",
    "elecPayGoesUpWithUsage": "Ihre Stromauszahlungstarif steigt mit zunehmendem Verbrauch? ",
    "pRatePeakOffPecakChanges": "Ihre Stromauszahlungstarif hat Spitzen- und Nebenzeitenänderungen? ",
    "ratePerUnitOfSolar": "Wie hoch ist Ihr Auszahlungstarif pro erzeugter Solarenergieeinheit? ",
    "payOutRate": "Auszahlungstarif ",
    "tarifeditorConstants1": "Struktur des Stromtarifs  ",
    "tarifeditorConstants2": "Konvertiert Energiedaten in äquivalente Wechselkurse  ",
    "tarifeditorConstants3": "Anzeigen/Bearbeiten des Stromtarifs Ihres Versorgungsunternehmens  ",
    "tarifeditorConstants4": "Informationen zu Stromimporttarife finden Sie in Ihrer Stromrechnung im Abschnitt mit den Details Ihrer Stromkosten.  ",
    "tarifeditorConstants5": "Stromimporttarif hinzufügen  ",
    "tarifeditorConstants6": "Legen Sie die Tarifstruktur fest zu der Sie von Ihrem Energieversorger für den Import von Strom aus dem Netz belastet werden.  ",
    "tarifeditorConstants7": "Hinweis  ",
    "tarifeditorConstants8": "Die Informationen zum Stromtarif werden vom Gateway verwendet, um den optimalen Zeitplan für die Ladung und Entladung der Batterie zu ermitteln, wenn Ihr Batterieprofil auf „Energiesparmodus“ eingestellt ist. Das Ändern dieser Informationen ändert das Systemverhalten.",
    "tarifeditorConstants9": "Die Struktur des Stromtarifs wird nicht hinzugefügt  ",
    "tarifeditorConstants10": "Stromimporttarif hinzufügen  ",
    "tarifeditorConstants11": "Wählen Sie einen Modus um Ihre Details hinzuzufügen  ",
    "tarifeditorConstants12": "Auto-Auffüllen  ",
    "tarifeditorConstants13": "Importieren Sie Ihre Stromtarifstruktur anhand der Informationen Ihres Versorgungsunternehmens  ",
    "tarifeditorConstants14": "Manuell  ",
    "tarifeditorConstants15": "Geben Sie die Details der Stromtarifstruktur Ihres Versorgungsunternehmens manuell ein  ",
    "tarifeditorConstants16": "Postleitzahl  ",
    "tarifeditorConstants17": "Name des Versorgungsunternehmens  ",
    "tarifeditorConstants18": "Tarifname / Code  ",
    "tarifeditorConstants19": "Details zur Stromimporttarif  ",
    "tarifeditorConstants20": "Pauschalpreis ",
    "tarifeditorConstants21": "Gestaffelt ",
    "tarifeditorConstants22": "Nutzungszeit ",
    "tarifeditorConstants23": "Fester Tarif  ",
    "tarifeditorConstants24": "Haftungsausschluss  ",
    "tarifeditorConstants25": "Die gemeldeten Stromtarife sind gebündelte Änderungen die nur verbrauchsabhängige Tarifkomponenten enthalten. Feste Gebühren Anpassungen Gutschriften Anreize Regionen Besonderheiten und Steuern werden nicht berücksichtigt.  ",
    "tarifeditorConstants26": "Bestätigen & Speichern  ",
    "tarifeditorConstants27": "Stromtarif Name  ",
    "tarifeditorConstants28": "Basisstromtarif  ",
    "tarifeditorConstants29": "Sind Sie sicher dass Sie die Details wirklich zurücksetzen möchten?  ",
    "tarifeditorConstants30": "Ihr Stromtarif hat Spitzen- und Nebenkosten?  ",
    "tarifeditorConstants31": "Ihr Stromtarif steigt mit zunehmendem Verbrauch?  ",
    "tarifeditorConstants32": "Fester Stromtarif der nicht variiert.  ",
    "tarifeditorConstants33": "Der Stromtarif steigt mit zunehmendem Verbrauch.  ",
    "tarifeditorConstants34": "Variiert Ihr Stromtarif saisonal?  ",
    "tarifeditorConstants35": "Variiert Ihr Stromtarif am Wochenende?  ",
    "tarifeditorConstants36": "Was ist Ihr Grundstromtarif?  ",
    "tarifeditorConstants37": "Fester Stromtarif der nicht variiert.  ",
    "tarifeditorConstants38": "Die Stromtarifstruktur variiert nur saisonal.  ",
    "tarifeditorConstants39": "Die Stromtarifstruktur variiert am Wochenende.  ",
    "tarifeditorConstants40": "Die Stromtarifstruktur variiert saisonal und am Wochenende.  ",
    "tarifeditorConstants41": "Der Stromtarif steigt mit zunehmendem Verbrauch.  ",
    "tarifeditorConstants42": "Basisstromtarif:  ",
    "tarifeditorConstants43": "Die Stromtarifstruktur variiert nur saisonal.  ",
    "tarifeditorConstants44": "Der Stromtarif hat Spitzen- und Nebenkosten.  ",
    "tarifeditorConstants45": "Die Stromtarifstruktur variiert nur am Wochenende.  ",
    "tarifeditorConstants46": "Stromexporttarif hinzufügen  ",
    "tarifeditorConstants47": "Fügen Sie die Tarifstruktur hinzu zu der Sie für den Export Ihres solar erzeugten Stroms in das Netz bezahlt werden.  ",
    "tarifeditorConstants48": "Wählen Sie Ihren Stromexportplan  ",
    "tarifeditorConstants49": "So wählen Sie Ihren Stromexportplan aus  ",
    "tarifeditorConstants50": "Sie können diese Informationen in Ihrer Stromrechnung unter dem Abschnitt überprüfen in dem Ihre Gutschriften und Anpassungen hervorgehoben sind.  ",
    "tarifeditorConstants51": "NEM (Netto-Messung)  ",
    "tarifeditorConstants52": "Überprüfen Sie dies wenn Sie zu Hause eine Netz-Messgerät-Konfiguration haben. <b style='font-weight: bold;'>Ihr Stromimporttarif wird sowie Ihr Stromexporttarif kopiert.</b>  ",
    "tarifeditorConstants53": "Netto-FIT (Netto-Einspeisetarif)  ",
    "tarifeditorConstants54": "Überprüfen Sie dies wenn Sie nur für Solarenergie bezahlt werden die von Ihrem Haus aus wieder ins Netz eingespeist wird.  ",
    "tarifeditorConstants55": "Brutto-FIT (Bruttoeinspeisetarif)  ",
    "tarifeditorConstants56": "Überprüfen Sie dies wenn Sie für jede von Ihren Solarmodulen erzeugte Stromeinheit bezahlt werden.  ",
    "tarifeditorConstants57": "Sonstige  ",
    "tarifeditorConstants58": "Überprüfen Sie dies wenn Sie einen anderen Plan haben.  ",
    "tarifeditorConstants59": "Angaben zur Stromexporttarif  ",
    "tarifeditorConstants60": "Struktur des Stromauszahlungstarifs  ",
    "tarifeditorConstants61": "Exportplan  ",
    "tarifeditorConstants62": "Stromexporttarif bearbeiten  ",
    "tarifeditorConstants63": "Ihr FIT-Plan zahlt Ihnen einen Festpreis pro exportierter Solarenergieeinheit?  ",
    "tarifeditorConstants64": "Zeitvariabler Tarif  ",
    "tarifeditorConstants65": "Der Stromauszahlungstarif hat Spitzen- und Nebenkosten  ",
    "tarifeditorConstants66": "Fester Stromauszahlungstarif der nicht variiert  ",
    "tec67": "Ausgangswert für Stromauszahlungsrate",
    "tec68": "Tarifname",
    "tec69": "Leider wird das automatische Ausfüllen für Ihre Tarifstruktur nicht unterstützt. Wir arbeiten daran, dies zu beheben. Zwischenzeitlich können Sie Ihren Tarif manuell einstellen.",
    "tec70": "Wir konnten den Namen Ihres Versorgungsunternehmens nicht über Ihre Postleitzahl bestimmen. Richten Sie den Tarif bitte manuell ein.",
    "tec71": "Wir konnten die Tarifdetails leider nicht ermitteln.",
    "tec72": "Namen des Versorgungsunternehmens auswählen",
    "tec73": "Suchen",
    "tec74": "Name/Code des Tarifs",
    "tec75": "Namen/Code des Tarifs auswählen",
    "tec76": "Tarif manuell einstellen",
    "tec77": "Erneut versuchen",
    "tec78": "SLadezeit auswählen",
    "tec79": "Batterien über das Netz laden",
    "from": "Von",
    "to": "Bis",
    "tec80": "Laden der Speicher über das Netz erfolgreich aktualisiert",
    "try_again": "Versuchen Sie es erneut.",
    "tec81": "Ihre Erfahrung bewerten",
    "tec82": "Waren die Daten hilfreich und genau?",
    "tec83": "Unwahrscheinlich",
    "tec84": "Am wahrscheinlichsten",
    "tec85": "Schreiben Sie uns bitte, wenn Sie Fragen haben oder Erläuterungen wünschen.",
    "tec86": "Sie möchten nicht, dass Ihre Batterien über das Netz aufgeladen werden?",
    "tec87": "Thank you for your valuable feedback",
    "talc": "Bitte versuchen Sie es später erneut.",
    "tec88": "Wie bewerten Sie die Nutzung des Tarif-Editors?",
    "tec89": "Hinweis",
    "tec90": "Aus Kauftarif kopieren",
    "tec91": "Tarifeinstellungen aus dem eingestellten Kauftarif kopieren",
    "tec92": "Tarif für Stromexport",
    "tec93": "Tarif für Stromimport",
    "tec94": "Der hier gezeigte Stromtarif wurde gemäß der unten gezeigten Tarifkomponenten gebündelt.",
    "tec95": "Beantworten Sie die unten stehenden Fragen, um Ihren Tariftyp festzulegen.",
    "tec96": "Ungültiger Zeitraum",
    "tec97": "%{time1} - %{time2} wurde bereits ausgewählt",
    "peak": "Höchststand",
    "aPeak": "Höchststand hinzufügen",
    "aSeason": "Saison hinzufügen",
    "season": "Saison",
    "eSeason": "Saison bearbeiten",
    "tec98": "Ungültige Eingabe. Der Wert muss höher als Tier %{Index} sein.",
    "tec99": "Ein Fehler ist aufgetreten, versuchen Sie es später erneut",
    "tec100": "Die Stromauszahlungsrate steigt bei steigender Nutzung.",
    "tec101": "Zeitabhängiger Tarif",
    "tier": "Tier",
    "offPeak": "Nieder",
    "tec102": "Tarif für Stromimport bearbeiten",
    "tec103": "manuelle Konfiguration",
    "tec104": "AutoFill-Tarif",
    "tec105": "Modus auswählen",
    "tec106": "Wählen Sie einen Modus um Ihre Details bearbeiten",
    "tec107": "Tarifnamen auswählen",
    "tec108": "Die Informationen zum Stromtarif werden vom Gateway verwendet, um den optimalen Zeitplan für die Ladung und Entladung der Batterie zu ermitteln. Das Ändern dieser Informationen ändert das Systemverhalten.",
    "tec109": "Die Informationen zum Energietarif werden zur Berechnung Ihrer Energieeinsparungen über Zeit verwendet und helfen uns, Ihnen personalisierte Empfehlungen zur Einsparung von Energiekosten zukommen zu lassen.",
    "tec110": "Wie hoch ist Ihr Auszahlungstarif pro exportierter Solarenergieeinheit?",
    "tec111": "Tarif für Stromimport wurde hinzugefügt",
    "tec112": "Tarif für Stromimport wurde aktualisiert",
    "tec113": "Tarif für Stromimport wurde zurückgesetzt",
    "tec114": "Tarif für Stromexport wurde hinzugefügt",
    "tec115": "Tarif für Stromexport wurde aktualisiert",
    "tec116": "Tarif für Stromexport wurde zurückgesetzt",
    "rate": "Tarif",
    "tec117": "Feste Auszahlungsrate",
    "tec118": "Sonstige (Gestaffelt )",
    "tec119": "Sonstige (Nutzungszeit )",
    "tec120": "Sonstige (Pauschalpreis  )",
    "tec121": "Gross FIT",
    "tec122": "Net FIT (Zeitabhängiger Tarif)",
    "tec123": 'Net FIT (Pauschalpreis  )',
    "tec124": "NEM",
    "tec125": "Fester Stromtarif der nicht variiert. Die Stromtarifstruktur variiert nur saisonal.",
    "tec126": "Fester Stromtarif der nicht variiert. Die Stromtarifstruktur variiert nur am Wochenende.",
    "tec127": "Fester Stromtarif der nicht variiert. Die Stromtarifstruktur variiert saisonal und am Wochenende.",
    "tec128": "Fester Stromauszahlungstarif der nicht variiert. Die Stromtarifstruktur variiert nur saisonal.",
    "tec129": "Fester Stromauszahlungstarif der nicht variiert. Die Stromtarifstruktur variiert nur am Wochenende.",
    "tec130": "Fester Stromauszahlungstarif der nicht variiert. Die Stromtarifstruktur variiert saisonal und am Wochenende.",
    "tec131": "Der Stromtarif hat Spitzen- und Nebenkosten. Die Stromtarifstruktur variiert nur saisonal.",
    "tec132": "Der Stromtarif hat Spitzen- und Nebenkosten. Die Stromtarifstruktur variiert nur am Wochenende.",
    "tec133": "Der Stromtarif hat Spitzen- und Nebenkosten. Die Stromtarifstruktur variiert saisonal und am Wochenende.",
    "tec134": "Der Stromauszahlungstarif hat Spitzen- und Nebenkosten. Die Stromtarifstruktur variiert nur saisonal.",
    "tec135": "Der Stromauszahlungstarif hat Spitzen- und Nebenkosten. Die Stromtarifstruktur variiert nur am Wochenende.",
    "tec136": "Der Stromauszahlungstarif hat Spitzen- und Nebenkosten. Die Stromtarifstruktur variiert saisonal und am Wochenende.",
    "tec137": "Der Stromtarif steigt mit zunehmendem Verbrauch. Die Stromtarifstruktur variiert nur saisonal.",
    "tec138": "Die Stromauszahlungsrate steigt bei steigender Nutzung. Die Stromtarifstruktur variiert nur saisonal.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Prozentuale Werte im Zeitverlauf anzeigen",
    "tec141": "Stromimportrate erfolgreich hinzugefügt",
    "tec142": "Bitte bewerten Sie Ihre Erfahrung mit dem Hinzufügen von Stromtarifen",
    "tec143": "Unzufrieden",
    "tec144": "Zufrieden",
    "tec145": "Überspringen",
    "tedc0": "Leistungskosten",
    "tedc1": "Ganztägiger Leistungspreis (24 Stunden)",
    "tedc2": "Ihr Stromtarif enthält eine Leistungspreiskomponente, die monatlich auf Ihre Stromrechnung aufgeschlagen wird.",
    "tedc3": "Ihr Strompreis enthält eine Leistungsgebührkomponente. Während der Spitzenzeiten wird der maximale Verbrauch für jedes %{time}-Minuten-Intervall während des Monats gemäß den folgenden Details berechnet",
    "tedc4": "%{time}-minütiger Maximalverbrauch",
    "tedc5": "Wählen Sie eine Stromtarifstruktur",
    "tet1": "Ich möchte mehr über das Hinzufügen eines Stromtarifs erfahren",
    "tet2": "In manchen Regionen ändert sich der Preis für Strom im Laufe des Tages oder in Abhängigkeit davon, wie viel Sie nutzen. Wenn das Profil auf den Energiesparmodus eingestellt ist, verwenden wir Ihren Stromtarif, um die optimale Batterieladung und -entladung zu planen.",
    "tet3": "Erste Schritte",
    "tet4": "Tippen Sie auf „Tarif für Stromimport hinzufügen“.",
    "tet5": "Geben Sie Ihre Daten ein.",
    "tet6": "Verwenden Sie „Automatisch ausfüllen“ oder „Manuell“, um Informationen zu Ihrem Tarif anzugeben. Sie benötigen möglicherweise eine aktuelle Stromrechnung, wenn Sie die Daten manuell eingeben möchten.",
    "tet7": "Automatisch ausfüllen",
    "tet8": "Wählen Sie Ihr Versorgungsunternehmen und den Plannamen oder -code aus den Drop-down-Menüs. Die App ruft Ihren Tarif für den Stromimport automatisch ab.",
    "tet9": "Manuell",
    "tet10": "Geben Sie in den einzelnen Feldern Daten ein. Sie benötigen möglicherweise eine aktuelle Stromrechnung, um die relevanten Informationen nachzuschlagen.",
    "tet11": "Tarif für Stromexport hinzufügen",
    "tet12": "Wenn Sie für das Wiedereinspeisen von Strom in das Netz eine Gutschrift erhalten, geben Sie als nächstes den Tarif für den Stromexport an. Tippen Sie auf „Tarif für Stromexport hinzufügen“, um loszulegen. Auch hier können Sie wählen, ob Sie Ihre Daten automatisch ausfüllen oder manuell eingeben möchten.",
    "tet13": "So bestimmen und nutzen wir Ihren Stromtarif",
    "undefined": "Andere (Gestuft)",
    "timeDiffError": "Start- und Endzeit sollten mindestens 15 Minuten voneinander abweichen",
    "periodOverlapError": "Dieser Zeitraum überschneidet sich mit einem der anderen Zeiträume",
    "peakConflictError": "Die Spitzenrate sollte höher sein als die nicht Spitzenrate",
    "isTimeValid": 'Die Startzeit muss vor der Endzeit liegen'
  },
  "appliance": {
    "info": "Um Ihr Zuhause während eines Netzausfalls über längere Zeit mit Strom zu versorgen, empfehlen wir Ihnen, Ihren Energieverbrauch zu minimieren und zu kontrollieren",
    "desc": "Schalten Sie unkritische Haushaltslasten aus, um die Batterielebensdauer zu verlängern.",
    "descSystem2_0AndEncharge": "Empfohlene Vorgehensweisen bei Netzstromausfall.",
    "largeAppliances": "Großgeräte",
    "useSparingly": "Sparsam verwenden",
    "essentialAppliances": "Grundlegende Geräte",
    "useNormally": "Normalerweise verwenden",
    "airConditioner": "Klimaanlage",
    "dishwasher": "Geschirrspüler",
    "poolPump": "Poolpumpe",
    "washingMachine": "Waschmaschine",
    "electricVehicle": "Elektrisches Fahrzeug",
    "electricDryer": "Elektrischer Trockner",
    "lights": "Beleuchtung",
    "laptop": "Laptop",
    "television": "Fernsehen",
    "refrigerator": "Kühlschrank",
    "wifiRouter": "Wi-Fi Router",
    "microwave": "Mikrowelle"
  },
  "rootedAlert": {
    "exitBtn": "Beenden",
    "proceedBtn": "Fortfahren",
    "agreeBtn": "Ich stimme zu",
    "warningLabel": "WARNUNG!",
    "warningTextInitial": "Ihr Gerät wurde anscheinend gerootet. Durch Rooten wird der Standard-Sicherheitsschutz kompromittiert und die auf Ihrem Gerät gespeicherten Daten werden gefährdet. Es ist nicht empfehlenswert, die Enphase App auf einem gerooteten Gerät auszuführen.",
    "warningTextFinal": "Wenn ich fortfahre, bestätige ich, dass ich verstehe und einverstanden bin, dass Enphase nicht für Fehlfunktionen oder andere Konsequenzen des Einsatzes der Enphase Anwendung auf diesem gerooteten Gerät haftbar gemacht werden kann."
  },
  "generator": {
    "exerciseModeOverlap1": "Die Trainingszeit überschneidet sich mit Ihrer Ruhezeit",
    "exerciseModeOverlap2": "bis",
    "exerciseModeOverlap3": "Möchten Sie fortfahren?",
    "dayInWeek": "Tag in einer Woche",
    "time": "Zeit",
    "duration": "Dauer",
    "frequency": "Frequenz",
    "save": "Bewaar",
    "edit": "BEWERKEN",
    "cancelRequest": "Verzoek annuleren",
    "activate": "Activeer",
    "okayText": "OKÉ, Begrepen!",
    "batteryUnavailable": "<span>Uw systeem heeft geen batterij. Wilt u uw generator controleren op basis van de acculading? <a href='https://estimator.enphaseenergy.com/login' target='_blank'>Opslag toevoegen</a></span>",
    "suspendedStateText": "Ihr Generator ist derzeit deaktiviert. Aktivieren Sie Ihren Generator, indem Sie über den Umschalter oben auf dem Bildschirm das Generatorprofil aktivieren.",
    "suspendedModalHeading": "Ihr Generator wird deaktiviert.",
    "suspendedModalHeading_1": "Ihr Generator wird auf der Grundlage des ausgewählten Profils eingeschaltet.",
    "suspendedModalSubheading": "Verwenden Sie zum Aktivieren des Generators die Umschalttaste oben auf dem Bildschirm.",
    "infoHeadng": "Generator",
    "infoSubheading": "<div style='font-size: 12px; font-weight: 300; line-height: 1.5'><div>When <span style='color: #F37320'>Enabled</span>, your generator will turn on and turn off based on the selected profile and grid availability. If your system is On Grid, your generator will be turned off irrespective of profiles selected.</div><div style='margin-top: 10px;'> You can disable your generator when not in use for e.g. when you are going for a vacation.<div></div>",
    "advancedSettings": "Erweiterte Einstellungen",
    "pendingRequest": "Anfrage steht aus",
    "disabled": "Uitschakelen",
    "disable": "Deaktivieren",
    "enabled": "Inschakelen",
    "waiting": "Wachten op informatie",
    "active": "Actief",
    "deviceDetails": "Wählen Sie ein intelligentes Profil, um Ihren %{manufacturer} %{modelNumber} zu steuern",
    "autoStart": "Automatische start",
    "autoStartSubheading": "Verwenden Sie diese Option, wenn Sie Ihren Generator einschalten möchten, sobald Ihr System in den Netzfern-Modus wechselt",
    "batteryOptimizationSubheading": "Verwenden Sie diese Option, wenn Sie Ihren Generator nur dann einschalten möchten, wenn die Speicher-Ladung unter einem bestimmten Wert liegt und Ihr System netzfern ist.",
    "batteryChargeThreshold": "Speicher-Ladungsschwelle:",
    "lowerLimit": "Ondergrens: ",
    "start": "Start: ",
    "stop": "Stopp: ",
    "upperLimit": "Obergrenze: ",
    "addQuietTime": "Kalme tijd toevoegen",
    "quietTime": "Kalme tijd",
    "quietTimeToggle": "Verwenden Sie diese Option, wenn Sie Ihren Generator während dieser Zeit nicht einschalten möchten. Wenn der Speicher die kritische Grenze erreicht, wird der Generator unabhängig von der Ruhezeit eingeschaltet.",
    "startTime": "Startzeit: ",
    "endTime": "Endzeit: ",
    "criticalChargeSettings": "Einstellungen für kritische Ladung:",
    "generatorLoadingToast": "Die Bestätigung über den Stromerzeugerstatus dauert länger als erwartet. Bitte sehen Sie später nochmals nach.",
    "exerciseMode": "Inspanning instellingen",
    "exerciseModeSubheading": "Dies wird verwendet, um den Generator in regelmäßigen Abständen automatisch zu betreiben, um ihn in einem guten Betriebszustand zu halten.",
    "batteryOptimization": "Start basierend auf dem Speicherladestand",
    "activateBatteryProfile": "Sie haben das Autostart-Profil ausgewählt. Bitte aktivieren Sie das Profil \"Start basierend auf Speicher-Niveau\", um die Ruhezeit hinzuzufügen",
    "manualMode": "Manueller Modus",
    "manualModeDescription": "Ihr Generator arbeitet derzeit im manuellen Modus. Bitte ändern Sie Ihren Generatormodus auf Auto oder wenden Sie sich an Ihren Installateur.",
    "generatorStartLimit": "Startlimit kann nicht unter 10 % liegen",
    "generatorStartStopLimit": "Startlimit und Stopplimit sollten eine Mindestdifferenz von 5 % aufweisen.",
    "generatorLimitDescription": "Damit können Sie verhindern, dass der Generator während bestimmter Zeiträume eingeschaltet wird. Der Generator wird eingeschaltet, wenn die Batterieladung unter die kritische Ladungsgrenze fällt.",
    "generatorQuietTime": "Ruhezeit",
    "generatorNormalTime": "Normale Zeit",
    "generatorEnableGenerator": "Generator aktivieren",
    "generatorDisableGenerator": "Generator deaktivieren",
    "automatic": "Automatisch",
    "ecoFriendly": "Umweltfreundlich"
  },
  "sgipStatic": {
    "applyForIncentive": "Bewerben Sie sich für den Sgip-Anreiz",
    "subheadingSgip": "Systembesitzer in Kalifornien, die den Kauf einer Enphase Batterie für Ihr Haus planen oder bereits getätigt haben, können SGIP beantragen",
    "applyNow": "Jetzt bewerben",
    "learnMore": "Lern mehr",
    "serviceFee": "* Servicegebühr kann anfallen",
    "enphaseRepresentative": "* Sie können von einem Enphase-Vertreter per Anruf/E-Mail kontaktiert werden",
    "documentsRequired": "Folgende Unterlagen sind für die Beantragung von Sgip-Anreize erforderlich:",
    "documentHeading1": "1. Aktuelle Stromrechnungen (Mindestens eine Rechnung der letzten 3 Monate)",
    "documentHeading2": "2. Vertragsdokument",
    "additionalInfo": "* Vor der Auszahlung des endgültigen Anreizes können zusätzliche Dokumente erforderlich sein"
  },
  "activationProgress": {
    "systemActivationInProgress": "Ihre Systemaktivierung ist im Gange",
    "completed": "Abgeschlossen",
    "viewDetails": "Details anzeigen",
    "activationCompleted": "Die Aktivierung ist zu 100 % abgeschlossen",
    "activationInProgress": "Aktivierung läuft",
    "devices": "Geräte",
    "status": "Status",
    "envoy": "Gateway",
    "encharge": "Batterie",
    "enpower": "Systemcontroller",
    "pvProduction": "PV-Produktion",
    "cosumptionCT": "Verbrauchs-CT",
    "systemOperational": "System betriebsbereit",
    "reporting": "Berichterstattung",
    "notReporting": "Nicht melden",
    "enabled": "Aktiviert",
    "notEnabled": "Nicht aktiviert",
    "producing": "Wird produziert",
    "verified": "Verifiziert",
    "notVerified": "Nicht verifiziert",
    "featuresNowEnable": "Die folgenden Funktionen sind jetzt aktiviert.",
    "featuresWillBeEnabled": "Die folgenden Funktionen werden aktiviert, sobald Ihre Systemaktivierung abgeschlossen ist:",
    "consumptionMonitoring": "Verbrauchsüberwachung",
    "liveStatus": "Live-Status",
    "stormGuard": "Sturmschutzfunktion",
    "batteryProfileSetting": "Akku-Profileinstellungen",
    "gridControl": "Netzsteuerung"
  },
  "prodIssue_faq_1": "Warum erzeugt eines meiner Panels weniger als die anderen?",
  "prodIssue_faq_2": "Es ist üblich, dass Paneele auf demselben Dach in der Energieerzeugung variieren. Viele Faktoren können diese Abweichungen verursachen, z. B. die Richtung der Paneele, die Beschattung durch Schornsteine oder Bäume und andere Hindernisse.",
  "accountNew": {
    "account": {
      "title": "Ihre Informationen",
      "title_alternate": "Persönliche Informationen",
      "save_changes": "Änderungen speichern",
      "name_label": "Name:",
      "phone_label": "Handynummer:",
      "phone_placeholder": "Telefonnummer",
      "first_name_placeholder": "Vorname",
      "last_name_placeholder": "Nachname",
      "email_placeholder": "E-Mail-Adresse",
      "email_label": "E-Mail:",
      "change_password": "Kennwort ändern",
      "current_password": "Aktuelles Kennwort:",
      "password_label": "Neues Kennwort:",
      "password2_label": "Neues Kennwort erneut eingeben:",
      "password_footnote": "Kennwörter müssen mindestens 6 Zeichen lang sein und mindestens eine Zahl oder ein Sonderzeichen enthalten.",
      "cancel_change_password": "Kennwort nicht ändern",
      "units_label": "Einheiten:",
      "units_metric": "Metrisch (°C, km)",
      "units_us": "Angloamerikanisch (°F, mi)",
      "locale_label": "Sprache",
      "equivalent_label": "Energieäquivalent:",
      "equivalent_display": "Beginnen mit",
      "notification_label": "E-Mails:",
      "preference_monthly_email": "Senden Sie mir eine monatliche Zusammenfassung der Systemleistung",
      "preference_enphase_email": "Senden Sie mir Newsletter, Werbeaktionen und Umfragen zu Enphase-Produkten und Dienstleistungen",
      "production_issues_email": "Benachrichtigen Sie mich über Probleme mit der Systemproduktion oder mit dem Service",
      "save_successful": "Die Informationen wurden gespeichert.",
      "save_successful_email": "Die Informationen wurden gespeichert. Lesen Sie folgenden Hinweis zur Änderung Ihrer E-Mail-Adresse.",
      "save_failed": "Die Informationen konnten nicht gespeichert werden.",
      "system_info": "Systeminformationen für %{site_name}",
      "system_weather": "Systemwetter",
      "show_system_weather": "Wetterfunktionen für diesen Standort anzeigen",
      "save": "Speichern"
    },
    "system_preferences": {
      "title": "Systemeinstellungen",
      "name_label": "Name:",
      "public_label": "Seite mit den öffentlichen Systemen:",
      "public_text_html": "Öffentliche Seite für mein System erstellen",
      "public_preview_link": "Öffentliche Seite in der Vorschau anzeigen",
      "public_help_link": "Mehr erfahren",
      "public_footnote": "Dadurch werden Funktione für die Freigabe in sozialen Netzwerken aktiviert, und Besucher können auf Ihr System zugreifen.",
      "display_label": "Systemnamen anzeigen als:",
      "save_changes": "Systemeinstellungen speichern",
      "save_location_changes": "Datenschutzeinstellungen speichern",
      "save_successful": "Ihre Systemeinstellungen wurden gespeichert.",
      "save_failed": "Systemeinstellungen konnten nicht gespeichert werden."
    },
    "validations": {
      "required": "Dieses Feld ist ein Pflichtfeld.",
      "password_too_short": "Ihr Kennwort muss mindestens sechs Zeichen lang sein und mindestens eine Ziffer oder ein Sonderzeichen enthalten.",
      "password_too_long": "Geben Sie weniger als 50 Zeichen ein.",
      "password_similar_to_username": "Ihr Kennwort darf nicht mit Ihrer E-Mail-Adresse identisch sein.",
      "password_too_weak": "Ihr Kennwort muss mindestens sechs Zeichen lang sein und mindestens eine Ziffer oder ein Sonderzeichen enthalten.",
      "password_weak": "Ihr Kennwort muss mindestens sechs Zeichen lang sein und mindestens eine Ziffer oder ein Sonderzeichen enthalten.",
      "password_good": "Kennwortstärke: gut",
      "password_strong": "Kennwortstärke: stark",
      "password_policy": "Ihr Kennwort muss mindestens %{pwd_min_length}–%{pwd_max_length} Zeichen lang sein und %{digit_in_pwd} Zahlen, %{uppercase_in_pwd} Großbuchstaben, %{lowercase_in_pwd} Kleinbuchstaben, %{special_character_in_pwd} Sonderzeichen und nur (~!@#$%^&*) enthalten.",
      "equalTo": "Bitte denselben Wert wiederholen.",
      "invalid_phone_number": "Geben Sie eine gültige Handynummer ein.",
      "empty_phone_number": "Geben Sie Ihre Handynummer ein.",
      "email_used": "E-Mail-ID ist bereits registriert. Versuchen Sie es erneut mit einer anderen E-Mail-ID oder $cHere, um Ihr Passwort zurückzusetzen.",
      "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
    }
  },
  "accountDelete": {
    "deleteAccount": "Konto löschen",
    "deletePopUpText": "Ihr Konto und die damit verbundenen personenbezogenen Daten würden gelöscht. Nach dem Löschen des Kontos werden Sie abgemeldet. Willst du fortfahren?",
    "deleteCnfText": "Ihr Konto und die damit verbundenen personenbezogenen Daten würden gelöscht, mit Ausnahme von Daten, die wir in Verbindung mit Ihrem Energiesystem aufbewahren müssen. Nach dem Löschen des Kontos werden Sie abgemeldet. Willst du fortfahren?",
    "yes": "Ja",
    "no": "Nein",
    "verificationCode": "Verifizierungs-Schlüssel",
    "enterCodeText": "Geben Sie den 4-stelligen Code ein, der an Ihre registrierte E-Mail-Adresse und die Handynummer gesendet wurde.",
    "didntReceive": "Code nicht erhalten?",
    "resend": "Erneut senden",
    "deleteCnfTextEnlm": "Ihr Konto und die damit verbundenen personenbezogenen Daten würden gelöscht, mit Ausnahme von Daten, die wir in Verbindung mit Ihrem Energiesystem aufbewahren müssen. Sie verlieren auch den Zugriff auf Enlighten Manager. Nach dem Löschen des Kontos werden Sie abgemeldet. Willst du fortfahren?",
    "deleteAdmin": "Ihr Konto kann nicht gelöscht werden, da Sie ein Enphase-Administrator sind",
    "verifyCode": "Code überprüfen",
    "logOutText": "Sie werden nach Überprüfung des Codes abgemeldet.",
    "confirmText": "Ihr Konto ist deaktiviert. Wir speichern personenbezogene Daten in Bezug auf Ihr Energiesystem, um Ihre Garantie zu erfüllen und Ihr System zu unterstützen.",
    "ok": "OK habe es",
    "activateCnfText": "Ihr Enphase-Konto ist nicht aktiv, da Sie Ihr Konto gelöscht haben. Möchten Sie es erneut aktivieren?",
    "activateText": "Die E-Mail-ID ist bei Enphase registriert. Es ist jedoch nicht aktiv, da es gelöscht wurde.",
    "click": "Klicken ",
    "activateAgain": "hier, um es wieder zu aktivieren",
    "activateAccount": "Konto aktivieren",
    "emailIDRegistered": "Die E-Mail-ID ist bei Enphase registriert. Es ist jedoch nicht aktiv, da es gelöscht wurde. $cHere, um es wieder zu aktivieren.",
    "deleteAccountPopupText": "Durch das Löschen Ihres Kontos wird Ihr Konto deaktiviert und alle mit Ihrem Konto verbundenen persönlichen Daten werden entfernt. Da Sie mit einem Energiesystem von Enphase verbunden sind, müssen wir Ihre personenbezogenen Daten aufbewahren, um die Produktgarantie, System-Upgrades und den Support zu unterstützen.",
    "learnMore": "Lern mehr",
    "accountdeletion": "Ihr Konto wird gerade gelöscht. Dieser Vorgang kann bis zu 30 Tage dauern und Sie können ein neues Konto erstellen, nachdem Ihr vorheriges Konto gelöscht wurde.",
    "incorrectEmailandPass": "Die von Ihnen eingegebene E-Mail-Adresse und das Passwort stimmen nicht mit unseren Aufzeichnungen überein. Bitte versuche es erneut.",
    "accountdeletioninfo": "Ihr Konto wird gerade gelöscht. Es kann bis zu 30 Tage dauern.",
    "WOAccntdeletePopup": "Durch das Löschen Ihres Kontos wird Ihr Konto deaktiviert und alle mit Ihrem Konto verbundenen persönlichen Daten werden entfernt.",
    "accountdelReq": "Antrag auf Kontolöschung",
    "verfcodedel": "Ihr Bestätigungscode zum Löschen des Enphase-Kontos",
    "accountActvReq": "Anfrage zur Kontoaktivierung",
    "codedelAccount": "Bestätigungscode zum Löschen des Enphase-Kontos",
    "codeDuration": "Dieser Code ist nur 15 Minuten lang gültig.",
    "userDelReq": "Der Benutzer hat die Option zum Löschen des Kontos in der Enphase-App angefordert. Nachfolgend finden Sie die Benutzerdaten",
    "requestReceived": "Wir haben Ihre Anfrage zur Aktivierung Ihres Enphase-Kontos erhalten. Klicken Sie dazu innerhalb von 7 Tagen nach Erhalt dieser E-Mail auf den unten stehenden Link.",
    "activate": "aktivieren Sie",
    "accActivate": "aktiviere deinen Account",
    "optdelaccount": "Ihr Bestätigungscode zum Löschen des Enphase-Kontos lautet %{otp}. Dieser Code ist 15 Minuten lang gültig.",
    "emailCheckInstruction": "Bitte überprüfen Sie Ihre E-Mail auf Anweisungen zur Aktivierung des Kontos."
  },
  "phase": {
    "all": "Dreiphasen Ansicht",
    "phaseL": "Phase L",
    "msgOffGrid": "Phasenbezogene Stromverbrauchsdaten sind nicht verfügbar, wenn sich Ihr System im Netzfern-Modus befindet."
  },
  "vls": {
    "vlsHeading": "Akku-Abschaltstufe",
    "shutdownLevelLine1": "Bei einem Stromausfall schaltet sich Ihr Akku beim Laden ab,",
    "shutdownLevelLine1-2": "um Energie zu sparen. Es startet wieder, indem es die eingesparte Energie verwendet, wenn das Versorgungsnetz wieder mit Strom versorgt wird oder Sonnenkollektoren mit der Energieerzeugung beginnen.",
    "shutdownLevelLine2": "Wählen Sie einen hohen Wert, wenn schlechtes Wetter die Solarproduktion beeinträchtigt.",
    "vlsWarning": "Akku-Abschaltlevel kann nicht mehr als Akku-Reserve (%{soc}%) sein",
    "stormVlsWarning": "Sturmalarm ist für Ihr System aktiviert. Sobald der Sturmalarm endet, wird die Akku-Reserve auf %{soc}% aktualisiert, da die Reserve nicht niedriger als das Abschaltniveau sein kann",
    "batteryReserveWarning": "Die Akku-Reserve kann nicht niedriger als der Akku-Abschaltpegel (%{horizontal}%) eingestellt werden. Bitte verringern Sie Ihren Akku-Abschaltpegel in den #erweiterten Einstellungen#, um die Akkureserve zu verringern.",
    "editRequest": "Sie haben eine aktive Anfrage. Bitte warten Sie auf die Bestätigung oder brechen Sie diese Anfrage ab, um mit der Auswahl fortzufahren."
  },
  "defaultLocale": {
    "popContent1": "Wählen Sie App-Sprache",
    "popContentBody1": "Möchten Sie mit ",
    "popContentBody2": " als App-Sprache fortfahren?",
    "button1": "Okay, weiter",
    "button2": "Wählen Sie eine andere Sprache",
    "button3": "Nein, zu ",
    "en": "Englisch",
    "de": "Deutsch",
    "es": "Spanisch",
    "fr": "Französisch",
    "it": "Italienisch",
    "nl": "Niederländisch",
    "pl": "Polieren",
    "pt": "Portugiesisch"
  },
  "woSolarWStorage": {
    "noArraysTitle": "Keine Arrays!",
    "noArraysDesc": "Sie haben keine Sonnenkollektoren installiert",
    "noAccessConsumptionData": "Sie haben keinen Zugriff auf Verbrauchsdaten für diese Website."
  },
  "drEventsActive": "NR-Ereignis: Aktiv",
  "pleaseGoTo": "Rufen Sie den ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": " auf, um Ihre Benachrichtigungseinstellungen zu aktualisieren.",
  "loadControl": {
    "enabled": "Aktiviert",
    "disabled": "Deaktiviert",
    "smartEnabled": "Smart-Steuerung aktiviert",
    "smartDisabled": "Smart-Steuerung deaktiviert",
    "offGridBehaviour": "Netzfern Verhalten",
    "modeDetails": "Details zum Smart-Steuerung-Modus",
    "newModeDetails": "Details zum Laststeuerungsmodus",
    "basicMode": "Basismodus",
    "cannotUse": "%{loadName} nicht verwendet werden​​",
    "genOnUSe": "%{loadName} verwendet werden wenn der Generator an ist",
    "genMode": "Generator Modus",
    "batteryMode": "Akku-Modus",
    "batteryModePercent": "%{loadName} verwendet werden, wenn die Akku-Ladung  %{lowerSoc}% oder mehr beträgt.​",
    "batteryModeSoc": "Wenn die Ladung unter %{lowerSoc}% fällt, %{loadName} erst verwendet werden, wenn der Akku zu %{upperSoc}% aufgeladen ist.",
    "loadControlHeading": "Steuern Sie die Stromversorgung Ihrer Lasten, wenn auf Netzfern.",
    "loadControlSubHeading": "Alle Lasten werden beim Einschalten mit Netzstrom versorgt",
    "powered": "Gespeist",
    "notPowered": "Nicht gespeist",
    "unknown": "Unbekannt",
    "waiting": "Wachten op informatie",
    "permissionOfIntstaller": "Sie haben keine Berechtigung, Einstellungen für diese Vorrichtung zu bearbeiten. Bitte wenden Sie sich an Ihren Installateur oder den Enphase-Kundesupport, um mehr darüber zu erfahren.",
    "willbePowered": "Ihre %{loadName} immer in diesem Zustand mit Strom versorgt.",
    "poweredOnOffGrid": "Ihre %{loadName} basierend auf dem ausgewählten Netzfernen Verhalten mit Strom versorgt.",
    "continueModal": "Wollen Sie fortfahren?",
    "infoDetails": "Wenn die intelligente Steuerung deaktiviert ist oder wenn Ihr System Netzverbunden ist, werden die Lasten immer mit Strom versorgt.",
    "newInfoDetails": "Steuern Sie die Leistung Ihrer Lasten basierend auf der Energieressource oder der Tageszeit. Sie können auch den manuellen Modus verwenden, wenn Sie die Stromversorgung Ihrer Lasten sofort steuern möchten.",
    "enableSmartComtrol": "Stellen Sie sicher, dass Ihre Netzschalter für diese Geräte eingeschaltet sind, um diese Funktionalität nutzen zu können.",
    "enableToggle": "Enable Smart-Steuerung?",
    "disableToggle": "Deaktivieren Smart-Steuerung?",
    "apply": "Anwenden",
    "modalPara1": "<div>Wenn die intelligente Steuerung <span style='color: #F37320'>aktiviert</span> ist, können Sie einen der drei Modi für das Netzferne Verhalten auswählen.</div>",
    "disabledModalText": "Die intelligente Steuerung ist für diese Last deaktiviert. Bitte aktivieren Sie die intelligente Steuerung mit der Umschalttaste, um das Off Grid-Verhalten zu aktualisieren update",
    "batteryChargeLowerLimit": "Die untere Grenze der Batterieladung kann nicht unter 10 % liegen.",
    "batteryChargeHigherLimit": "Untere Grenze der Akkuladung darf nicht über 90 % liegen",
    "loadControlLoadingToast": "Die Statusbestätigung von %{loadName} dauert länger als erwartet. Bitte schauen Sie später noch einmal vorbei.",
    "loadControlTakingLonger": "Die Bestätigung des Ladestatus dauert länger als erwartet. Bitte schauen Sie später noch einmal vorbei.",
    "batteryChargeLowerHigherLimit": "Akkuladeuntergrenze und Obergrenze sollten mindestens 5% auseinander liegen",
    "mode": "modus",
    "lcMainHeading": "Steuern Sie die Stromversorgung Ihrer Lasten",
    "basic": "einfach",
    "scheduled": "geplant",
    "advanced": "fortgeschritten",
    "manual": "manuell",
    "notSelected": "Nicht ausgewählt",
    "poweredWhen": "Wird mit Strom versorgt, wenn die Akkuladung oben ist",
    "poweredGenOn": "Wird mit Strom versorgt, wenn der Generator eingeschaltet ist",
    "poweredBetweenTime": "Eingeschaltet zwischen %{startTime} und %{endTime}",
    "onceDisconnected": "Nach dem Trennen von der Stromquelle wird die Last nicht mit Strom versorgt, es sei denn, der Akku wird auf 100%. aufgeladen.",
    "alwaysPowered": "Immer mit Strom versorgt",
    "neverPowered": "Nie mit Strom versorgt",
    "minDiff": "Startzeit und Endzeit sollten einen Mindestunterschied von 15 Minuten haben.",
    "startLessThanEnd": "Die Startzeit sollte kleiner als die Endzeit sein",
    "notValidTime": "Startzeit und Endzeit sollten zwischen %{startTime} und %{endTime} liegen.",
    "completed": "%{loadName}-Modus erfolgreich aktualisiert.",
    "notCompleted": "Ihre Anforderung konnte nicht vervollständigt werden. Bitte versuchen Sie es später erneut",
    "completedAll": "Loads updated successfully.",
    "emptyLoadControls": "Keine Laststeuerung gefunden",
    "allowedWarning": "Wenn Sie dieses Zeitfenster ändern, stellen Sie bitte sicher, dass Ihre Solarstromproduktion ausreicht, um Ihren Verbrauch während dieses Zeitfensters zu decken.",
    "advancedMode": {
      "subtitle": "Steuern Sie die Last mit:",
      "notPowered": "Mit Strom versorgt wenn die Last höher ist ",
      "batterySocDesc1": "Wird nicht mit Strom versorgt, wenn die Ladung darunter fällt ",
      "batterySocDesc2": "Wird erst nach dem Aufladen des Akkus mit Strom versorgt ",
      "batterySocDesc3": " (auch wenn der Generator eingeschaltet ist)",
      "notAvailable": "Nicht verfügbar",
      "onGridGenPowered": "Gespeist",
      "offGridGenPowered": "Wird mit Strom versorgt, wenn der Generator eingeschaltet ist"
    }
  },
  "app_info": {
    "update_available": "App-Update verfügbar",
    "already_updatec": "Ihre App hat die aktuelle",
    "update_now": "Jetzt aktualisieren",
    "latest_update": "Letztes Update",
    "update_history": "Update-Verlauf",
    "show_more": "Mehr anzeigen",
    "show_less": "Weniger anzeigen"
  },
  "s1": "Hilfe bei der Auswahl eines Profils",
  "s2": "Mehr über Batterieprofile erfahren",
  "s3": "Ich möchte mir ein Profil vorschlagen lassen",
  "s4": "Batterieladung ist höher als Reservewert",
  "s5": "Energieautarkie nach den Spitzenlastzeiten:",
  "s6": "Außerhalb von Spitzenzeiten laden Ihre Solarmodule Ihre Batterie auf, bevor Sie Ihr Zuhause mit Strom versorgen. Überschüssiger Solarstrom wird zurück ins Netz eingespeist, um Ihre Stromrechnung zu senken.",
  "s7": "Wenn Ihr Heim mehr Strom benötigt als von Ihren Solarmodulen erzeugt werden kann, wird Strom aus dem Netz bezogen.",
  "s8": "Systemverhalten während Spitzenzeiten",
  "s9": "Ihre Stromrechnung senken",
  "s10": "In manchen Regionen ändert sich der Strompreis im Laufe des Tages und ist dabei während Spitzenzeiten, also wenn hohe Nachfrage nach Strom besteht, am teuersten.",
  "s11": "Der Bezug von Strom zu diesem erhöhten Preis kann vermieden werden, indem zu diesen Zeiten die Batterie genutzt wird. Wenn Sie zu Hause mehr Strom benötigen, als die Batterie abgibt, wird als nächstes Solarstrom verwendet und dann schließlich das Netz. Überschüssige Solarenergie wird in das Netz eingespeist.",
  "s12": "Nachts, wenn die Solarmodule keinen Strom erzeugen, wird für Ihr Zuhause der Strom aus der Batterie verwendet, bis diese den Reserveladezustand erreicht hat.",
  "s13": "Elektrizität wird aus dem Netz importiert, wenn kein Solarstrom zur Verfügung steht und bei Ihnen zu Hause mehr Strom benötigt wird, als die Batterie abgibt.",
  "s14": "Ihr Zuhause mit sauberer Energie versorgen",
  "s15": "Für Ihr Zuhause wird saubere Energie priorisiert. Tagsüber wird der Solarstrom für den Stromverbrauch zu Hause und dann für die Batterie verwendet. Überschüssige Energie wird in das Netz eingespeist. Nachts wird der Stromverbrauch zu Hause durch die Batterie gedeckt.",
  "s16": "Elektrizität wird aus dem Netz importiert, wenn bei Ihnen zu Hause mehr Strom benötigt wird, als die Solaranlage und die Batterie zusammengenommen abgeben.",
  "s17": "Batterie ist voll aufgeladen",
  "s18": "Systemverhalten außerhalb von Spitzenzeiten",
  "s19": "Ihre Solarmodule versorgen zuerst Ihre Batterie mit Strom, dann Ihr Zuhause. Überschüssiger Strom wird ins Netz eingespeist.",
  "s20": "Nachts oder wenn Ihr Heim mehr Strom benötigt als von Ihren Solarmodulen erzeugt werden kann, wird Strom aus dem Netz bezogen. Ihre Batterie wird nur im Falle eines Stromausfalls angezapft.",
  "s21": "Tippen Sie auf ein Profil, um dessen Seiten aufzurufen.",
  "s22": "Wischen Sie nach links oder rechts, um mehr zu lesen.",
  "s23": "Ihre Batterien werden auch außerhalb der Spitzenzeiten entladen.",
  "s24": "Elektrizität wird aus dem Netz importiert, wenn kein Solarstrom zur Verfügung steht und bei Ihnen zu Hause mehr Strom benötigt wird, als die Batterie abgibt.",
  "s25": "Systemverhalten außerhalb von Spitzenzeiten",
  "s26": "Während Ausfällen mit Strom versorgt bleiben",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "Dies ist die geschätzte Höhe der Kosteneinsparungen, die Ihnen Ihr System basierend auf der Solarstromerzeugung einbringt. Dieser Wert wird basierend auf den eingegebenen Details zu Ihrem Energietarif berechnet.",
      "noTeriffMsg": "Fügen Sie den Stromtarif hinzu, um Ihre Einsparungen zu erfahren",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Erste Schritte",
      "billingCycle": {
        "more": "Mehr als zu diesem Zeitpunkt im letzten Abrechnungszyklus",
        "less": "Weniger als zu diesem Zeitpunkt im letzten Abrechnungszyklus",
        "same": "Etwa gleich viel wie zu diesem Zeitpunkt im letzten Abrechnungszyklus"
      },
      "calendarMonth": {
        "more": "mehr als um diese Zeit im Vormonat",
        "less": "weniger als um diese Zeit im Vormonat",
        "same": "Ungefähr dasselbe wie um diese Zeit im Vormonat"
      },
      "day": {
        "more": "mehr als um diese Zeit am Vortag",
        "less": "weniger als um diese Zeit am Vortag",
        "same": "Ungefähr dieselbe Zeit wie am Vortag um diese Zeit",
        "significantMore": "Deutlich höher als am Vortag"
      },
      "week": {
        "more": "mehr als um diese Zeit Vorwoche",
        "less": "weniger als um diese Zeit Vorwoche",
        "same": "Ungefähr dasselbe wie letzte Woche um diese Zeit"
      },
      "year": {
        "more": "mehr als um diese Zeit im Vorjahr",
        "less": "weniger als zu diesem Zeitpunkt im letzten Jahr",
        "same": "Ungefähr so "
      },
      "editElectricity": "ENERGIETARIF BEARBEITEN",
      "viewSavingsBased": "Einsparungen anzeigen basierend auf",
      "calendarMonthTitle": "Kalendermonat",
      "calendarMonthDesc": "Zeitraum vom ersten Tag (1.) des Monats bis zum letzten Tag des Monats",
      "noExportRate": "Fügen Sie %{exportCTA} hinzu, um Ihre Gesamteinsparungen anzuzeigen",
      "exportRate": "Exportrate"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "Lokale Verbindung nicht möglich",
    "limitedAppFunctionality": "Eingeschränkte App-Funktionalität",
    "needHelpGatewayWifi": "Benötigen Sie Hilfe bei der Konfiguration der Gateway-Wi-Fi-Konnektivität",
    "howToConnectGatewayNetwork": "So stellen Sie eine Verbindung zum Gateway-Netzwerk her",
    "connectGatewayToWifi": "Verbinden Sie das Gateway mit dem Wi-Fi-Netzwerk",
    "connectLocally": "LOKAL VERBINDEN",
    "checkNetworkConnection": "Bitte überprüfen Sie Ihre Netzwerkverbindung.",
    "noInternetModalSubText1": "Bitte überprüfen Sie Ihre Netzwerkverbindung. In der Zwischenzeit können Sie den aktuellen Status des Systems einsehen.",
    "noInternetModalSubText2": "Bitte überprüfen Sie Ihre Netzwerkverbindung. Wenn Sie sich in der Nähe Ihres Systems befinden, können Sie sich in der Zwischenzeit lokal mit Gateway verbinden, um den aktuellen Status anzuzeigen.",
    "refereshing": "Wird aktualisiert",
    "pullToReferesh": "Ziehen zum Aktualisieren ",
    "connectionStatus": "Ihr Telefon ist jetzt lokal mit dem Gateway-Netzwerk verbunden.",
    "connectivityErrorMsg1": "Bitte stellen Sie sicher, dass sich Ihr Telefon und Gateway im selben Netzwerk befinden",
    "connectivityErrorMsg2": 'Das Gateway wurde kürzlich mit dem Netzwerk %{wifiName} verbunden',
    "connectivityErrorMsg3": "Alternativ können Sie Ihr Telefon mit dem WLAN des Gateways verbinden, indem Sie den AP-Modus auf Ihrem Gateway aktivieren",
    "connecting": "Ihr Telefon versucht, sich lokal mit dem Gateway zu verbinden, um den Live-Status anzuzeigen.",
    "viewLiveStatus": "Live-Status anzeigen",
    "pleaseTryAgainInSomeTime": "Bitte versuchen Sie es später erneut.",
    "connectedLocally": "Lokal verbunden",
    "ssidNotMatchedError": "Sie haben Ihr Mobiltelefon nicht mit dem richtigen Gateway-Netzwerk verbunden. Bitte verbinden Sie Ihr Mobiltelefon mit diesem Gateway-Netzwerk: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Gateway-Netzwerke für diesen Standort",
      "message": "Bitte verbinden Sie Ihr Handy nur mit dem Netz eines der Gateways dieses Standorts. Im Folgenden sind die Gateway-Netzwerke für diesen Standort aufgeführt:",
      "buttonText": "Okay, verstanden!"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "Sie haben Ihr Mobiltelefon nicht mit dem richtigen Gateway-Netzwerk verbunden. Bitte verbinden Sie Ihr Handy nur mit dem Netz eines der Gateways dieses Standorts.",
    "configureButtonMultiEnvoyMsg": "Sie haben Ihr Mobiltelefon nicht mit dem richtigen Gateway-Netzwerk verbunden. Bitte verbinden Sie Ihr Handy nur mit dem Netz eines der Gateways dieses Standorts. Im Folgenden sind die Gateway-Netzwerke für diesen Standort aufgeführt:",
    "listOfGatewayNetworks": "Liste der Gateway-Netzwerke für diesen Standort",
    "configureWifiMultiEnvoyMsg": "Um Wi-Fi für das Gateway (Seriennummer: XXXX) zu konfigurieren, verbinden Sie Ihr Mobiltelefon mit dem AP-Modus dieses Gateways. Sie sind derzeit mit dem AP-Modus des Gateways verbunden (Seriennummer:XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "So stellen Sie eine Verbindung zum WLAN von Gateway her",
      "okGotIt": "Okay, verstanden",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "",
      "subText1": "Verbinden Sie sich lokal mit dem Gateway-Netzwerk, wenn Sie Ihre Systemeinstellungen ändern möchten.",
      "subText2": 'Stellen Sie sicher, dass sich Ihr Telefon und Gateway im selben Netzwerk befinden %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(das Gateway wurde k\xFCrzlich mit dem Netzwerk \"%{lastConnection}\" verbunden)",
      "subText3": "Alternativ können Sie Ihr Mobiltelefon mit dem WLAN von Gateways verbinden, indem Sie den AP-Modus auf Ihrem Gateway aktivieren",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Kürzliche WLAN-Verbindungen von Gateways",
      "gatewayPrefix": "Gateway-SN",
      "gatewayBtn": "Gateway WLAN-Netzwerke für diesen Standort",
      "alternetively": "Alternativ können Sie Ihr Telefon mit einem beliebigen Netzwerk des Gateways verbinden, indem Sie den AP-Modus auf Ihrem Gateway aktivieren."
    },
    "isTouPopupMsg": "Der Sparmodus kann nicht aktiviert werden, da er nur funktioniert, wenn Sie über Netto-Messung (NEM) verfügen und Ihr Stromtarif je nach Nutzungsdauer (ToU) variiert. Das Einstellen oder Aktualisieren des Stromtarifs ist nur möglich, wenn Ihr Telefon mit dem Internet verbunden ist.",
    "configWifiToGateway": "WI-FI FÜR IHR GATEWAY KONFIGURIEREN",
    "phoneNtConnectedToGateway": "Ihr Telefon ist nicht mit dem Gateway verbunden",
    "chooseWifiNetwork": "Wählen Sie ein Wi-Fi-Netzwerk, das Sie mit Ihrem Gateway verwenden möchten.",
    "learnWifiConfigToGatway": "Erfahren Sie, wie Sie Wi-Fi für Ihr Gateway konfigurieren",
    "step": "Schritt",
    "connectPhoneToGateway": "Verbinden Sie Ihr Telefon mit dem Gateway",
    "connectToGatewayNetwork": "Stellen Sie eine Verbindung zum Netzwerk des Gateways her, um Wi-Fi für Ihr Gateway zu konfigurieren",
    "gatewayNtReachable": "Ihr Gateway ist nicht erreichbar",
    "pleaseEnsure": "Bitte stelle sicher:",
    "gatewayAPModeOn": "Der AP-Modus des Gateways ist eingeschaltet",
    "phoneInCloseProximity": "Das Telefon befindet sich in unmittelbarer Nähe des Gateways",
    "mobileDataOff": "Mobile Daten (mobile Daten) sind deaktiviert",
    "searchingGateway": "Suche nach Gateway-Netzwerk…",
    "devicePluggedIn": "Stellen Sie sicher, dass sich Ihr Gerät in der Nähe befindet, angeschlossen und der AP-Modus aktiviert ist",
    "connectingTo": "Verbinden mit",
    "reflectedInApp": "Es kann einige Minuten dauern, bis dies in der App angezeigt wird",
    "connectionFailed": "Verbindung zum Gateway-Netzwerk konnte nicht hergestellt werden",
    "connectedToGateway": "Das Telefon ist mit dem Gateway verbunden"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Gateway mit Wi-Fi verbinden"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Wählen Sie ein WLAN-Netzwerk aus, mit dem Sie Ihr Gateway verbinden möchten."), _defineProperty(_offline, "scanNetwork", "WLAN-Netzwerk scannen"), _defineProperty(_offline, "enterPassword", "Geben Sie das Passwort für ein"), _defineProperty(_offline, "join", "Verbinden"), _defineProperty(_offline, "gatewayConnected", "Gateway ist erfolgreich mit %{selectedWifi} verbunden"), _defineProperty(_offline, "disconnectPhoneFromGateway", "Sie können Ihr Telefon jetzt von Ihrem Gateway-Netzwerk trennen und es mit Ihrem WLAN verbinden/Ihre mobilen Daten aktivieren"), _defineProperty(_offline, "failedToConnect", "„%{network_name}“ konnte nicht verbunden werden"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "Bitte stellen Sie sicher, dass Ihr Gateway an eine Stromquelle angeschlossen ist und Sie sich in unmittelbarer Nähe Ihres Gateways befinden."), _defineProperty(_offline, "routerIsOn", "Stellen Sie sicher, dass Ihr WLAN-Router eingeschaltet ist und Sie sich in unmittelbarer Nähe Ihres WLAN-Routers befinden"), _defineProperty(_offline, "unableToDisplayNetworks", "Wi-Fi-Netzwerke können nicht angezeigt werden"), _defineProperty(_offline, "errorDisplayingNetworks", "Aufgrund einiger technischer Probleme ist ein Fehler bei der Anzeige von WLAN-Netzwerken aufgetreten. Bitte versuche es erneut."), _defineProperty(_offline, "errorInConnectingToWifi", "Beim Verbinden mit dem WLAN-Netzwerk ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder stellen Sie eine Verbindung zu einem anderen Netzwerk her."), _defineProperty(_offline, "unableToConnect", "Verbindung konnte nicht hergestellt werden"), _defineProperty(_offline, "pairGateway", "Koppeln Sie das Gateway über Bluetooth mit Ihrem Telefon."), _offline),
  "tutorial": {
    "back": "Der Rücken",
    "apMode": "So aktivieren Sie den AP-Modus",
    "step1": "Schritt 1 von 3",
    "step2": "Schritt 2 von 3",
    "step3": "Schritt 3 von 3",
    "powerOnGateway": "Gateway einschalten",
    "title2": "Drücken Sie die AP-Modus-Taste",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Get started",
    "next": "Nächster Schritt",
    "prev": "Vorheriger Schritt",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "Das ist es!",
    "step1of2": "Schritt 1 von 2",
    "step2of2": "Schritt 2 von 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Versuchen wir, das Gateway mit Ihrem Telefon zu verbinden. Stellen Sie sicher, dass Sie sich in der Nähe Ihres Gateways befinden und Ihre mobilen Daten ausgeschaltet sind"
  }
};
module.exports = mobile;